/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9565:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var sprintf_js_1 = __webpack_require__(8975);
var Angle = /** @class */ (function () {
    function Angle(rad) {
        this.rad = rad;
    }
    Object.defineProperty(Angle.prototype, "deg", {
        get: function () { return rad2deg(this.rad); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Angle.prototype, "amin", {
        get: function () { return rad2amin(this.rad); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Angle.prototype, "asec", {
        get: function () { return rad2asec(this.rad); },
        enumerable: true,
        configurable: true
    });
    Angle.fromRad = function (rad) { return new Angle(rad); };
    Angle.fromDeg = function (deg) { return new Angle(deg2rad(deg)); };
    Angle.fromAmin = function (amin) { return new Angle(amin2rad(amin)); };
    Angle.fromAsec = function (asec) { return new Angle(asec2rad(asec)); };
    Angle.prototype.sexadecimal = function (hour2deg, showSign) {
        var totalSeconds = 3600 * this.deg / hour2deg;
        var sign = showSign ? (totalSeconds < 0 ? '-' : '+') : '';
        var s = Math.abs(totalSeconds);
        return sprintf_js_1.sprintf(sign + "%02d:%02d:%07.4f", Math.floor(s / 3600), Math.floor(s / 60 % 60), s % 60);
    };
    Angle.prototype.clone = function () {
        return new Angle(this.rad);
    };
    return Angle;
}());
exports.Angle = Angle;
var EquatorialCoord = /** @class */ (function () {
    function EquatorialCoord(a, d) {
        this.a = a;
        this.d = d;
    }
    EquatorialCoord.parse = function (s) {
        var _a = parseEquatorialCoord(s), a = _a.a, d = _a.d;
        return new EquatorialCoord(a, d);
    };
    Object.defineProperty(EquatorialCoord.prototype, "xyz", {
        get: function () {
            var a = this.a.rad;
            var d = this.d.rad;
            var cosd = Math.cos(d);
            return [
                cosd * Math.cos(a),
                cosd * Math.sin(a),
                Math.sin(d)
            ];
        },
        enumerable: true,
        configurable: true
    });
    EquatorialCoord.fromXyz = function (_a) {
        var x = _a[0], y = _a[1], z = _a[2];
        var r2 = x * x + y * y;
        if (r2 == 0) {
            return EquatorialCoord.fromRad(0, z > 0 ? Math.PI / 2 : -Math.PI / 2);
        }
        else {
            var PI2_1 = 2 * Math.PI;
            var a = (Math.atan2(y, x) + PI2_1) % PI2_1;
            var d = Math.atan2(z, Math.sqrt(r2));
            return EquatorialCoord.fromRad(a, d);
        }
    };
    EquatorialCoord.fromRad = function (a, d) {
        return new EquatorialCoord(Angle.fromRad(a), Angle.fromRad(d));
    };
    EquatorialCoord.fromDeg = function (a, d) {
        return new EquatorialCoord(Angle.fromDeg(a), Angle.fromDeg(d));
    };
    EquatorialCoord.prototype.toString = function () {
        return {
            a: this.a.sexadecimal(15, false),
            d: this.d.sexadecimal(1, true),
        };
    };
    EquatorialCoord.prototype.clone = function () {
        return new EquatorialCoord(this.a.clone(), this.d.clone());
    };
    return EquatorialCoord;
}());
exports.EquatorialCoord = EquatorialCoord;
function deg2rad(deg) {
    // return deg / 180 * Math.PI
    return 0.01745329252 * deg;
}
exports.deg2rad = deg2rad;
function amin2rad(amin) {
    // return arcmin / (60 * 180) * Math.PI
    return 0.0002908882087 * amin;
}
exports.amin2rad = amin2rad;
function asec2rad(asec) {
    // return arcsec / (3600 * 180) * Math.PI
    return 0.000004848136811 * asec;
}
exports.asec2rad = asec2rad;
function rad2deg(rad) {
    // return rad / Math.PI * 180
    return 57.2957795131 * rad;
}
exports.rad2deg = rad2deg;
function rad2amin(rad) {
    // return rad / Math.PI * 180 * 60
    return 3437.7467707849 * rad;
}
exports.rad2amin = rad2amin;
function rad2asec(rad) {
    // return rad / Math.PI * 180 * 3600
    return 206264.806247096 * rad;
}
exports.rad2asec = rad2asec;
var PI2 = 2 * Math.PI;
function wrapTo2Pi(x) {
    if (x < 0)
        return PI2 - (-x % (PI2));
    else
        return x % PI2;
}
exports.wrapTo2Pi = wrapTo2Pi;
var NUMBER = /[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/g;
function parseEquatorialCoord(s) {
    s = s.replace(/−/g, '-');
    s = s.replace(/([\+\-])\s+(\d)/, '$1$2').replace(/\[\d+\]/g, '');
    var numbers = s.match(NUMBER);
    if (numbers == null || numbers.length < 2) {
        throw new Error("invalid coord format: '" + s + "': numbers=" + JSON.stringify(numbers));
    }
    if (numbers.length == 2) {
        return EquatorialCoord.fromDeg(Number(numbers[0]), Number(numbers[1]));
    }
    return new EquatorialCoord(parseSexadecimal(numbers.slice(0, Math.floor(numbers.length / 2)), 15), parseSexadecimal(numbers.slice(Math.floor(numbers.length / 2)), 1));
}
function parseSexadecimal(numbers, hour2deg) {
    if (numbers.length == 0 || numbers.length > 3) {
        throw new Error("invalid coord format: '" + numbers.join(', ') + "'");
    }
    var hs = numbers[0];
    var m = numbers[1] != undefined ? Number(numbers[1]) : 0;
    var s = numbers[2] != undefined ? Number(numbers[2]) : 0;
    if (hs.substr(0, 1) == '-') {
        return Angle.fromDeg(-hour2deg * (s / 3600 + m / 60 + Number(hs.substr(1))));
    }
    else {
        return Angle.fromDeg(hour2deg * (s / 3600 + m / 60 + Number(hs)));
    }
}


/***/ }),

/***/ 1796:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var CacheMap = /** @class */ (function () {
    function CacheMap(limit, onDrop) {
        this.limit = limit;
        this.onDrop = onDrop;
        this.seq = 0;
        this.count = 0;
        this.persistCount = 0;
        this.oldestNum = 0;
        this.byKey = new Map();
        this.byNum = new Map();
    }
    CacheMap.prototype.set = function (k, v, persist) {
        if (persist === void 0) { persist = false; }
        var originlPack = this.byKey.get(k);
        if (originlPack) {
            if (this.onDrop && originlPack.v == v) {
                console.info("CacheMap[" + k + "] is assigned twice to same value. This may cause unexpected onDrop callback.");
            }
            this.deleteByPack(originlPack);
        }
        var newPack = { k: k, v: v, num: this.seq++, persist: persist };
        this.byKey.set(k, newPack);
        this.byNum.set(newPack.num, newPack);
        this.count++;
        persist && this.persistCount++;
        this.deleteOldItems();
    };
    CacheMap.prototype.peek = function (k) {
        var p = this.byKey.get(k);
        return p ? p.v : undefined;
    };
    CacheMap.prototype.get = function (k) {
        var pack = this.byKey.get(k);
        if (pack) {
            this.byNum.get(pack.num);
            this.byNum.delete(pack.num);
            this.byNum.set(pack.num = this.seq++, pack);
            return pack.v;
        }
    };
    CacheMap.prototype.keys = function () {
        var keys = [];
        this.byNum.forEach(function (pack) { return keys.push(pack.k); });
        return keys;
    };
    CacheMap.prototype.clear = function () {
        var packs = [];
        this.byNum.forEach(function (pack) { return packs.push(pack); });
        for (var _i = 0, packs_1 = packs; _i < packs_1.length; _i++) {
            var pack = packs_1[_i];
            this.deleteByPack(pack);
        }
    };
    CacheMap.prototype.delete = function (k) {
        var pack = this.byKey.get(k);
        if (pack) {
            this.deleteByPack(pack);
            return true;
        }
        return false;
    };
    CacheMap.prototype.setLimit = function (limit) {
        this.limit = limit;
        this.deleteOldItems();
    };
    CacheMap.prototype.deleteOldItems = function () {
        var totalLimit = this.limit + this.persistCount;
        while (this.count > totalLimit) {
            var pack = this.byNum.get(this.oldestNum++);
            pack && !pack.persist && this.deleteByPack(pack);
        }
    };
    CacheMap.prototype.deleteByPack = function (pack) {
        this.byKey.delete(pack.k);
        this.byNum.delete(pack.num);
        this.onDrop && this.onDrop(pack.v, pack.k);
        this.count--;
        pack.persist && this.persistCount--;
    };
    Object.defineProperty(CacheMap.prototype, "size", {
        get: function () {
            return this.byNum.size;
        },
        enumerable: true,
        configurable: true
    });
    return CacheMap;
}());
exports.CacheMap = CacheMap;


/***/ }),

/***/ 16:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function linear(x) {
    return x;
}
exports.linear = linear;
function slowStart2(x) {
    return x * x;
}
exports.slowStart2 = slowStart2;
function fastStart2(x) {
    x = 1 - x;
    return 1 - x * x;
}
exports.fastStart2 = fastStart2;
function slowStart4(x) {
    var y = x * x;
    return y * y;
}
exports.slowStart4 = slowStart4;
function fastStart4(x) {
    x = 1 - x;
    var y = x * x;
    return 1 - y * y;
}
exports.fastStart4 = fastStart4;
function slowStartStop2(x) {
    var x2 = 1 - x;
    return x < 0.5 ? 2 * x * x : -2 * x2 * x2 + 1;
}
exports.slowStartStop2 = slowStartStop2;
function slowStartStop4(x) {
    var y = x * x;
    var x2 = 1 - x;
    var y2 = x2 * x2;
    return x < 0.5 ? 8 * y * y : -8 * y2 * y2 + 1;
}
exports.slowStartStop4 = slowStartStop4;


/***/ }),

/***/ 3749:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var glUtils = __webpack_require__(8223);
var AttribList = /** @class */ (function () {
    function AttribList(gl, data) {
        this.gl = gl;
        this.usage = -1;
        this.bufferSize = -1;
        this.vertexCount = 0;
        this.bufferName = glUtils.nonNull(gl.createBuffer());
        if (data) {
            this.setData(data);
        }
    }
    AttribList.prototype.release = function () {
        this.gl.deleteBuffer(this.bufferName);
    };
    AttribList.prototype.setData = function (_a) {
        var members = _a.members, array = _a.array, _b = _a.usage, usage = _b === void 0 ? this.gl.STATIC_DRAW : _b;
        if (members) {
            this.members = members;
            this.stride = 0;
            this.offset = [];
            for (var _i = 0, members_1 = members; _i < members_1.length; _i++) {
                var m = members_1[_i];
                if (m.dataType == undefined)
                    m.dataType = this.gl.FLOAT;
                if (m.normalize == undefined)
                    m.normalize = false;
                this.offset.push(this.stride);
                this.stride += m.nComponents * sizeof(this.gl, m.dataType);
            }
        }
        if (array) {
            this.vertexCount = byteLength(array) / this.stride;
            this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.bufferName);
            if (usage != this.usage || this.bufferSize < this.vertexCount) {
                this.usage = usage;
                this.bufferSize = this.vertexCount;
                this.gl.bufferData(this.gl.ARRAY_BUFFER, array, usage);
            }
            else {
                this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, array);
            }
            this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null);
            if (this.vertexCount % 1 !== 0) {
                throw "nComponents may be invalid";
            }
        }
    };
    AttribList.prototype.enable = function (program, f) {
        var gl = this.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.bufferName);
        for (var i in this.members) {
            var m = this.members[i];
            gl.enableVertexAttribArray(program.attribLocation(m.name));
            gl.vertexAttribPointer(program.attribLocation(m.name), m.nComponents, m.dataType, m.normalize, this.stride, this.offset[i]);
        }
        f();
        for (var _i = 0, _a = this.members; _i < _a.length; _i++) {
            var m = _a[_i];
            gl.disableVertexAttribArray(program.attribLocation(m.name));
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
    };
    return AttribList;
}());
exports.AttribList = AttribList;
function sizeof(gl, dataType) {
    switch (dataType) {
        case gl.FLOAT:
            return 4;
        default:
            throw "unknown type: " + dataType;
    }
}
function byteLength(array) {
    return array.length * array.BYTES_PER_ELEMENT;
}


/***/ }),

/***/ 3101:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var CanvasPool = /** @class */ (function () {
    function CanvasPool() {
        this.pool = [];
    }
    CanvasPool.prototype.pull = function () {
        if (this.pool.length == 0) {
            var canvas = document.createElement('canvas');
            canvas.style.backgroundColor = '#007';
            this.pool.push(canvas);
        }
        return this.pool.shift();
    };
    CanvasPool.prototype.push = function (canvas) {
        this.pool.unshift(canvas);
    };
    return CanvasPool;
}());
var pools = new Map();
var canvas2pool = new Map();
function opt2key(opt) {
    return JSON.stringify(Object.keys(opt).sort().map(function (k) { return [k, opt[k]]; }));
}
function pull(opt) {
    var key = opt2key(opt);
    if (!pools.has(key))
        pools.set(key, new CanvasPool());
    var pool = pools.get(key);
    var canvas = pool.pull();
    var gl = canvas.getContext('webgl', opt) || canvas.getContext('experimental-webgl');
    if (gl == null)
        throw new Error("gl == null");
    canvas2pool.set(canvas, pool);
    return { canvas: canvas, gl: gl };
}
exports.pull = pull;
function push(canvas) {
    canvas2pool.get(canvas).push(canvas);
}
exports.push = push;


/***/ }),

/***/ 3898:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var canvasPool = __webpack_require__(3101);
exports.canvasPool = canvasPool;
var utils = __webpack_require__(8223);
exports.utils = utils;
var program_1 = __webpack_require__(8615);
exports.Program = program_1.Program;
var attrib_list_1 = __webpack_require__(3749);
exports.AttribList = attrib_list_1.AttribList;
var index_buffer_1 = __webpack_require__(7960);
exports.IndexBuffer = index_buffer_1.IndexBuffer;
var texture_1 = __webpack_require__(4569);
exports.Texture = texture_1.Texture;


/***/ }),

/***/ 7960:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var glUtils = __webpack_require__(8223);
var IndexBuffer = /** @class */ (function () {
    function IndexBuffer(gl, dataOption) {
        this.gl = gl;
        this.name = glUtils.nonNull(this.gl.createBuffer());
        if (dataOption)
            this.setData(dataOption);
    }
    IndexBuffer.prototype.release = function () {
        this.gl.deleteBuffer(this.name);
    };
    IndexBuffer.prototype.bind = function (cb) {
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name);
        cb();
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
    };
    IndexBuffer.prototype.setData = function (_a) {
        var usage = _a.usage, array = _a.array;
        this.usage = usage || this.gl.STATIC_DRAW;
        this._length = array.length;
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.name);
        this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, array, this.usage);
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, null);
    };
    Object.defineProperty(IndexBuffer.prototype, "length", {
        get: function () {
            return this._length;
        },
        enumerable: true,
        configurable: true
    });
    return IndexBuffer;
}());
exports.IndexBuffer = IndexBuffer;


/***/ }),

/***/ 8615:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var glUtils = __webpack_require__(8223);
var tuple_map_1 = __webpack_require__(1519);
var Program = /** @class */ (function () {
    function Program(gl, vertSource, fragSource) {
        this.gl = gl;
        this.vertSource = vertSource;
        this.fragSource = fragSource;
        this.attribLocationMemo = new Map();
        this.uniformLocationMemo = new Map();
        this.refCount = 1;
        this.vertShader = this.createShader(vertSource, this.gl.VERTEX_SHADER);
        this.fragShader = this.createShader(fragSource, this.gl.FRAGMENT_SHADER);
        this.name = glUtils.nonNull(this.gl.createProgram());
        this.gl.attachShader(this.name, this.vertShader);
        this.gl.attachShader(this.name, this.fragShader);
        this.gl.linkProgram(this.name);
        if (!this.gl.getProgramParameter(this.name, this.gl.LINK_STATUS)) {
            throw "WebGL link error: " + this.gl.getProgramInfoLog(this.name);
        }
    }
    Program.prototype.retain = function () {
        ++this.refCount;
        return this;
    };
    Program.new = function (gl, vertSource, fragSource) {
        var cachedProgram = Program.cache.get([gl, vertSource, fragSource]);
        if (cachedProgram) {
            return cachedProgram.retain();
        }
        else {
            var program = new Program(gl, vertSource, fragSource);
            this.cache.set([gl, vertSource, fragSource], program);
            return program;
        }
    };
    Program.prototype.release = function () {
        if (--this.refCount == 0) {
            this.gl.deleteShader(this.fragShader);
            this.gl.deleteShader(this.vertShader);
            this.gl.deleteProgram(this.name);
            Program.cache.delete([this.gl, this.vertSource, this.fragSource]);
        }
    };
    Program.prototype.use = function () {
        this.gl.useProgram(this.name);
    };
    Program.prototype.attribLocation = function (varName) {
        var location = this.attribLocationMemo.get(varName);
        if (location == undefined)
            location = this.gl.getAttribLocation(this.name, varName);
        if (location == -1)
            throw "unknown attribute: " + varName;
        this.attribLocationMemo.set(varName, location);
        return location;
    };
    Program.prototype.uniformLocation = function (varName) {
        var location = this.uniformLocationMemo.get(varName);
        if (location == undefined)
            location = this.gl.getUniformLocation(this.name, varName);
        if (location == null)
            throw "unknown uniform: " + varName;
        this.uniformLocationMemo.set(varName, location);
        return location;
    };
    Program.prototype.enableAttribList = function (attribList, cb) {
        this.use();
        attribList.enable(this, cb);
    };
    Program.prototype.uniformMatrix4fv = function (matrices, transpose) {
        if (transpose === void 0) { transpose = false; }
        for (var name_1 in matrices) {
            var matrix = matrices[name_1];
            this.gl.uniformMatrix4fv(this.uniformLocation(name_1), transpose, matrix);
        }
    };
    Program.prototype.uniformMatrix3fv = function (matrices, transpose) {
        if (transpose === void 0) { transpose = false; }
        for (var name_2 in matrices) {
            var matrix = matrices[name_2];
            this.gl.uniformMatrix3fv(this.uniformLocation(name_2), transpose, matrix);
        }
    };
    Program.prototype.uniformMatrix2fv = function (matrices, transpose) {
        if (transpose === void 0) { transpose = false; }
        for (var name_3 in matrices) {
            var matrix = matrices[name_3];
            this.gl.uniformMatrix2fv(this.uniformLocation(name_3), transpose, matrix);
        }
    };
    Program.prototype.uniform1f = function (vars) {
        for (var name_4 in vars) {
            this.gl.uniform1f(this.uniformLocation(name_4), vars[name_4]);
        }
    };
    Program.prototype.uniform1i = function (vars) {
        for (var name_5 in vars) {
            this.gl.uniform1i(this.uniformLocation(name_5), vars[name_5]);
        }
    };
    Program.prototype.uniform2fv = function (vars) {
        for (var name_6 in vars) {
            this.gl.uniform2fv(this.uniformLocation(name_6), vars[name_6]);
        }
    };
    Program.prototype.uniform3fv = function (vars) {
        for (var name_7 in vars) {
            this.gl.uniform3fv(this.uniformLocation(name_7), vars[name_7]);
        }
    };
    Program.prototype.uniform4fv = function (vars) {
        for (var name_8 in vars) {
            this.gl.uniform4fv(this.uniformLocation(name_8), vars[name_8]);
        }
    };
    Program.prototype.createShader = function (source, type) {
        var shader = this.gl.createShader(type);
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
            throw "WebGL shader compile error: " + this.gl.getShaderInfoLog(shader) + "\nsource:\n" + glUtils.addLineNumber(source);
        }
        return glUtils.nonNull(shader);
    };
    Program.cache = new tuple_map_1.TupleMap();
    return Program;
}());
exports.Program = Program;


/***/ }),

/***/ 4569:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var glUtils = __webpack_require__(8223);
var Texture = /** @class */ (function () {
    function Texture(gl, parameterSetter) {
        var _this = this;
        this.gl = gl;
        this.name = glUtils.nonNull(gl.createTexture());
        this.bind(function () { return (parameterSetter || defaultParameterSetter)(_this.gl); });
    }
    Texture.prototype.release = function () {
        this.gl.deleteTexture(this.name);
    };
    Texture.prototype.bind = function (cb) {
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.name);
        cb();
        this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    };
    Texture.prototype.setImage = function (img) {
        var _this = this;
        this.bind(function () {
            _this.gl.texImage2D(_this.gl.TEXTURE_2D, 0, _this.gl.RGBA, _this.gl.RGBA, _this.gl.UNSIGNED_BYTE, img);
        });
    };
    return Texture;
}());
exports.Texture = Texture;
function defaultParameterSetter(gl) {
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
}


/***/ }),

/***/ 8223:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var sprintf_js_1 = __webpack_require__(8975);
function enable(gl, fs, callback) {
    for (var _i = 0, fs_1 = fs; _i < fs_1.length; _i++) {
        var f = fs_1[_i];
        gl.enable(f);
    }
    callback();
    for (var _a = 0, fs_2 = fs; _a < fs_2.length; _a++) {
        var f = fs_2[_a];
        gl.disable(f);
    }
}
exports.enable = enable;
function addLineNumber(body) {
    return body.split("\n")
        .map(function (line, n) { return sprintf_js_1.sprintf('%4d | %s', n + 1, line); })
        .join("\n");
}
exports.addLineNumber = addLineNumber;
function nonNull(v) {
    if (!v)
        throw new Error("non-null check error: " + v);
    return v;
}
exports.nonNull = nonNull;


/***/ }),

/***/ 5866:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

/**
 * # API Reference
 *
 * This package based on this paper: [Gorski (2005)](http://iopscience.iop.org/article/10.1086/427976/pdf).
 *
 * The key things to understand the implementation are:
 * - Spherical coordinates in different representations such as `(alpha, delta)`
 *   or `(theta, phi)` or `(X, Y, z)` are always normalised to `(z, a)`.
 * - The HEALPix spherical projection is used to map to `(t, u)` (see `za2tu` and `tu2za`).
 *   See Section 4.4 and Figure 5 in the paper, where `(t, u)` is called `(x_s, y_s)`.
 *
 * - A simple affine transformation is used to map to `(f, x, y)` (see `tu2fxy` and `fxy2tu`),
 *   where `f = {0 .. 11}` is the base pixel index and `(x, y)` is the position
 *   within the base pixel in the (north-east, north-west) direction
 *   and `(0, 0)` in the south corner.
 * - From `(f, x, y)`, the HEALPix pixel index in the "nested" scheme
 *   is related via `fxy2nest` and `nest2fxy`, and in the "ring" scheme
 *   via `fxy2ring` and `ring2fxy` in a relatively simple equations.
 *
 * To summarise: there are two geometrical transformations:
 * `(z, a)` <-> `(t, u)` is the HEALPix spherical projection,
 * and `(t, u)` <-> `(f, x, y)` is a 45 deg rotation and scaling for each
 * of the 12 base pixels, so that HEALPix pixels in `(x, y)` are unit squares,
 * and pixel index compuatations are relatively straightforward,
 * both in the "nested" and "ring" pixelisation scheme.
 *
 * ## Notations
 *
 * <pre>
 * theta :  colatitude (pi/2 - delta)                [0 , pi]
 * phi   :  longitude (alpha)                        [0, 2 pi)
 * t     :  coord. of x-axis in spherical projection [0, 2 pi)
 * u     :  coord. of y-axis in spherical projection [-pi/2, pi/2]
 * z     :  cos(theta)                               [-1, 1]
 * X     :  sin(theta) * cos(phi)                    [-1, 1]
 * Y     :  sin(theta) * sin(phi)                    [-1, 1]
 * a     :  phi                                      [0, 2 pi)
 * f     :  base pixel index                         {0 .. 11}
 * x     :  north-east index in base pixel           [0, nside)
 * y     :  north-west index in base pixel           [0, nside)
 * p     :  north-east axis in base pixel            [0, 1)
 * q     :  north-west axis in base pixel            [0, 1)
 * j     :  pixel-in-ring index                      polar cap: {1 .. 4 i}
 *                                                   equatorial belt: {1 .. 4 nside}
 * i     :  ring index                               {1 .. 4 nside - 1}
 * </pre>
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uniq2orderpix = exports.orderpix2uniq = exports.fxy2tu = exports.bit_decombine = exports.bit_combine = exports.fxy2nest = exports.vec2ang = exports.ang2vec = exports.tu2za = exports.za2tu = exports.tu2fxy = exports.pixcoord2vec_ring = exports.pixcoord2vec_nest = exports.nside2resol = exports.nside2pixarea = exports.corners_ring = exports.corners_nest = exports.max_pixrad = exports.query_disc_inclusive_ring = exports.query_disc_inclusive_nest = exports.pix2ang_ring = exports.pix2vec_ring = exports.pix2ang_nest = exports.pix2vec_nest = exports.ring2fxy = exports.ring2nest = exports.nest2ring = exports.ang2pix_ring = exports.ang2pix_nest = exports.vec2pix_ring = exports.vec2pix_nest = exports.nside2npix = exports.nside2order = exports.order2nside = void 0;
function order2nside(order) {
    return 1 << order;
}
exports.order2nside = order2nside;
function nside2order(nside) {
    return ilog2(nside);
}
exports.nside2order = nside2order;
function nside2npix(nside) {
    return 12 * nside * nside;
}
exports.nside2npix = nside2npix;
function vec2pix_nest(nside, v) {
    var _a = vec2za(v[0], v[1], v[2]), z = _a.z, a = _a.a;
    return za2pix_nest(nside, z, a);
}
exports.vec2pix_nest = vec2pix_nest;
function vec2pix_ring(nside, v) {
    var _a = vec2za(v[0], v[1], v[2]), z = _a.z, a = _a.a;
    return nest2ring(nside, za2pix_nest(nside, z, a));
}
exports.vec2pix_ring = vec2pix_ring;
function ang2pix_nest(nside, theta, phi) {
    var z = Math.cos(theta);
    return za2pix_nest(nside, z, phi);
}
exports.ang2pix_nest = ang2pix_nest;
function ang2pix_ring(nside, theta, phi) {
    var z = Math.cos(theta);
    return nest2ring(nside, za2pix_nest(nside, z, phi));
}
exports.ang2pix_ring = ang2pix_ring;
function nest2ring(nside, ipix) {
    var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    return fxy2ring(nside, f, x, y);
}
exports.nest2ring = nest2ring;
function ring2nest(nside, ipix) {
    if (nside == 1) {
        return ipix;
    }
    var _a = ring2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    return fxy2nest(nside, f, x, y);
}
exports.ring2nest = ring2nest;
function ring2fxy(nside, ipix) {
    var polar_lim = 2 * nside * (nside - 1);
    if (ipix < polar_lim) { // north polar cap
        var i = Math.floor((Math.sqrt(1 + 2 * ipix) + 1) / 2);
        var j = ipix - 2 * i * (i - 1);
        var f = Math.floor(j / i);
        var k = j % i;
        var x = nside - i + k;
        var y = nside - 1 - k;
        return { f: f, x: x, y: y };
    }
    if (ipix < polar_lim + 8 * nside * nside) { // equatorial belt
        var k = ipix - polar_lim;
        var ring = 4 * nside;
        var i = nside - Math.floor(k / ring);
        var s = i % 2 == 0 ? 1 : 0;
        var j = 2 * (k % ring) + s;
        var jj = j - 4 * nside;
        var ii = i + 5 * nside - 1;
        var pp = (ii + jj) / 2;
        var qq = (ii - jj) / 2;
        var PP = Math.floor(pp / nside);
        var QQ = Math.floor(qq / nside);
        var V = 5 - (PP + QQ);
        var H = PP - QQ + 4;
        var f = 4 * V + (H >> 1) % 4;
        var x = pp % nside;
        var y = qq % nside;
        return { f: f, x: x, y: y };
    }
    else { // south polar cap
        var p = 12 * nside * nside - ipix - 1;
        var i = Math.floor((Math.sqrt(1 + 2 * p) + 1) / 2);
        var j = p - 2 * i * (i - 1);
        var f = 11 - Math.floor(j / i);
        var k = j % i;
        var x = i - k - 1;
        var y = k;
        return { f: f, x: x, y: y };
    }
}
exports.ring2fxy = ring2fxy;
function pix2vec_nest(nside, ipix) {
    var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    var _b = fxy2tu(nside, f, x, y), t = _b.t, u = _b.u;
    var _c = tu2za(t, u), z = _c.z, a = _c.a;
    return za2vec(z, a);
}
exports.pix2vec_nest = pix2vec_nest;
function pix2ang_nest(nside, ipix) {
    var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    var _b = fxy2tu(nside, f, x, y), t = _b.t, u = _b.u;
    var _c = tu2za(t, u), z = _c.z, a = _c.a;
    return { theta: Math.acos(z), phi: a };
}
exports.pix2ang_nest = pix2ang_nest;
function pix2vec_ring(nside, ipix) {
    return pix2vec_nest(nside, ring2nest(nside, ipix));
}
exports.pix2vec_ring = pix2vec_ring;
function pix2ang_ring(nside, ipix) {
    return pix2ang_nest(nside, ring2nest(nside, ipix));
}
exports.pix2ang_ring = pix2ang_ring;
// TODO: cleanup
function query_disc_inclusive_nest(nside, v, radius, cb) {
    if (radius > PI_2) {
        throw new Error("query_disc: radius must < PI/2");
    }
    var pixrad = max_pixrad(nside);
    var d = PI_4 / nside;
    var _a = vec2za(v[0], v[1], v[2]), z0 = _a.z, a0 = _a.a; // z0 = cos(theta)
    var sin_t = Math.sqrt(1 - z0 * z0);
    var cos_r = Math.cos(radius); // r := radius
    var sin_r = Math.sin(radius);
    var z1 = z0 * cos_r + sin_t * sin_r; // cos(theta - r)
    var z2 = z0 * cos_r - sin_t * sin_r; // cos(theta + r)
    var u1 = za2tu(z1, 0).u;
    var u2 = za2tu(z2, 0).u;
    var cover_north_pole = sin_t * cos_r - z0 * sin_r < 0; // sin(theta - r) < 0
    var cover_south_pole = sin_t * cos_r + z0 * sin_r < 0; // sin(theta - r) < 0
    var i1 = Math.floor((PI_2 - u1) / d);
    var i2 = Math.floor((PI_2 - u2) / d + 1);
    if (cover_north_pole) {
        ++i1;
        for (var i = 1; i <= i1; ++i)
            walk_ring(nside, i, cb);
        ++i1;
    }
    if (i1 == 0) {
        walk_ring(nside, 1, cb);
        i1 = 2;
    }
    if (cover_south_pole) {
        --i2;
        for (var i = i2; i <= 4 * nside - 1; ++i)
            walk_ring(nside, i, cb);
        --i2;
    }
    if (i2 == 4 * nside) {
        walk_ring(nside, 4 * nside - 1, cb);
        i2 = 4 * nside - 2;
    }
    var theta = Math.acos(z0);
    for (var i = i1; i <= i2; ++i)
        walk_ring_around(nside, i, a0, theta, radius + pixrad, function (ipix) {
            if (angle(pix2vec_nest(nside, ipix), v) <= radius + pixrad)
                cb(ipix);
        });
}
exports.query_disc_inclusive_nest = query_disc_inclusive_nest;
function query_disc_inclusive_ring(nside, v, radius, cb_ring) {
    return query_disc_inclusive_nest(nside, v, radius, function (ipix) {
        cb_ring(nest2ring(nside, ipix));
    });
}
exports.query_disc_inclusive_ring = query_disc_inclusive_ring;
function max_pixrad(nside) {
    var unit = PI_4 / nside;
    return angle(tu2vec(unit, nside * unit), tu2vec(unit, (nside + 1) * unit));
}
exports.max_pixrad = max_pixrad;
function angle(a, b) {
    return 2 * Math.asin(Math.sqrt(distance2(a, b)) / 2);
}
function tu2vec(t, u) {
    var _a = tu2za(t, u), z = _a.z, a = _a.a;
    return za2vec(z, a);
}
function distance2(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return dx * dx + dy * dy + dz * dz;
}
function walk_ring_around(nside, i, a0, theta, r, cb) {
    if (theta < r || theta + r > PI)
        return walk_ring(nside, i, cb);
    var u = PI_4 * (2 - i / nside);
    var z = tu2za(PI_4, u).z;
    var st = Math.sin(theta);
    var ct = Math.cos(theta);
    var sr = Math.sin(r);
    var cr = Math.cos(r);
    var w = Math.atan2(Math.sqrt(-square(z - ct * cr) / (square(st) * sr * sr) + 1) * sr, (-z * ct + cr) / st);
    if (w >= PI)
        return walk_ring(nside, i, cb);
    var t1 = center_t(nside, i, za2tu(z, wrap(a0 - w, PI2)).t);
    var t2 = center_t(nside, i, za2tu(z, wrap(a0 + w, PI2)).t);
    var begin = tu2fxy(nside, t1, u);
    var end = right_next_pixel(nside, tu2fxy(nside, t2, u));
    for (var s = begin; !fxy_compare(s, end); s = right_next_pixel(nside, s)) {
        cb(fxy2nest(nside, s.f, s.x, s.y));
    }
}
function center_t(nside, i, t) {
    var d = PI_4 / nside;
    t /= d;
    t = (((t + i % 2) >> 1) << 1) + 1 - i % 2;
    t *= d;
    return t;
}
function walk_ring(nside, i, cb) {
    var u = PI_4 * (2 - i / nside);
    var t = PI_4 * (1 + (1 - i % 2) / nside);
    var begin = tu2fxy(nside, t, u);
    var s = begin;
    do {
        cb(fxy2nest(nside, s.f, s.x, s.y));
        s = right_next_pixel(nside, s);
    } while (!fxy_compare(s, begin));
}
function fxy_compare(a, b) {
    return a.x == b.x && a.y == b.y && a.f == b.f;
}
function right_next_pixel(nside, _a) {
    var f = _a.f, x = _a.x, y = _a.y;
    ++x;
    if (x == nside) {
        switch (Math.floor(f / 4)) {
            case 0:
                f = (f + 1) % 4;
                x = y;
                y = nside;
                break;
            case 1:
                f = f - 4;
                x = 0;
                break;
            case 2:
                f = 4 + (f + 1) % 4;
                x = 0;
                break;
        }
    }
    --y;
    if (y == -1) {
        switch (Math.floor(f / 4)) {
            case 0:
                f = 4 + (f + 1) % 4;
                y = nside - 1;
                break;
            case 1:
                f = f + 4;
                y = nside - 1;
                break;
            case 2: {
                f = 8 + (f + 1) % 4;
                y = x - 1;
                x = 0;
                break;
            }
        }
    }
    return { f: f, x: x, y: y };
}
function corners_nest(nside, ipix) {
    var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    var _b = fxy2tu(nside, f, x, y), t = _b.t, u = _b.u;
    var d = PI_4 / nside;
    var xyzs = [];
    for (var _i = 0, _c = [
        [0, d],
        [-d, 0],
        [0, -d],
        [d, 0],
    ]; _i < _c.length; _i++) {
        var _d = _c[_i], tt = _d[0], uu = _d[1];
        var _e = tu2za(t + tt, u + uu), z = _e.z, a = _e.a;
        xyzs.push(za2vec(z, a));
    }
    return xyzs;
}
exports.corners_nest = corners_nest;
function corners_ring(nside, ipix) {
    return corners_nest(nside, ring2nest(nside, ipix));
}
exports.corners_ring = corners_ring;
// pixel area
function nside2pixarea(nside) {
    return PI / (3 * nside * nside);
}
exports.nside2pixarea = nside2pixarea;
// average pixel size
function nside2resol(nside) {
    return Math.sqrt(PI / 3) / nside;
}
exports.nside2resol = nside2resol;
function pixcoord2vec_nest(nside, ipix, ne, nw) {
    var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
    var _b = fxy2tu(nside, f, x, y), t = _b.t, u = _b.u;
    var d = PI_4 / nside;
    var _c = tu2za(t + d * (ne - nw), u + d * (ne + nw - 1)), z = _c.z, a = _c.a;
    return za2vec(z, a);
}
exports.pixcoord2vec_nest = pixcoord2vec_nest;
function pixcoord2vec_ring(nside, ipix, ne, nw) {
    return pixcoord2vec_nest(nside, ring2nest(nside, ipix), ne, nw);
}
exports.pixcoord2vec_ring = pixcoord2vec_ring;
function za2pix_nest(nside, z, a) {
    var _a = za2tu(z, a), t = _a.t, u = _a.u;
    var _b = tu2fxy(nside, t, u), f = _b.f, x = _b.x, y = _b.y;
    return fxy2nest(nside, f, x, y);
}
function tu2fxy(nside, t, u) {
    var _a = tu2fpq(t, u), f = _a.f, p = _a.p, q = _a.q;
    var x = clip(Math.floor(nside * p), 0, nside - 1);
    var y = clip(Math.floor(nside * q), 0, nside - 1);
    return { f: f, x: x, y: y };
}
exports.tu2fxy = tu2fxy;
function wrap(A, B) {
    return A < 0 ? B - (-A % B) : A % B;
}
var PI2 = 2 * Math.PI;
var PI = Math.PI;
var PI_2 = Math.PI / 2;
var PI_4 = Math.PI / 4;
var PI_8 = Math.PI / 8;
function sigma(z) {
    if (z < 0)
        return -sigma(-z);
    else
        return 2 - Math.sqrt(3 * (1 - z));
}
/**
 * HEALPix spherical projection.
 */
function za2tu(z, a) {
    if (Math.abs(z) <= 2. / 3.) { // equatorial belt
        var t = a;
        var u = 3 * PI_8 * z;
        return { t: t, u: u };
    }
    else { // polar caps
        var p_t = a % (PI_2);
        var sigma_z = sigma(z);
        var t = a - (Math.abs(sigma_z) - 1) * (p_t - PI_4);
        var u = PI_4 * sigma_z;
        return { t: t, u: u };
    }
}
exports.za2tu = za2tu;
/**
 * Inverse HEALPix spherical projection.
 */
function tu2za(t, u) {
    var abs_u = Math.abs(u);
    if (abs_u >= PI_2) { // error
        return { z: sign(u), a: 0 };
    }
    if (abs_u <= Math.PI / 4) { // equatorial belt
        var z = 8 / (3 * PI) * u;
        var a = t;
        return { z: z, a: a };
    }
    else { // polar caps
        var t_t = t % (Math.PI / 2);
        var a = t - (abs_u - PI_4) / (abs_u - PI_2) * (t_t - PI_4);
        var z = sign(u) * (1 - 1 / 3 * square(2 - 4 * abs_u / PI));
        return { z: z, a: a };
    }
}
exports.tu2za = tu2za;
// (x, y, z) -> (z = cos(theta), phi)
function vec2za(X, Y, z) {
    var r2 = X * X + Y * Y;
    if (r2 == 0)
        return { z: z < 0 ? -1 : 1, a: 0 };
    else {
        var a = (Math.atan2(Y, X) + PI2) % PI2;
        z /= Math.sqrt(z * z + r2);
        return { z: z, a: a };
    }
}
// (z = cos(theta), phi) -> (x, y, z)
function za2vec(z, a) {
    var sin_theta = Math.sqrt(1 - z * z);
    var X = sin_theta * Math.cos(a);
    var Y = sin_theta * Math.sin(a);
    return [X, Y, z];
}
function ang2vec(theta, phi) {
    var z = Math.cos(theta);
    return za2vec(z, phi);
}
exports.ang2vec = ang2vec;
function vec2ang(v) {
    var _a = vec2za(v[0], v[1], v[2]), z = _a.z, a = _a.a;
    return { theta: Math.acos(z), phi: a };
}
exports.vec2ang = vec2ang;
// spherical projection -> f, p, q
// f: base pixel index
// p: coord in north east axis of base pixel
// q: coord in north west axis of base pixel
function tu2fpq(t, u) {
    t /= PI_4;
    u /= PI_4;
    t = wrap(t, 8);
    t += -4;
    u += 5;
    var pp = clip((u + t) / 2, 0, 5);
    var PP = Math.floor(pp);
    var qq = clip((u - t) / 2, 3 - PP, 6 - PP);
    var QQ = Math.floor(qq);
    var V = 5 - (PP + QQ);
    if (V < 0) { // clip
        return { f: 0, p: 1, q: 1 };
    }
    var H = PP - QQ + 4;
    var f = 4 * V + (H >> 1) % 4;
    var p = pp % 1;
    var q = qq % 1;
    return { f: f, p: p, q: q };
}
// f, p, q -> nest index
function fxy2nest(nside, f, x, y) {
    return f * nside * nside + bit_combine(x, y);
}
exports.fxy2nest = fxy2nest;
// x = (...x2 x1 x0)_2 <- in binary
// y = (...y2 y1 y0)_2
// p = (...y2 x2 y1 x1 y0 x0)_2
// returns p
function bit_combine(x, y) {
    assert(x < (1 << 16));
    assert(y < (1 << 15));
    return (
    // (python)
    // n = 14
    // ' | '.join(['x & 1'] + [f'(x & 0x{2 ** (i+1):x} | y & 0x{2 ** i:x}) << {i + 1}' for i in range(n)] + [f'y & 0x{2**n:x} << {n+1}'])
    x & 1 | (x & 0x2 | y & 0x1) << 1 | (x & 0x4 | y & 0x2) << 2 |
        (x & 0x8 | y & 0x4) << 3 | (x & 0x10 | y & 0x8) << 4 | (x & 0x20 | y & 0x10) << 5 |
        (x & 0x40 | y & 0x20) << 6 | (x & 0x80 | y & 0x40) << 7 | (x & 0x100 | y & 0x80) << 8 |
        (x & 0x200 | y & 0x100) << 9 | (x & 0x400 | y & 0x200) << 10 | (x & 0x800 | y & 0x400) << 11 |
        (x & 0x1000 | y & 0x800) << 12 | (x & 0x2000 | y & 0x1000) << 13 | (x & 0x4000 | y & 0x2000) << 14 |
        (x & 0x8000 | y & 0x4000) << 15 | y & 0x8000 << 16);
}
exports.bit_combine = bit_combine;
// x = (...x2 x1 x0)_2 <- in binary
// y = (...y2 y1 y0)_2
// p = (...y2 x2 y1 x1 y0 x0)_2
// returns x, y
function bit_decombine(p) {
    assert(p <= 0x7fffffff);
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i):x}) >> {i}' for i in range(16))
    var x = (p & 0x1) >> 0 | (p & 0x4) >> 1 | (p & 0x10) >> 2 |
        (p & 0x40) >> 3 | (p & 0x100) >> 4 | (p & 0x400) >> 5 |
        (p & 0x1000) >> 6 | (p & 0x4000) >> 7 | (p & 0x10000) >> 8 |
        (p & 0x40000) >> 9 | (p & 0x100000) >> 10 | (p & 0x400000) >> 11 |
        (p & 0x1000000) >> 12 | (p & 0x4000000) >> 13 | (p & 0x10000000) >> 14 | (p & 0x40000000) >> 15;
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i + 1):x}) >> {i+1}' for i in range(15))
    var y = (p & 0x2) >> 1 | (p & 0x8) >> 2 | (p & 0x20) >> 3 |
        (p & 0x80) >> 4 | (p & 0x200) >> 5 | (p & 0x800) >> 6 |
        (p & 0x2000) >> 7 | (p & 0x8000) >> 8 | (p & 0x20000) >> 9 |
        (p & 0x80000) >> 10 | (p & 0x200000) >> 11 | (p & 0x800000) >> 12 |
        (p & 0x2000000) >> 13 | (p & 0x8000000) >> 14 | (p & 0x20000000) >> 15;
    return { x: x, y: y };
}
exports.bit_decombine = bit_decombine;
// f: base pixel index
// x: north east index in base pixel
// y: north west index in base pixel
function nest2fxy(nside, ipix) {
    var nside2 = nside * nside;
    var f = Math.floor(ipix / nside2); // base pixel index
    var k = ipix % nside2; // nested pixel index in base pixel
    var _a = bit_decombine(k), x = _a.x, y = _a.y;
    return { f: f, x: x, y: y };
}
function fxy2ring(nside, f, x, y) {
    var f_row = Math.floor(f / 4); // {0 .. 2}
    var f1 = f_row + 2; // {2 .. 4}
    var v = x + y;
    var i = f1 * nside - v - 1;
    if (i < nside) { // north polar cap
        var f_col = f % 4;
        var ipix = 2 * i * (i - 1) + (i * f_col) + nside - y - 1;
        return ipix;
    }
    if (i < 3 * nside) { // equatorial belt
        var h = x - y;
        var f2 = 2 * (f % 4) - (f_row % 2) + 1; // {0 .. 7}
        var k = (f2 * nside + h + (8 * nside)) % (8 * nside);
        var offset = 2 * nside * (nside - 1);
        var ipix = offset + (i - nside) * 4 * nside + (k >> 1);
        return ipix;
    }
    else { // south polar cap
        var i_i = 4 * nside - i;
        var i_f_col = 3 - (f % 4);
        var j = 4 * i_i - (i_i * i_f_col) - y;
        var i_j = 4 * i_i - j + 1;
        var ipix = 12 * nside * nside - 2 * i_i * (i_i - 1) - i_j;
        return ipix;
    }
}
// f, x, y -> spherical projection
function fxy2tu(nside, f, x, y) {
    var f_row = Math.floor(f / 4);
    var f1 = f_row + 2;
    var f2 = 2 * (f % 4) - (f_row % 2) + 1;
    var v = x + y;
    var h = x - y;
    var i = f1 * nside - v - 1;
    var k = (f2 * nside + h + (8 * nside));
    var t = k / nside * PI_4;
    var u = PI_2 - i / nside * PI_4;
    return { t: t, u: u };
}
exports.fxy2tu = fxy2tu;
function orderpix2uniq(order, ipix) {
    /**
     * Pack `(order, ipix)` into a `uniq` integer.
     *
     * This HEALPix "unique identifier scheme" is starting to be used widely:
     * - see section 3.2 in http://healpix.sourceforge.net/pdf/intro.pdf
     * - see section 2.3.1 in http://ivoa.net/documents/MOC/
     */
    return 4 * ((1 << (2 * order)) - 1) + ipix;
}
exports.orderpix2uniq = orderpix2uniq;
function uniq2orderpix(uniq) {
    /**
     * Unpack `uniq` integer into `(order, ipix)`.
     *
     * Inverse of `orderpix2uniq`.
     */
    assert(uniq <= 0x7fffffff);
    var order = 0;
    var l = (uniq >> 2) + 1;
    while (l >= 4) {
        l >>= 2;
        ++order;
    }
    var ipix = uniq - (((1 << (2 * order)) - 1) << 2);
    return { order: order, ipix: ipix };
}
exports.uniq2orderpix = uniq2orderpix;
function ilog2(x) {
    /**
     * log2 for integer numbers.
     *
     * We're not calling Math.log2 because it's not supported on IE yet.
     */
    var o = -1;
    while (x > 0) {
        x >>= 1;
        ++o;
    }
    return o;
}
var sign = Math.sign || function (A) {
    return A > 0 ? 1 : (A < 0 ? -1 : 0);
};
function square(A) {
    return A * A;
}
function clip(Z, A, B) {
    return Z < A ? A : (Z > B ? B : Z);
}
function assert(condition) {
    console.assert(condition);
    if (!condition) {
        debugger;
    }
}


/***/ }),

/***/ 5661:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var MagicTrackpadDetector = (function () {
    function MagicTrackpadDetector() {
        this.minN1 = 10;
        this.minN2 = 15;
        this.history = new RingBuffer(Math.max(this.minN1, this.minN2));
    }
    MagicTrackpadDetector.prototype.inertial = function (e) {
        var h = this.history;
        var t0 = performance.now();
        var d0 = e.deltaY;
        h.push([t0, d0]);
        if (h.length < this.minN1)
            return false;
        if (Math.abs(e.deltaY) > 1) {
            for (var i = this.minN1 - 1; i > 1; --i) {
                var o = h.at(-i);
                var n = h.at(-i + 1);
                if (n[1] * o[1] < 0 || n[1] / o[1] > 1)
                    return false;
            }
            if (h.at(-1)[1] == h.at(-(this.minN1 - 1))[1]) {
                return false;
            }
        }
        else {
            if (h.length < this.minN2)
                return false;
            var _a = h.at(-this.minN2), to = _a[0], vo = _a[1];
            if (Math.abs(vo) <= 1) {
                return false;
            }
            for (var i = this.minN2 - 1; i > 1; --i) {
                var o = h.at(-i);
                var n = h.at(-i + 1);
                if (n[1] * o[1] < 0 || n[1] / o[1] > 1)
                    return false;
            }
        }
        return true;
    };
    return MagicTrackpadDetector;
}());
exports.MagicTrackpadDetector = MagicTrackpadDetector;
var RingBuffer = (function () {
    function RingBuffer(n) {
        this.n = n;
        this.clear();
    }
    RingBuffer.prototype.at = function (i) {
        var j = (this.o + i + this.length) % this.xs.length;
        return this.xs[j];
    };
    RingBuffer.prototype.push = function (x) {
        if (this.xs.length < this.n)
            this.xs.push(x);
        else
            this.xs[this.o] = x;
        this.o = (this.o + 1) % this.n;
    };
    RingBuffer.prototype.clear = function () {
        this.o = 0;
        this.xs = [];
    };
    Object.defineProperty(RingBuffer.prototype, "length", {
        get: function () {
            return this.xs.length;
        },
        enumerable: true,
        configurable: true
    });
    return RingBuffer;
}());


/***/ }),

/***/ 1519:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var TupleMap = (function () {
    function TupleMap() {
        this.m = new Map();
        this.idMaker = new TupleIdMaker();
    }
    TupleMap.prototype.get = function (key) {
        var id = this.idMaker.get(key);
        var value = this.m.get(id);
        this.idMaker.forget(key);
        return value;
    };
    TupleMap.prototype.set = function (key, value) {
        var id = this.idMaker.get(key);
        if (this.m.has(id))
            this.idMaker.forget(key);
        this.m.set(id, value);
        return this;
    };
    TupleMap.prototype.has = function (key) {
        var id = this.idMaker.get(key);
        var has = this.m.has(id);
        this.idMaker.forget(key);
        return has;
    };
    TupleMap.prototype.delete = function (key) {
        var id = this.idMaker.get(key);
        this.m.delete(id);
        this.idMaker.forget(key);
        this.idMaker.forget(key);
        return true;
    };
    TupleMap.prototype.clear = function () {
        this.m.clear();
        this.idMaker.clear();
    };
    TupleMap.prototype._internalMapSize = function () {
        return this.idMaker.idMaker.m.size;
    };
    return TupleMap;
}());
exports.TupleMap = TupleMap;
var TupleIdMaker = (function () {
    function TupleIdMaker() {
        this.idMaker = new IdMaker();
    }
    TupleIdMaker.prototype.get = function (key) {
        var _this = this;
        return key.map(function (k) { return _this.idMaker.get(k); }).join('-');
    };
    TupleIdMaker.prototype.forget = function (key) {
        var _this = this;
        key.forEach(function (k) { return _this.idMaker.forget(k); });
    };
    TupleIdMaker.prototype.clear = function () { this.idMaker.clear(); };
    return TupleIdMaker;
}());
var IdMaker = (function () {
    function IdMaker() {
        this.serialNumber = 0;
        this.m = new Map();
    }
    IdMaker.prototype.get = function (key) {
        var idInfo = this.m.get(key);
        if (idInfo != undefined) {
            ++idInfo.refCount;
            return idInfo.value;
        }
        else {
            var value = ++this.serialNumber;
            this.m.set(key, {
                refCount: 1,
                value: value
            });
            return value;
        }
    };
    IdMaker.prototype.forget = function (key) {
        var idInfo = this.m.get(key);
        if (--idInfo.refCount == 0)
            this.m.delete(key);
    };
    IdMaker.prototype.clear = function () {
        this.m.clear();
    };
    return IdMaker;
}());


/***/ }),

/***/ 9669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(5327);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var createError = __webpack_require__(5061);
var defaults = __webpack_require__(5655);
var Cancel = __webpack_require__(5263);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(5263);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);
axios.VERSION = __webpack_require__(3636).version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 5263:
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 4972:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(5263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 6502:
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(5327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 5061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 3572:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5655);
var Cancel = __webpack_require__(5263);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 481:
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 7185:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(5061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var enhanceError = __webpack_require__(481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 3636:
/***/ ((module) => {

module.exports = {
  "version": "0.22.0"
};

/***/ }),

/***/ 1849:
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 5327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ ((module) => {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 4109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 4875:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var VERSION = __webpack_require__(3636).version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 6752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "5524030224b6d804143652d9a6ed09a7._json";

/***/ }),

/***/ 887:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "glMatrix": () => (/* reexport */ common_namespaceObject),
  "mat2": () => (/* reexport */ mat2_namespaceObject),
  "mat2d": () => (/* reexport */ mat2d_namespaceObject),
  "mat3": () => (/* reexport */ mat3_namespaceObject),
  "mat4": () => (/* reexport */ mat4_namespaceObject),
  "quat": () => (/* reexport */ quat_namespaceObject),
  "quat2": () => (/* reexport */ quat2_namespaceObject),
  "vec2": () => (/* reexport */ vec2_namespaceObject),
  "vec3": () => (/* reexport */ vec3_namespaceObject),
  "vec4": () => (/* reexport */ vec4_namespaceObject)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/common.js
var common_namespaceObject = {};
__webpack_require__.r(common_namespaceObject);
__webpack_require__.d(common_namespaceObject, {
  "ARRAY_TYPE": () => (ARRAY_TYPE),
  "EPSILON": () => (EPSILON),
  "RANDOM": () => (RANDOM),
  "equals": () => (equals),
  "setMatrixArrayType": () => (setMatrixArrayType),
  "toRadian": () => (toRadian)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat2.js
var mat2_namespaceObject = {};
__webpack_require__.r(mat2_namespaceObject);
__webpack_require__.d(mat2_namespaceObject, {
  "LDU": () => (LDU),
  "add": () => (add),
  "adjoint": () => (adjoint),
  "clone": () => (clone),
  "copy": () => (copy),
  "create": () => (create),
  "determinant": () => (determinant),
  "equals": () => (mat2_equals),
  "exactEquals": () => (exactEquals),
  "frob": () => (frob),
  "fromRotation": () => (fromRotation),
  "fromScaling": () => (fromScaling),
  "fromValues": () => (fromValues),
  "identity": () => (identity),
  "invert": () => (invert),
  "mul": () => (mul),
  "multiply": () => (multiply),
  "multiplyScalar": () => (multiplyScalar),
  "multiplyScalarAndAdd": () => (multiplyScalarAndAdd),
  "rotate": () => (rotate),
  "scale": () => (scale),
  "set": () => (set),
  "str": () => (str),
  "sub": () => (sub),
  "subtract": () => (subtract),
  "transpose": () => (transpose)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat2d.js
var mat2d_namespaceObject = {};
__webpack_require__.r(mat2d_namespaceObject);
__webpack_require__.d(mat2d_namespaceObject, {
  "add": () => (mat2d_add),
  "clone": () => (mat2d_clone),
  "copy": () => (mat2d_copy),
  "create": () => (mat2d_create),
  "determinant": () => (mat2d_determinant),
  "equals": () => (mat2d_equals),
  "exactEquals": () => (mat2d_exactEquals),
  "frob": () => (mat2d_frob),
  "fromRotation": () => (mat2d_fromRotation),
  "fromScaling": () => (mat2d_fromScaling),
  "fromTranslation": () => (fromTranslation),
  "fromValues": () => (mat2d_fromValues),
  "identity": () => (mat2d_identity),
  "invert": () => (mat2d_invert),
  "mul": () => (mat2d_mul),
  "multiply": () => (mat2d_multiply),
  "multiplyScalar": () => (mat2d_multiplyScalar),
  "multiplyScalarAndAdd": () => (mat2d_multiplyScalarAndAdd),
  "rotate": () => (mat2d_rotate),
  "scale": () => (mat2d_scale),
  "set": () => (mat2d_set),
  "str": () => (mat2d_str),
  "sub": () => (mat2d_sub),
  "subtract": () => (mat2d_subtract),
  "translate": () => (translate)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat3.js
var mat3_namespaceObject = {};
__webpack_require__.r(mat3_namespaceObject);
__webpack_require__.d(mat3_namespaceObject, {
  "add": () => (mat3_add),
  "adjoint": () => (mat3_adjoint),
  "clone": () => (mat3_clone),
  "copy": () => (mat3_copy),
  "create": () => (mat3_create),
  "determinant": () => (mat3_determinant),
  "equals": () => (mat3_equals),
  "exactEquals": () => (mat3_exactEquals),
  "frob": () => (mat3_frob),
  "fromMat2d": () => (fromMat2d),
  "fromMat4": () => (fromMat4),
  "fromQuat": () => (fromQuat),
  "fromRotation": () => (mat3_fromRotation),
  "fromScaling": () => (mat3_fromScaling),
  "fromTranslation": () => (mat3_fromTranslation),
  "fromValues": () => (mat3_fromValues),
  "identity": () => (mat3_identity),
  "invert": () => (mat3_invert),
  "mul": () => (mat3_mul),
  "multiply": () => (mat3_multiply),
  "multiplyScalar": () => (mat3_multiplyScalar),
  "multiplyScalarAndAdd": () => (mat3_multiplyScalarAndAdd),
  "normalFromMat4": () => (normalFromMat4),
  "projection": () => (projection),
  "rotate": () => (mat3_rotate),
  "scale": () => (mat3_scale),
  "set": () => (mat3_set),
  "str": () => (mat3_str),
  "sub": () => (mat3_sub),
  "subtract": () => (mat3_subtract),
  "translate": () => (mat3_translate),
  "transpose": () => (mat3_transpose)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat4.js
var mat4_namespaceObject = {};
__webpack_require__.r(mat4_namespaceObject);
__webpack_require__.d(mat4_namespaceObject, {
  "add": () => (mat4_add),
  "adjoint": () => (mat4_adjoint),
  "clone": () => (mat4_clone),
  "copy": () => (mat4_copy),
  "create": () => (mat4_create),
  "determinant": () => (mat4_determinant),
  "equals": () => (mat4_equals),
  "exactEquals": () => (mat4_exactEquals),
  "frob": () => (mat4_frob),
  "fromQuat": () => (mat4_fromQuat),
  "fromQuat2": () => (fromQuat2),
  "fromRotation": () => (mat4_fromRotation),
  "fromRotationTranslation": () => (fromRotationTranslation),
  "fromRotationTranslationScale": () => (fromRotationTranslationScale),
  "fromRotationTranslationScaleOrigin": () => (fromRotationTranslationScaleOrigin),
  "fromScaling": () => (mat4_fromScaling),
  "fromTranslation": () => (mat4_fromTranslation),
  "fromValues": () => (mat4_fromValues),
  "fromXRotation": () => (fromXRotation),
  "fromYRotation": () => (fromYRotation),
  "fromZRotation": () => (fromZRotation),
  "frustum": () => (frustum),
  "getRotation": () => (getRotation),
  "getScaling": () => (getScaling),
  "getTranslation": () => (getTranslation),
  "identity": () => (mat4_identity),
  "invert": () => (mat4_invert),
  "lookAt": () => (lookAt),
  "mul": () => (mat4_mul),
  "multiply": () => (mat4_multiply),
  "multiplyScalar": () => (mat4_multiplyScalar),
  "multiplyScalarAndAdd": () => (mat4_multiplyScalarAndAdd),
  "ortho": () => (ortho),
  "orthoNO": () => (orthoNO),
  "orthoZO": () => (orthoZO),
  "perspective": () => (perspective),
  "perspectiveFromFieldOfView": () => (perspectiveFromFieldOfView),
  "perspectiveNO": () => (perspectiveNO),
  "perspectiveZO": () => (perspectiveZO),
  "rotate": () => (mat4_rotate),
  "rotateX": () => (rotateX),
  "rotateY": () => (rotateY),
  "rotateZ": () => (rotateZ),
  "scale": () => (mat4_scale),
  "set": () => (mat4_set),
  "str": () => (mat4_str),
  "sub": () => (mat4_sub),
  "subtract": () => (mat4_subtract),
  "targetTo": () => (targetTo),
  "translate": () => (mat4_translate),
  "transpose": () => (mat4_transpose)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec3.js
var vec3_namespaceObject = {};
__webpack_require__.r(vec3_namespaceObject);
__webpack_require__.d(vec3_namespaceObject, {
  "add": () => (vec3_add),
  "angle": () => (angle),
  "bezier": () => (bezier),
  "ceil": () => (ceil),
  "clone": () => (vec3_clone),
  "copy": () => (vec3_copy),
  "create": () => (vec3_create),
  "cross": () => (cross),
  "dist": () => (dist),
  "distance": () => (distance),
  "div": () => (div),
  "divide": () => (divide),
  "dot": () => (vec3_dot),
  "equals": () => (vec3_equals),
  "exactEquals": () => (vec3_exactEquals),
  "floor": () => (floor),
  "forEach": () => (forEach),
  "fromValues": () => (vec3_fromValues),
  "hermite": () => (hermite),
  "inverse": () => (inverse),
  "len": () => (len),
  "length": () => (vec3_length),
  "lerp": () => (lerp),
  "max": () => (max),
  "min": () => (min),
  "mul": () => (vec3_mul),
  "multiply": () => (vec3_multiply),
  "negate": () => (negate),
  "normalize": () => (normalize),
  "random": () => (random),
  "rotateX": () => (vec3_rotateX),
  "rotateY": () => (vec3_rotateY),
  "rotateZ": () => (vec3_rotateZ),
  "round": () => (round),
  "scale": () => (vec3_scale),
  "scaleAndAdd": () => (scaleAndAdd),
  "set": () => (vec3_set),
  "sqrDist": () => (sqrDist),
  "sqrLen": () => (sqrLen),
  "squaredDistance": () => (squaredDistance),
  "squaredLength": () => (squaredLength),
  "str": () => (vec3_str),
  "sub": () => (vec3_sub),
  "subtract": () => (vec3_subtract),
  "transformMat3": () => (transformMat3),
  "transformMat4": () => (transformMat4),
  "transformQuat": () => (transformQuat),
  "zero": () => (zero)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec4.js
var vec4_namespaceObject = {};
__webpack_require__.r(vec4_namespaceObject);
__webpack_require__.d(vec4_namespaceObject, {
  "add": () => (vec4_add),
  "ceil": () => (vec4_ceil),
  "clone": () => (vec4_clone),
  "copy": () => (vec4_copy),
  "create": () => (vec4_create),
  "cross": () => (vec4_cross),
  "dist": () => (vec4_dist),
  "distance": () => (vec4_distance),
  "div": () => (vec4_div),
  "divide": () => (vec4_divide),
  "dot": () => (dot),
  "equals": () => (vec4_equals),
  "exactEquals": () => (vec4_exactEquals),
  "floor": () => (vec4_floor),
  "forEach": () => (vec4_forEach),
  "fromValues": () => (vec4_fromValues),
  "inverse": () => (vec4_inverse),
  "len": () => (vec4_len),
  "length": () => (vec4_length),
  "lerp": () => (vec4_lerp),
  "max": () => (vec4_max),
  "min": () => (vec4_min),
  "mul": () => (vec4_mul),
  "multiply": () => (vec4_multiply),
  "negate": () => (vec4_negate),
  "normalize": () => (vec4_normalize),
  "random": () => (vec4_random),
  "round": () => (vec4_round),
  "scale": () => (vec4_scale),
  "scaleAndAdd": () => (vec4_scaleAndAdd),
  "set": () => (vec4_set),
  "sqrDist": () => (vec4_sqrDist),
  "sqrLen": () => (vec4_sqrLen),
  "squaredDistance": () => (vec4_squaredDistance),
  "squaredLength": () => (vec4_squaredLength),
  "str": () => (vec4_str),
  "sub": () => (vec4_sub),
  "subtract": () => (vec4_subtract),
  "transformMat4": () => (vec4_transformMat4),
  "transformQuat": () => (vec4_transformQuat),
  "zero": () => (vec4_zero)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/quat.js
var quat_namespaceObject = {};
__webpack_require__.r(quat_namespaceObject);
__webpack_require__.d(quat_namespaceObject, {
  "add": () => (quat_add),
  "calculateW": () => (calculateW),
  "clone": () => (quat_clone),
  "conjugate": () => (conjugate),
  "copy": () => (quat_copy),
  "create": () => (quat_create),
  "dot": () => (quat_dot),
  "equals": () => (quat_equals),
  "exactEquals": () => (quat_exactEquals),
  "exp": () => (exp),
  "fromEuler": () => (fromEuler),
  "fromMat3": () => (fromMat3),
  "fromValues": () => (quat_fromValues),
  "getAngle": () => (getAngle),
  "getAxisAngle": () => (getAxisAngle),
  "identity": () => (quat_identity),
  "invert": () => (quat_invert),
  "len": () => (quat_len),
  "length": () => (quat_length),
  "lerp": () => (quat_lerp),
  "ln": () => (ln),
  "mul": () => (quat_mul),
  "multiply": () => (quat_multiply),
  "normalize": () => (quat_normalize),
  "pow": () => (pow),
  "random": () => (quat_random),
  "rotateX": () => (quat_rotateX),
  "rotateY": () => (quat_rotateY),
  "rotateZ": () => (quat_rotateZ),
  "rotationTo": () => (rotationTo),
  "scale": () => (quat_scale),
  "set": () => (quat_set),
  "setAxes": () => (setAxes),
  "setAxisAngle": () => (setAxisAngle),
  "slerp": () => (slerp),
  "sqlerp": () => (sqlerp),
  "sqrLen": () => (quat_sqrLen),
  "squaredLength": () => (quat_squaredLength),
  "str": () => (quat_str)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/quat2.js
var quat2_namespaceObject = {};
__webpack_require__.r(quat2_namespaceObject);
__webpack_require__.d(quat2_namespaceObject, {
  "add": () => (quat2_add),
  "clone": () => (quat2_clone),
  "conjugate": () => (quat2_conjugate),
  "copy": () => (quat2_copy),
  "create": () => (quat2_create),
  "dot": () => (quat2_dot),
  "equals": () => (quat2_equals),
  "exactEquals": () => (quat2_exactEquals),
  "fromMat4": () => (quat2_fromMat4),
  "fromRotation": () => (quat2_fromRotation),
  "fromRotationTranslation": () => (quat2_fromRotationTranslation),
  "fromRotationTranslationValues": () => (fromRotationTranslationValues),
  "fromTranslation": () => (quat2_fromTranslation),
  "fromValues": () => (quat2_fromValues),
  "getDual": () => (getDual),
  "getReal": () => (getReal),
  "getTranslation": () => (quat2_getTranslation),
  "identity": () => (quat2_identity),
  "invert": () => (quat2_invert),
  "len": () => (quat2_len),
  "length": () => (quat2_length),
  "lerp": () => (quat2_lerp),
  "mul": () => (quat2_mul),
  "multiply": () => (quat2_multiply),
  "normalize": () => (quat2_normalize),
  "rotateAroundAxis": () => (rotateAroundAxis),
  "rotateByQuatAppend": () => (rotateByQuatAppend),
  "rotateByQuatPrepend": () => (rotateByQuatPrepend),
  "rotateX": () => (quat2_rotateX),
  "rotateY": () => (quat2_rotateY),
  "rotateZ": () => (quat2_rotateZ),
  "scale": () => (quat2_scale),
  "set": () => (quat2_set),
  "setDual": () => (setDual),
  "setReal": () => (setReal),
  "sqrLen": () => (quat2_sqrLen),
  "squaredLength": () => (quat2_squaredLength),
  "str": () => (quat2_str),
  "translate": () => (quat2_translate)
});

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec2.js
var vec2_namespaceObject = {};
__webpack_require__.r(vec2_namespaceObject);
__webpack_require__.d(vec2_namespaceObject, {
  "add": () => (vec2_add),
  "angle": () => (vec2_angle),
  "ceil": () => (vec2_ceil),
  "clone": () => (vec2_clone),
  "copy": () => (vec2_copy),
  "create": () => (vec2_create),
  "cross": () => (vec2_cross),
  "dist": () => (vec2_dist),
  "distance": () => (vec2_distance),
  "div": () => (vec2_div),
  "divide": () => (vec2_divide),
  "dot": () => (vec2_dot),
  "equals": () => (vec2_equals),
  "exactEquals": () => (vec2_exactEquals),
  "floor": () => (vec2_floor),
  "forEach": () => (vec2_forEach),
  "fromValues": () => (vec2_fromValues),
  "inverse": () => (vec2_inverse),
  "len": () => (vec2_len),
  "length": () => (vec2_length),
  "lerp": () => (vec2_lerp),
  "max": () => (vec2_max),
  "min": () => (vec2_min),
  "mul": () => (vec2_mul),
  "multiply": () => (vec2_multiply),
  "negate": () => (vec2_negate),
  "normalize": () => (vec2_normalize),
  "random": () => (vec2_random),
  "rotate": () => (vec2_rotate),
  "round": () => (vec2_round),
  "scale": () => (vec2_scale),
  "scaleAndAdd": () => (vec2_scaleAndAdd),
  "set": () => (vec2_set),
  "sqrDist": () => (vec2_sqrDist),
  "sqrLen": () => (vec2_sqrLen),
  "squaredDistance": () => (vec2_squaredDistance),
  "squaredLength": () => (vec2_squaredLength),
  "str": () => (vec2_str),
  "sub": () => (vec2_sub),
  "subtract": () => (vec2_subtract),
  "transformMat2": () => (transformMat2),
  "transformMat2d": () => (transformMat2d),
  "transformMat3": () => (vec2_transformMat3),
  "transformMat4": () => (vec2_transformMat4),
  "zero": () => (vec2_zero)
});

;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/common.js
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */

function setMatrixArrayType(type) {
  ARRAY_TYPE = type;
}
var degree = Math.PI / 180;
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */

function toRadian(a) {
  return a * degree;
}
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */

function equals(a, b) {
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat2.js

/**
 * 2x2 Matrix
 * @module mat2
 */

/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */

function create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
  }

  out[0] = 1;
  out[3] = 1;
  return out;
}
/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */

function clone(a) {
  var out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
/**
 * Create a new mat2 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out A new 2x2 matrix
 */

function fromValues(m00, m01, m10, m11) {
  var out = new ARRAY_TYPE(4);
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}
/**
 * Set the components of a mat2 to the given values
 *
 * @param {mat2} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out
 */

function set(out, m00, m01, m10, m11) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}
/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache
  // some values
  if (out === a) {
    var a1 = a[1];
    out[1] = a[2];
    out[2] = a1;
  } else {
    out[0] = a[0];
    out[1] = a[2];
    out[2] = a[1];
    out[3] = a[3];
  }

  return out;
}
/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function invert(out, a) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3]; // Calculate the determinant

  var det = a0 * a3 - a2 * a1;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = a3 * det;
  out[1] = -a1 * det;
  out[2] = -a2 * det;
  out[3] = a0 * det;
  return out;
}
/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function adjoint(out, a) {
  // Caching this value is nessecary if out == a
  var a0 = a[0];
  out[0] = a[3];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a0;
  return out;
}
/**
 * Calculates the determinant of a mat2
 *
 * @param {ReadonlyMat2} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  return a[0] * a[3] - a[2] * a[1];
}
/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function multiply(out, a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  return out;
}
/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */

function rotate(out, a, rad) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = a0 * c + a2 * s;
  out[1] = a1 * c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  return out;
}
/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/

function scale(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.rotate(dest, dest, rad);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */

function fromRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.scale(dest, dest, vec);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat2} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  return out;
}
/**
 * Returns a string representation of a mat2
 *
 * @param {ReadonlyMat2} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str(a) {
  return "mat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Returns Frobenius norm of a mat2
 *
 * @param {ReadonlyMat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3]);
}
/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {ReadonlyMat2} L the lower triangular matrix
 * @param {ReadonlyMat2} D the diagonal matrix
 * @param {ReadonlyMat2} U the upper triangular matrix
 * @param {ReadonlyMat2} a the input matrix to factorize
 */

function LDU(L, D, U, a) {
  L[2] = a[2] / a[0];
  U[0] = a[0];
  U[1] = a[1];
  U[3] = a[3] - L[2] * U[1];
  return [L, D, U];
}
/**
 * Adds two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat2} a The first matrix.
 * @param {ReadonlyMat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat2} a The first matrix.
 * @param {ReadonlyMat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}
/**
 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2} out the receiving vector
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  return out;
}
/**
 * Alias for {@link mat2.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link mat2.subtract}
 * @function
 */

var sub = subtract;
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat2d.js

/**
 * 2x3 Matrix
 * @module mat2d
 * @description
 * A mat2d contains six elements defined as:
 * <pre>
 * [a, b,
 *  c, d,
 *  tx, ty]
 * </pre>
 * This is a short form for the 3x3 matrix:
 * <pre>
 * [a, b, 0,
 *  c, d, 0,
 *  tx, ty, 1]
 * </pre>
 * The last column is ignored so the array is shorter and operations are faster.
 */

/**
 * Creates a new identity mat2d
 *
 * @returns {mat2d} a new 2x3 matrix
 */

function mat2d_create() {
  var out = new ARRAY_TYPE(6);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[4] = 0;
    out[5] = 0;
  }

  out[0] = 1;
  out[3] = 1;
  return out;
}
/**
 * Creates a new mat2d initialized with values from an existing matrix
 *
 * @param {ReadonlyMat2d} a matrix to clone
 * @returns {mat2d} a new 2x3 matrix
 */

function mat2d_clone(a) {
  var out = new ARRAY_TYPE(6);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}
/**
 * Copy the values from one mat2d to another
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {mat2d} out
 */

function mat2d_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}
/**
 * Set a mat2d to the identity matrix
 *
 * @param {mat2d} out the receiving matrix
 * @returns {mat2d} out
 */

function mat2d_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Create a new mat2d with the given values
 *
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} A new mat2d
 */

function mat2d_fromValues(a, b, c, d, tx, ty) {
  var out = new ARRAY_TYPE(6);
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}
/**
 * Set the components of a mat2d to the given values
 *
 * @param {mat2d} out the receiving matrix
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} out
 */

function mat2d_set(out, a, b, c, d, tx, ty) {
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}
/**
 * Inverts a mat2d
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {mat2d} out
 */

function mat2d_invert(out, a) {
  var aa = a[0],
      ab = a[1],
      ac = a[2],
      ad = a[3];
  var atx = a[4],
      aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}
/**
 * Calculates the determinant of a mat2d
 *
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {Number} determinant of a
 */

function mat2d_determinant(a) {
  return a[0] * a[3] - a[1] * a[2];
}
/**
 * Multiplies two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_multiply(out, a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  out[4] = a0 * b4 + a2 * b5 + a4;
  out[5] = a1 * b4 + a3 * b5 + a5;
  return out;
}
/**
 * Rotates a mat2d by the given angle
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */

function mat2d_rotate(out, a, rad) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = a0 * c + a2 * s;
  out[1] = a1 * c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  out[4] = a4;
  out[5] = a5;
  return out;
}
/**
 * Scales the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to translate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat2d} out
 **/

function mat2d_scale(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  out[4] = a4;
  out[5] = a5;
  return out;
}
/**
 * Translates the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to translate
 * @param {ReadonlyVec2} v the vec2 to translate the matrix by
 * @returns {mat2d} out
 **/

function translate(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0;
  out[1] = a1;
  out[2] = a2;
  out[3] = a3;
  out[4] = a0 * v0 + a2 * v1 + a4;
  out[5] = a1 * v0 + a3 * v1 + a5;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.rotate(dest, dest, rad);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */

function mat2d_fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.scale(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat2d} out
 */

function mat2d_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.translate(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat2d} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = v[0];
  out[5] = v[1];
  return out;
}
/**
 * Returns a string representation of a mat2d
 *
 * @param {ReadonlyMat2d} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat2d_str(a) {
  return "mat2d(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ")";
}
/**
 * Returns Frobenius norm of a mat2d
 *
 * @param {ReadonlyMat2d} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat2d_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], 1);
}
/**
 * Adds two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2d} out
 */

function mat2d_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  return out;
}
/**
 * Adds two mat2d's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2d} out the receiving vector
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2d} out
 */

function mat2d_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat2d} a The first matrix.
 * @param {ReadonlyMat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2d_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat2d} a The first matrix.
 * @param {ReadonlyMat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2d_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5));
}
/**
 * Alias for {@link mat2d.multiply}
 * @function
 */

var mat2d_mul = mat2d_multiply;
/**
 * Alias for {@link mat2d.subtract}
 * @function
 */

var mat2d_sub = mat2d_subtract;
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat3.js

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */

function mat3_create() {
  var out = new ARRAY_TYPE(9);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }

  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {ReadonlyMat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */

function fromMat4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[4];
  out[4] = a[5];
  out[5] = a[6];
  out[6] = a[8];
  out[7] = a[9];
  out[8] = a[10];
  return out;
}
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */

function mat3_clone(a) {
  var out = new ARRAY_TYPE(9);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */

function mat3_fromValues(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  var out = new ARRAY_TYPE(9);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */

function mat3_set(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */

function mat3_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a12 = a[5];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a01;
    out[5] = a[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a[0];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a[1];
    out[4] = a[4];
    out[5] = a[7];
    out[6] = a[2];
    out[7] = a[5];
    out[8] = a[8];
  }

  return out;
}
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20; // Calculate the determinant

  var det = a00 * b01 + a01 * b11 + a02 * b21;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  out[0] = a11 * a22 - a12 * a21;
  out[1] = a02 * a21 - a01 * a22;
  out[2] = a01 * a12 - a02 * a11;
  out[3] = a12 * a20 - a10 * a22;
  out[4] = a00 * a22 - a02 * a20;
  out[5] = a02 * a10 - a00 * a12;
  out[6] = a10 * a21 - a11 * a20;
  out[7] = a01 * a20 - a00 * a21;
  out[8] = a00 * a11 - a01 * a10;
  return out;
}
/**
 * Calculates the determinant of a mat3
 *
 * @param {ReadonlyMat3} a the source matrix
 * @returns {Number} determinant of a
 */

function mat3_determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b00 = b[0],
      b01 = b[1],
      b02 = b[2];
  var b10 = b[3],
      b11 = b[4],
      b12 = b[5];
  var b20 = b[6],
      b21 = b[7],
      b22 = b[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */

function mat3_translate(out, a, v) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      x = v[0],
      y = v[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x * a00 + y * a10 + a20;
  out[7] = x * a01 + y * a11 + a21;
  out[8] = x * a02 + y * a12 + a22;
  return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function mat3_rotate(out, a, rad) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c * a00 + s * a10;
  out[1] = c * a01 + s * a11;
  out[2] = c * a02 + s * a12;
  out[3] = c * a10 - s * a00;
  out[4] = c * a11 - s * a01;
  out[5] = c * a12 - s * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/

function mat3_scale(out, a, v) {
  var x = v[0],
      y = v[1];
  out[0] = x * a[0];
  out[1] = x * a[1];
  out[2] = x * a[2];
  out[3] = y * a[3];
  out[4] = y * a[4];
  out[5] = y * a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat3} out
 */

function mat3_fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function mat3_fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat3} out
 */

function mat3_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to copy
 * @returns {mat3} out
 **/

function fromMat2d(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = 0;
  out[3] = a[2];
  out[4] = a[3];
  out[5] = 0;
  out[6] = a[4];
  out[7] = a[5];
  out[8] = 1;
  return out;
}
/**
 * Calculates a 3x3 matrix from the given quaternion
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat3} out
 */

function fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
/**
 * Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyMat4} a Mat4 to derive the normal matrix from
 *
 * @returns {mat3} out
 */

function normalFromMat4(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */

function projection(out, width, height) {
  out[0] = 2 / width;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = -2 / height;
  out[5] = 0;
  out[6] = -1;
  out[7] = 1;
  out[8] = 1;
  return out;
}
/**
 * Returns a string representation of a mat3
 *
 * @param {ReadonlyMat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat3_str(a) {
  return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {ReadonlyMat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat3_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */

function mat3_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  return out;
}
/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */

function mat3_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat3_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat3_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7],
      a8 = a[8];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7],
      b8 = b[8];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
/**
 * Alias for {@link mat3.multiply}
 * @function
 */

var mat3_mul = mat3_multiply;
/**
 * Alias for {@link mat3.subtract}
 * @function
 */

var mat3_sub = mat3_subtract;
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat4.js

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function mat4_create() {
  var out = new ARRAY_TYPE(16);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function mat4_clone(a) {
  var out = new ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function mat4_fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */

function mat4_set(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function mat4_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a03 = a[3];
    var a12 = a[6],
        a13 = a[7];
    var a23 = a[11];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }

  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
  out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
  out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
  out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
  out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
  out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
  return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */

function mat4_determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function mat4_translate(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function mat4_scale(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function mat4_rotate(out, a, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  var b00, b01, b02;
  var b10, b11, b12;
  var b20, b21, b22;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;
  a00 = a[0];
  a01 = a[1];
  a02 = a[2];
  a03 = a[3];
  a10 = a[4];
  a11 = a[5];
  a12 = a[6];
  a13 = a[7];
  a20 = a[8];
  a21 = a[9];
  a22 = a[10];
  a23 = a[11]; // Construct the elements of the rotation matrix

  b00 = x * x * t + c;
  b01 = y * x * t + z * s;
  b02 = z * x * t - y * s;
  b10 = x * y * t - z * s;
  b11 = y * y * t + c;
  b12 = z * y * t + x * s;
  b20 = x * z * t + y * s;
  b21 = y * z * t - x * s;
  b22 = z * z * t + c; // Perform rotation-specific matrix multiplication

  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateY(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function mat4_fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function mat4_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function mat4_fromRotation(out, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c; // Perform rotation-specific matrix multiplication

  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromXRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromYRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = 0;
  out[2] = -s;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromZRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromRotationTranslation(out, q, v) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */

function fromQuat2(out, a) {
  var translation = new ARRAY_TYPE(3);
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense

  if (magnitude > 0) {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
  } else {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  }

  fromRotationTranslation(out, a, translation);
  return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m22 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */

function getRotation(out, mat) {
  var scaling = new ARRAY_TYPE(3);
  getScaling(scaling, mat);
  var is1 = 1 / scaling[0];
  var is2 = 1 / scaling[1];
  var is3 = 1 / scaling[2];
  var sm11 = mat[0] * is1;
  var sm12 = mat[1] * is2;
  var sm13 = mat[2] * is3;
  var sm21 = mat[4] * is1;
  var sm22 = mat[5] * is2;
  var sm23 = mat[6] * is3;
  var sm31 = mat[8] * is1;
  var sm32 = mat[9] * is2;
  var sm33 = mat[10] * is3;
  var trace = sm11 + sm22 + sm33;
  var S = 0;

  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (sm23 - sm32) / S;
    out[1] = (sm31 - sm13) / S;
    out[2] = (sm12 - sm21) / S;
  } else if (sm11 > sm22 && sm11 > sm33) {
    S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
    out[3] = (sm23 - sm32) / S;
    out[0] = 0.25 * S;
    out[1] = (sm12 + sm21) / S;
    out[2] = (sm31 + sm13) / S;
  } else if (sm22 > sm33) {
    S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
    out[3] = (sm31 - sm13) / S;
    out[0] = (sm12 + sm21) / S;
    out[1] = 0.25 * S;
    out[2] = (sm23 + sm32) / S;
  } else {
    S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
    out[3] = (sm12 - sm21) / S;
    out[0] = (sm31 + sm13) / S;
    out[1] = (sm23 + sm32) / S;
    out[2] = 0.25 * S;
  }

  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */

function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */

function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  var ox = o[0];
  var oy = o[1];
  var oz = o[2];
  var out0 = (1 - (yy + zz)) * sx;
  var out1 = (xy + wz) * sx;
  var out2 = (xz - wy) * sx;
  var out4 = (xy - wz) * sy;
  var out5 = (1 - (xx + zz)) * sy;
  var out6 = (yz + wx) * sy;
  var out8 = (xz + wy) * sz;
  var out9 = (yz - wx) * sz;
  var out10 = (1 - (xx + yy)) * sz;
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = 0;
  out[4] = out4;
  out[5] = out5;
  out[6] = out6;
  out[7] = 0;
  out[8] = out8;
  out[9] = out9;
  out[10] = out10;
  out[11] = 0;
  out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
  out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
  out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
  out[15] = 1;
  return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */

function mat4_fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */

function frustum(out, left, right, bottom, top, near, far) {
  var rl = 1 / (right - left);
  var tb = 1 / (top - bottom);
  var nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveNO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }

  return out;
}
/**
 * Alias for {@link mat4.perspectiveNO}
 * @function
 */

var perspective = perspectiveNO;
/**
 * Generates a perspective projection matrix suitable for WebGPU with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveZO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = far * nf;
    out[14] = far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -near;
  }

  return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function perspectiveFromFieldOfView(out, fov, near, far) {
  var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
  var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
  var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
  var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
  var xScale = 2.0 / (leftTan + rightTan);
  var yScale = 2.0 / (upTan + downTan);
  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = (upTan - downTan) * yScale * 0.5;
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = far * near / (near - far);
  out[15] = 0.0;
  return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoNO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.orthoNO}
 * @function
 */

var ortho = orthoNO;
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoZO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = near * nf;
  out[15] = 1;
  return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function lookAt(out, eye, center, up) {
  var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  var eyex = eye[0];
  var eyey = eye[1];
  var eyez = eye[2];
  var upx = up[0];
  var upy = up[1];
  var upz = up[2];
  var centerx = center[0];
  var centery = center[1];
  var centerz = center[2];

  if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) {
    return mat4_identity(out);
  }

  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len = 1 / Math.hypot(z0, z1, z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;
  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.hypot(x0, x1, x2);

  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;
  len = Math.hypot(y0, y1, y2);

  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }

  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function targetTo(out, eye, target, up) {
  var eyex = eye[0],
      eyey = eye[1],
      eyez = eye[2],
      upx = up[0],
      upy = up[1],
      upz = up[2];
  var z0 = eyex - target[0],
      z1 = eyey - target[1],
      z2 = eyez - target[2];
  var len = z0 * z0 + z1 * z1 + z2 * z2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }

  var x0 = upy * z2 - upz * z1,
      x1 = upz * z0 - upx * z2,
      x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat4_str(a) {
  return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat4_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */

function mat4_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */

function mat4_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  out[9] = a[9] + b[9] * scale;
  out[10] = a[10] + b[10] * scale;
  out[11] = a[11] + b[11] * scale;
  out[12] = a[12] + b[12] * scale;
  out[13] = a[13] + b[13] * scale;
  out[14] = a[14] + b[14] * scale;
  out[15] = a[15] + b[15] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat4_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat4_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var a8 = a[8],
      a9 = a[9],
      a10 = a[10],
      a11 = a[11];
  var a12 = a[12],
      a13 = a[13],
      a14 = a[14],
      a15 = a[15];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  var b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  var b8 = b[8],
      b9 = b[9],
      b10 = b[10],
      b11 = b[11];
  var b12 = b[12],
      b13 = b[13],
      b14 = b[14],
      b15 = b[15];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mat4_mul = mat4_multiply;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */

var mat4_sub = mat4_subtract;
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec3.js

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function vec3_create() {
  var out = new ARRAY_TYPE(3);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function vec3_clone(a) {
  var out = new ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec3_length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function vec3_fromValues(x, y, z) {
  var out = new ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function vec3_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function vec3_set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function vec3_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function vec3_dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  var z = RANDOM() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3];
  var x = a[0],
      y = a[1],
      z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
      uvy = qz * x - qx * z,
      uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
      uuvy = qz * uvx - qx * uvz,
      uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateX(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateY(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateZ(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      bx = b[0],
      by = b[1],
      bz = b[2],
      mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
      mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
      mag = mag1 * mag2,
      cosine = mag && vec3_dot(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec3_str(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec3_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec3_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var vec3_sub = vec3_subtract;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var vec3_mul = vec3_multiply;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var len = vec3_length;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = vec3_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec4.js

/**
 * 4 Dimensional Vector
 * @module vec4
 */

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */

function vec4_create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }

  return out;
}
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {ReadonlyVec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */

function vec4_clone(a) {
  var out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */

function vec4_fromValues(x, y, z, w) {
  var out = new ARRAY_TYPE(4);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the source vector
 * @returns {vec4} out
 */

function vec4_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */

function vec4_set(out, x, y, z, w) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  out[3] = a[3] * b[3];
  return out;
}
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  out[3] = a[3] / b[3];
  return out;
}
/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to ceil
 * @returns {vec4} out
 */

function vec4_ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  out[3] = Math.ceil(a[3]);
  return out;
}
/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to floor
 * @returns {vec4} out
 */

function vec4_floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  out[3] = Math.floor(a[3]);
  return out;
}
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  out[3] = Math.min(a[3], b[3]);
  return out;
}
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  out[3] = Math.max(a[3], b[3]);
  return out;
}
/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to round
 * @returns {vec4} out
 */

function vec4_round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  out[3] = Math.round(a[3]);
  return out;
}
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */

function vec4_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */

function vec4_scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} distance between a and b
 */

function vec4_distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} squared distance between a and b
 */

function vec4_squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Calculates the length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec4_length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function vec4_squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to negate
 * @returns {vec4} out
 */

function vec4_negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = -a[3];
  return out;
}
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to invert
 * @returns {vec4} out
 */

function vec4_inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  out[3] = 1.0 / a[3];
  return out;
}
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to normalize
 * @returns {vec4} out
 */

function vec4_normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  var len = x * x + y * y + z * z + w * w;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }

  out[0] = x * len;
  out[1] = y * len;
  out[2] = z * len;
  out[3] = w * len;
  return out;
}
/**
 * Calculates the dot product of two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
/**
 * Returns the cross-product of three vectors in a 4-dimensional space
 *
 * @param {ReadonlyVec4} result the receiving vector
 * @param {ReadonlyVec4} U the first vector
 * @param {ReadonlyVec4} V the second vector
 * @param {ReadonlyVec4} W the third vector
 * @returns {vec4} result
 */

function vec4_cross(out, u, v, w) {
  var A = v[0] * w[1] - v[1] * w[0],
      B = v[0] * w[2] - v[2] * w[0],
      C = v[0] * w[3] - v[3] * w[0],
      D = v[1] * w[2] - v[2] * w[1],
      E = v[1] * w[3] - v[3] * w[1],
      F = v[2] * w[3] - v[3] * w[2];
  var G = u[0];
  var H = u[1];
  var I = u[2];
  var J = u[3];
  out[0] = H * F - I * E + J * D;
  out[1] = -(G * F) + I * C - J * B;
  out[2] = G * E - H * C + J * A;
  out[3] = -(G * D) + H * B - I * A;
  return out;
}
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec4} out
 */

function vec4_lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  var aw = a[3];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  out[3] = aw + t * (b[3] - aw);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */

function vec4_random(out, scale) {
  scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
  // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
  // http://projecteuclid.org/euclid.aoms/1177692644;

  var v1, v2, v3, v4;
  var s1, s2;

  do {
    v1 = RANDOM() * 2 - 1;
    v2 = RANDOM() * 2 - 1;
    s1 = v1 * v1 + v2 * v2;
  } while (s1 >= 1);

  do {
    v3 = RANDOM() * 2 - 1;
    v4 = RANDOM() * 2 - 1;
    s2 = v3 * v3 + v4 * v4;
  } while (s2 >= 1);

  var d = Math.sqrt((1 - s1) / s2);
  out[0] = scale * v1;
  out[1] = scale * v2;
  out[2] = scale * v3 * d;
  out[3] = scale * v4 * d;
  return out;
}
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec4} out
 */

function vec4_transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
  return out;
}
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec4} out
 */

function vec4_transformQuat(out, a, q) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3]; // calculate quat * vec

  var ix = qw * x + qy * z - qz * y;
  var iy = qw * y + qz * x - qx * z;
  var iz = qw * z + qx * y - qy * x;
  var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat

  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to zero
 *
 * @param {vec4} out the receiving vector
 * @returns {vec4} out
 */

function vec4_zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec4_str(a) {
  return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec4_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec4_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
/**
 * Alias for {@link vec4.subtract}
 * @function
 */

var vec4_sub = vec4_subtract;
/**
 * Alias for {@link vec4.multiply}
 * @function
 */

var vec4_mul = vec4_multiply;
/**
 * Alias for {@link vec4.divide}
 * @function
 */

var vec4_div = vec4_divide;
/**
 * Alias for {@link vec4.distance}
 * @function
 */

var vec4_dist = vec4_distance;
/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */

var vec4_sqrDist = vec4_squaredDistance;
/**
 * Alias for {@link vec4.length}
 * @function
 */

var vec4_len = vec4_length;
/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */

var vec4_sqrLen = vec4_squaredLength;
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var vec4_forEach = function () {
  var vec = vec4_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 4;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      vec[3] = a[i + 3];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
      a[i + 3] = vec[3];
    }

    return a;
  };
}();
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/quat.js




/**
 * Quaternion
 * @module quat
 */

/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */

function quat_create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  out[3] = 1;
  return out;
}
/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function quat_identity(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyVec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/

function setAxisAngle(out, axis, rad) {
  rad = rad * 0.5;
  var s = Math.sin(rad);
  out[0] = s * axis[0];
  out[1] = s * axis[1];
  out[2] = s * axis[2];
  out[3] = Math.cos(rad);
  return out;
}
/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {ReadonlyQuat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */

function getAxisAngle(out_axis, q) {
  var rad = Math.acos(q[3]) * 2.0;
  var s = Math.sin(rad / 2.0);

  if (s > EPSILON) {
    out_axis[0] = q[0] / s;
    out_axis[1] = q[1] / s;
    out_axis[2] = q[2] / s;
  } else {
    // If s is zero, return any axis (no rotation - axis does not matter)
    out_axis[0] = 1;
    out_axis[1] = 0;
    out_axis[2] = 0;
  }

  return rad;
}
/**
 * Gets the angular distance between two unit quaternions
 *
 * @param  {ReadonlyQuat} a     Origin unit quaternion
 * @param  {ReadonlyQuat} b     Destination unit quaternion
 * @return {Number}     Angle, in radians, between the two quaternions
 */

function getAngle(a, b) {
  var dotproduct = quat_dot(a, b);
  return Math.acos(2 * dotproduct * dotproduct - 1);
}
/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 */

function quat_multiply(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  out[0] = ax * bw + aw * bx + ay * bz - az * by;
  out[1] = ay * bw + aw * by + az * bx - ax * bz;
  out[2] = az * bw + aw * bz + ax * by - ay * bx;
  out[3] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateX(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + aw * bx;
  out[1] = ay * bw + az * bx;
  out[2] = az * bw - ay * bx;
  out[3] = aw * bw - ax * bx;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateY(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var by = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw - az * by;
  out[1] = ay * bw + aw * by;
  out[2] = az * bw + ax * by;
  out[3] = aw * bw - ay * by;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateZ(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bz = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + ay * bz;
  out[1] = ay * bw - ax * bz;
  out[2] = az * bw + aw * bz;
  out[3] = aw * bw - az * bz;
  return out;
}
/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate W component of
 * @returns {quat} out
 */

function calculateW(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
  return out;
}
/**
 * Calculate the exponential of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function exp(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var et = Math.exp(w);
  var s = r > 0 ? et * Math.sin(r) / r : 0;
  out[0] = x * s;
  out[1] = y * s;
  out[2] = z * s;
  out[3] = et * Math.cos(r);
  return out;
}
/**
 * Calculate the natural logarithm of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function ln(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var t = r > 0 ? Math.atan2(r, w) / r : 0;
  out[0] = x * t;
  out[1] = y * t;
  out[2] = z * t;
  out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
  return out;
}
/**
 * Calculate the scalar power of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @param {Number} b amount to scale the quaternion by
 * @returns {quat} out
 */

function pow(out, a, b) {
  ln(out, a);
  quat_scale(out, out, b);
  exp(out, out);
  return out;
}
/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

function slerp(out, a, b, t) {
  // benchmarks:
  //    http://jsperf.com/quaternion-slerp-implementations
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  var omega, cosom, sinom, scale0, scale1; // calc cosine

  cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)

  if (cosom < 0.0) {
    cosom = -cosom;
    bx = -bx;
    by = -by;
    bz = -bz;
    bw = -bw;
  } // calculate coefficients


  if (1.0 - cosom > EPSILON) {
    // standard case (slerp)
    omega = Math.acos(cosom);
    sinom = Math.sin(omega);
    scale0 = Math.sin((1.0 - t) * omega) / sinom;
    scale1 = Math.sin(t * omega) / sinom;
  } else {
    // "from" and "to" quaternions are very close
    //  ... so we can do a linear interpolation
    scale0 = 1.0 - t;
    scale1 = t;
  } // calculate final values


  out[0] = scale0 * ax + scale1 * bx;
  out[1] = scale0 * ay + scale1 * by;
  out[2] = scale0 * az + scale1 * bz;
  out[3] = scale0 * aw + scale1 * bw;
  return out;
}
/**
 * Generates a random unit quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function quat_random(out) {
  // Implementation of http://planning.cs.uiuc.edu/node198.html
  // TODO: Calling random 3 times is probably not the fastest solution
  var u1 = RANDOM();
  var u2 = RANDOM();
  var u3 = RANDOM();
  var sqrt1MinusU1 = Math.sqrt(1 - u1);
  var sqrtU1 = Math.sqrt(u1);
  out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
  out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
  out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
  out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
  return out;
}
/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate inverse of
 * @returns {quat} out
 */

function quat_invert(out, a) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
  var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0

  out[0] = -a0 * invDot;
  out[1] = -a1 * invDot;
  out[2] = -a2 * invDot;
  out[3] = a3 * invDot;
  return out;
}
/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate conjugate of
 * @returns {quat} out
 */

function conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyMat3} m rotation matrix
 * @returns {quat} out
 * @function
 */

function fromMat3(out, m) {
  // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
  // article "Quaternion Calculus and Fast Animation".
  var fTrace = m[0] + m[4] + m[8];
  var fRoot;

  if (fTrace > 0.0) {
    // |w| > 1/2, may as well choose w > 1/2
    fRoot = Math.sqrt(fTrace + 1.0); // 2w

    out[3] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot; // 1/(4w)

    out[0] = (m[5] - m[7]) * fRoot;
    out[1] = (m[6] - m[2]) * fRoot;
    out[2] = (m[1] - m[3]) * fRoot;
  } else {
    // |w| <= 1/2
    var i = 0;
    if (m[4] > m[0]) i = 1;
    if (m[8] > m[i * 3 + i]) i = 2;
    var j = (i + 1) % 3;
    var k = (i + 2) % 3;
    fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
    out[i] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
    out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
    out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
  }

  return out;
}
/**
 * Creates a quaternion from the given euler angle x, y, z.
 *
 * @param {quat} out the receiving quaternion
 * @param {x} Angle to rotate around X axis in degrees.
 * @param {y} Angle to rotate around Y axis in degrees.
 * @param {z} Angle to rotate around Z axis in degrees.
 * @returns {quat} out
 * @function
 */

function fromEuler(out, x, y, z) {
  var halfToRad = 0.5 * Math.PI / 180.0;
  x *= halfToRad;
  y *= halfToRad;
  z *= halfToRad;
  var sx = Math.sin(x);
  var cx = Math.cos(x);
  var sy = Math.sin(y);
  var cy = Math.cos(y);
  var sz = Math.sin(z);
  var cz = Math.cos(z);
  out[0] = sx * cy * cz - cx * sy * sz;
  out[1] = cx * sy * cz + sx * cy * sz;
  out[2] = cx * cy * sz - sx * sy * cz;
  out[3] = cx * cy * cz + sx * sy * sz;
  return out;
}
/**
 * Returns a string representation of a quatenion
 *
 * @param {ReadonlyQuat} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function quat_str(a) {
  return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {ReadonlyQuat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */

var quat_clone = vec4_clone;
/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */

var quat_fromValues = vec4_fromValues;
/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the source quaternion
 * @returns {quat} out
 * @function
 */

var quat_copy = vec4_copy;
/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */

var quat_set = vec4_set;
/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 * @function
 */

var quat_add = vec4_add;
/**
 * Alias for {@link quat.multiply}
 * @function
 */

var quat_mul = quat_multiply;
/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {ReadonlyQuat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */

var quat_scale = vec4_scale;
/**
 * Calculates the dot product of two quat's
 *
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */

var quat_dot = dot;
/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 * @function
 */

var quat_lerp = vec4_lerp;
/**
 * Calculates the length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate length of
 * @returns {Number} length of a
 */

var quat_length = vec4_length;
/**
 * Alias for {@link quat.length}
 * @function
 */

var quat_len = quat_length;
/**
 * Calculates the squared length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */

var quat_squaredLength = vec4_squaredLength;
/**
 * Alias for {@link quat.squaredLength}
 * @function
 */

var quat_sqrLen = quat_squaredLength;
/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */

var quat_normalize = vec4_normalize;
/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyQuat} a The first quaternion.
 * @param {ReadonlyQuat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var quat_exactEquals = vec4_exactEquals;
/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {ReadonlyQuat} a The first vector.
 * @param {ReadonlyQuat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var quat_equals = vec4_equals;
/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {ReadonlyVec3} a the initial vector
 * @param {ReadonlyVec3} b the destination vector
 * @returns {quat} out
 */

var rotationTo = function () {
  var tmpvec3 = vec3_create();
  var xUnitVec3 = vec3_fromValues(1, 0, 0);
  var yUnitVec3 = vec3_fromValues(0, 1, 0);
  return function (out, a, b) {
    var dot = vec3_dot(a, b);

    if (dot < -0.999999) {
      cross(tmpvec3, xUnitVec3, a);
      if (len(tmpvec3) < 0.000001) cross(tmpvec3, yUnitVec3, a);
      normalize(tmpvec3, tmpvec3);
      setAxisAngle(out, tmpvec3, Math.PI);
      return out;
    } else if (dot > 0.999999) {
      out[0] = 0;
      out[1] = 0;
      out[2] = 0;
      out[3] = 1;
      return out;
    } else {
      cross(tmpvec3, a, b);
      out[0] = tmpvec3[0];
      out[1] = tmpvec3[1];
      out[2] = tmpvec3[2];
      out[3] = 1 + dot;
      return quat_normalize(out, out);
    }
  };
}();
/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {ReadonlyQuat} c the third operand
 * @param {ReadonlyQuat} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

var sqlerp = function () {
  var temp1 = quat_create();
  var temp2 = quat_create();
  return function (out, a, b, c, d, t) {
    slerp(temp1, a, d, t);
    slerp(temp2, b, c, t);
    slerp(out, temp1, temp2, 2 * t * (1 - t));
    return out;
  };
}();
/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {ReadonlyVec3} view  the vector representing the viewing direction
 * @param {ReadonlyVec3} right the vector representing the local "right" direction
 * @param {ReadonlyVec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */

var setAxes = function () {
  var matr = mat3_create();
  return function (out, view, right, up) {
    matr[0] = right[0];
    matr[3] = right[1];
    matr[6] = right[2];
    matr[1] = up[0];
    matr[4] = up[1];
    matr[7] = up[2];
    matr[2] = -view[0];
    matr[5] = -view[1];
    matr[8] = -view[2];
    return quat_normalize(out, fromMat3(out, matr));
  };
}();
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/quat2.js



/**
 * Dual Quaternion<br>
 * Format: [real, dual]<br>
 * Quaternion format: XYZW<br>
 * Make sure to have normalized dual quaternions, otherwise the functions may not work as intended.<br>
 * @module quat2
 */

/**
 * Creates a new identity dual quat
 *
 * @returns {quat2} a new dual quaternion [real -> rotation, dual -> translation]
 */

function quat2_create() {
  var dq = new ARRAY_TYPE(8);

  if (ARRAY_TYPE != Float32Array) {
    dq[0] = 0;
    dq[1] = 0;
    dq[2] = 0;
    dq[4] = 0;
    dq[5] = 0;
    dq[6] = 0;
    dq[7] = 0;
  }

  dq[3] = 1;
  return dq;
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {ReadonlyQuat2} a dual quaternion to clone
 * @returns {quat2} new dual quaternion
 * @function
 */

function quat2_clone(a) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = a[0];
  dq[1] = a[1];
  dq[2] = a[2];
  dq[3] = a[3];
  dq[4] = a[4];
  dq[5] = a[5];
  dq[6] = a[6];
  dq[7] = a[7];
  return dq;
}
/**
 * Creates a new dual quat initialized with the given values
 *
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component
 * @param {Number} y2 Y component
 * @param {Number} z2 Z component
 * @param {Number} w2 W component
 * @returns {quat2} new dual quaternion
 * @function
 */

function quat2_fromValues(x1, y1, z1, w1, x2, y2, z2, w2) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = x1;
  dq[1] = y1;
  dq[2] = z1;
  dq[3] = w1;
  dq[4] = x2;
  dq[5] = y2;
  dq[6] = z2;
  dq[7] = w2;
  return dq;
}
/**
 * Creates a new dual quat from the given values (quat and translation)
 *
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component (translation)
 * @param {Number} y2 Y component (translation)
 * @param {Number} z2 Z component (translation)
 * @returns {quat2} new dual quaternion
 * @function
 */

function fromRotationTranslationValues(x1, y1, z1, w1, x2, y2, z2) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = x1;
  dq[1] = y1;
  dq[2] = z1;
  dq[3] = w1;
  var ax = x2 * 0.5,
      ay = y2 * 0.5,
      az = z2 * 0.5;
  dq[4] = ax * w1 + ay * z1 - az * y1;
  dq[5] = ay * w1 + az * x1 - ax * z1;
  dq[6] = az * w1 + ax * y1 - ay * x1;
  dq[7] = -ax * x1 - ay * y1 - az * z1;
  return dq;
}
/**
 * Creates a dual quat from a quaternion and a translation
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyQuat} q a normalized quaternion
 * @param {ReadonlyVec3} t tranlation vector
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromRotationTranslation(out, q, t) {
  var ax = t[0] * 0.5,
      ay = t[1] * 0.5,
      az = t[2] * 0.5,
      bx = q[0],
      by = q[1],
      bz = q[2],
      bw = q[3];
  out[0] = bx;
  out[1] = by;
  out[2] = bz;
  out[3] = bw;
  out[4] = ax * bw + ay * bz - az * by;
  out[5] = ay * bw + az * bx - ax * bz;
  out[6] = az * bw + ax * by - ay * bx;
  out[7] = -ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Creates a dual quat from a translation
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyVec3} t translation vector
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromTranslation(out, t) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = t[0] * 0.5;
  out[5] = t[1] * 0.5;
  out[6] = t[2] * 0.5;
  out[7] = 0;
  return out;
}
/**
 * Creates a dual quat from a quaternion
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyQuat} q the quaternion
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromRotation(out, q) {
  out[0] = q[0];
  out[1] = q[1];
  out[2] = q[2];
  out[3] = q[3];
  out[4] = 0;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  return out;
}
/**
 * Creates a new dual quat from a matrix (4x4)
 *
 * @param {quat2} out the dual quaternion
 * @param {ReadonlyMat4} a the matrix
 * @returns {quat2} dual quat receiving operation result
 * @function
 */

function quat2_fromMat4(out, a) {
  //TODO Optimize this
  var outer = quat_create();
  getRotation(outer, a);
  var t = new ARRAY_TYPE(3);
  getTranslation(t, a);
  quat2_fromRotationTranslation(out, outer, t);
  return out;
}
/**
 * Copy the values from one dual quat to another
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the source dual quaternion
 * @returns {quat2} out
 * @function
 */

function quat2_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  return out;
}
/**
 * Set a dual quat to the identity dual quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @returns {quat2} out
 */

function quat2_identity(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  return out;
}
/**
 * Set the components of a dual quat to the given values
 *
 * @param {quat2} out the receiving quaternion
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component
 * @param {Number} y2 Y component
 * @param {Number} z2 Z component
 * @param {Number} w2 W component
 * @returns {quat2} out
 * @function
 */

function quat2_set(out, x1, y1, z1, w1, x2, y2, z2, w2) {
  out[0] = x1;
  out[1] = y1;
  out[2] = z1;
  out[3] = w1;
  out[4] = x2;
  out[5] = y2;
  out[6] = z2;
  out[7] = w2;
  return out;
}
/**
 * Gets the real part of a dual quat
 * @param  {quat} out real part
 * @param  {ReadonlyQuat2} a Dual Quaternion
 * @return {quat} real part
 */

var getReal = quat_copy;
/**
 * Gets the dual part of a dual quat
 * @param  {quat} out dual part
 * @param  {ReadonlyQuat2} a Dual Quaternion
 * @return {quat} dual part
 */

function getDual(out, a) {
  out[0] = a[4];
  out[1] = a[5];
  out[2] = a[6];
  out[3] = a[7];
  return out;
}
/**
 * Set the real component of a dual quat to the given quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat} q a quaternion representing the real part
 * @returns {quat2} out
 * @function
 */

var setReal = quat_copy;
/**
 * Set the dual component of a dual quat to the given quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat} q a quaternion representing the dual part
 * @returns {quat2} out
 * @function
 */

function setDual(out, q) {
  out[4] = q[0];
  out[5] = q[1];
  out[6] = q[2];
  out[7] = q[3];
  return out;
}
/**
 * Gets the translation of a normalized dual quat
 * @param  {vec3} out translation
 * @param  {ReadonlyQuat2} a Dual Quaternion to be decomposed
 * @return {vec3} translation
 */

function quat2_getTranslation(out, a) {
  var ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3];
  out[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
  out[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
  out[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  return out;
}
/**
 * Translates a dual quat by the given vector
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {quat2} out
 */

function quat2_translate(out, a, v) {
  var ax1 = a[0],
      ay1 = a[1],
      az1 = a[2],
      aw1 = a[3],
      bx1 = v[0] * 0.5,
      by1 = v[1] * 0.5,
      bz1 = v[2] * 0.5,
      ax2 = a[4],
      ay2 = a[5],
      az2 = a[6],
      aw2 = a[7];
  out[0] = ax1;
  out[1] = ay1;
  out[2] = az1;
  out[3] = aw1;
  out[4] = aw1 * bx1 + ay1 * bz1 - az1 * by1 + ax2;
  out[5] = aw1 * by1 + az1 * bx1 - ax1 * bz1 + ay2;
  out[6] = aw1 * bz1 + ax1 * by1 - ay1 * bx1 + az2;
  out[7] = -ax1 * bx1 - ay1 * by1 - az1 * bz1 + aw2;
  return out;
}
/**
 * Rotates a dual quat around the X axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateX(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateX(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat around the Y axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateY(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateY(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat around the Z axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateZ(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateZ(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat by a given quaternion (a * q)
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {ReadonlyQuat} q quaternion to rotate by
 * @returns {quat2} out
 */

function rotateByQuatAppend(out, a, q) {
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3],
      ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  out[0] = ax * qw + aw * qx + ay * qz - az * qy;
  out[1] = ay * qw + aw * qy + az * qx - ax * qz;
  out[2] = az * qw + aw * qz + ax * qy - ay * qx;
  out[3] = aw * qw - ax * qx - ay * qy - az * qz;
  ax = a[4];
  ay = a[5];
  az = a[6];
  aw = a[7];
  out[4] = ax * qw + aw * qx + ay * qz - az * qy;
  out[5] = ay * qw + aw * qy + az * qx - ax * qz;
  out[6] = az * qw + aw * qz + ax * qy - ay * qx;
  out[7] = aw * qw - ax * qx - ay * qy - az * qz;
  return out;
}
/**
 * Rotates a dual quat by a given quaternion (q * a)
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat} q quaternion to rotate by
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @returns {quat2} out
 */

function rotateByQuatPrepend(out, q, a) {
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3],
      bx = a[0],
      by = a[1],
      bz = a[2],
      bw = a[3];
  out[0] = qx * bw + qw * bx + qy * bz - qz * by;
  out[1] = qy * bw + qw * by + qz * bx - qx * bz;
  out[2] = qz * bw + qw * bz + qx * by - qy * bx;
  out[3] = qw * bw - qx * bx - qy * by - qz * bz;
  bx = a[4];
  by = a[5];
  bz = a[6];
  bw = a[7];
  out[4] = qx * bw + qw * bx + qy * bz - qz * by;
  out[5] = qy * bw + qw * by + qz * bx - qx * bz;
  out[6] = qz * bw + qw * bz + qx * by - qy * bx;
  out[7] = qw * bw - qx * bx - qy * by - qz * bz;
  return out;
}
/**
 * Rotates a dual quat around a given axis. Does the normalisation automatically
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @param {Number} rad how far the rotation should be
 * @returns {quat2} out
 */

function rotateAroundAxis(out, a, axis, rad) {
  //Special case for rad = 0
  if (Math.abs(rad) < EPSILON) {
    return quat2_copy(out, a);
  }

  var axisLength = Math.hypot(axis[0], axis[1], axis[2]);
  rad = rad * 0.5;
  var s = Math.sin(rad);
  var bx = s * axis[0] / axisLength;
  var by = s * axis[1] / axisLength;
  var bz = s * axis[2] / axisLength;
  var bw = Math.cos(rad);
  var ax1 = a[0],
      ay1 = a[1],
      az1 = a[2],
      aw1 = a[3];
  out[0] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[1] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[2] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[3] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  var ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  out[4] = ax * bw + aw * bx + ay * bz - az * by;
  out[5] = ay * bw + aw * by + az * bx - ax * bz;
  out[6] = az * bw + aw * bz + ax * by - ay * bx;
  out[7] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Adds two dual quat's
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {quat2} out
 * @function
 */

function quat2_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  return out;
}
/**
 * Multiplies two dual quat's
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {quat2} out
 */

function quat2_multiply(out, a, b) {
  var ax0 = a[0],
      ay0 = a[1],
      az0 = a[2],
      aw0 = a[3],
      bx1 = b[4],
      by1 = b[5],
      bz1 = b[6],
      bw1 = b[7],
      ax1 = a[4],
      ay1 = a[5],
      az1 = a[6],
      aw1 = a[7],
      bx0 = b[0],
      by0 = b[1],
      bz0 = b[2],
      bw0 = b[3];
  out[0] = ax0 * bw0 + aw0 * bx0 + ay0 * bz0 - az0 * by0;
  out[1] = ay0 * bw0 + aw0 * by0 + az0 * bx0 - ax0 * bz0;
  out[2] = az0 * bw0 + aw0 * bz0 + ax0 * by0 - ay0 * bx0;
  out[3] = aw0 * bw0 - ax0 * bx0 - ay0 * by0 - az0 * bz0;
  out[4] = ax0 * bw1 + aw0 * bx1 + ay0 * bz1 - az0 * by1 + ax1 * bw0 + aw1 * bx0 + ay1 * bz0 - az1 * by0;
  out[5] = ay0 * bw1 + aw0 * by1 + az0 * bx1 - ax0 * bz1 + ay1 * bw0 + aw1 * by0 + az1 * bx0 - ax1 * bz0;
  out[6] = az0 * bw1 + aw0 * bz1 + ax0 * by1 - ay0 * bx1 + az1 * bw0 + aw1 * bz0 + ax1 * by0 - ay1 * bx0;
  out[7] = aw0 * bw1 - ax0 * bx1 - ay0 * by1 - az0 * bz1 + aw1 * bw0 - ax1 * bx0 - ay1 * by0 - az1 * bz0;
  return out;
}
/**
 * Alias for {@link quat2.multiply}
 * @function
 */

var quat2_mul = quat2_multiply;
/**
 * Scales a dual quat by a scalar number
 *
 * @param {quat2} out the receiving dual quat
 * @param {ReadonlyQuat2} a the dual quat to scale
 * @param {Number} b amount to scale the dual quat by
 * @returns {quat2} out
 * @function
 */

function quat2_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  return out;
}
/**
 * Calculates the dot product of two dual quat's (The dot product of the real parts)
 *
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */

var quat2_dot = quat_dot;
/**
 * Performs a linear interpolation between two dual quats's
 * NOTE: The resulting dual quaternions won't always be normalized (The error is most noticeable when t = 0.5)
 *
 * @param {quat2} out the receiving dual quat
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat2} out
 */

function quat2_lerp(out, a, b, t) {
  var mt = 1 - t;
  if (quat2_dot(a, b) < 0) t = -t;
  out[0] = a[0] * mt + b[0] * t;
  out[1] = a[1] * mt + b[1] * t;
  out[2] = a[2] * mt + b[2] * t;
  out[3] = a[3] * mt + b[3] * t;
  out[4] = a[4] * mt + b[4] * t;
  out[5] = a[5] * mt + b[5] * t;
  out[6] = a[6] * mt + b[6] * t;
  out[7] = a[7] * mt + b[7] * t;
  return out;
}
/**
 * Calculates the inverse of a dual quat. If they are normalized, conjugate is cheaper
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a dual quat to calculate inverse of
 * @returns {quat2} out
 */

function quat2_invert(out, a) {
  var sqlen = quat2_squaredLength(a);
  out[0] = -a[0] / sqlen;
  out[1] = -a[1] / sqlen;
  out[2] = -a[2] / sqlen;
  out[3] = a[3] / sqlen;
  out[4] = -a[4] / sqlen;
  out[5] = -a[5] / sqlen;
  out[6] = -a[6] / sqlen;
  out[7] = a[7] / sqlen;
  return out;
}
/**
 * Calculates the conjugate of a dual quat
 * If the dual quaternion is normalized, this function is faster than quat2.inverse and produces the same result.
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat2} a quat to calculate conjugate of
 * @returns {quat2} out
 */

function quat2_conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  out[4] = -a[4];
  out[5] = -a[5];
  out[6] = -a[6];
  out[7] = a[7];
  return out;
}
/**
 * Calculates the length of a dual quat
 *
 * @param {ReadonlyQuat2} a dual quat to calculate length of
 * @returns {Number} length of a
 * @function
 */

var quat2_length = quat_length;
/**
 * Alias for {@link quat2.length}
 * @function
 */

var quat2_len = quat2_length;
/**
 * Calculates the squared length of a dual quat
 *
 * @param {ReadonlyQuat2} a dual quat to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */

var quat2_squaredLength = quat_squaredLength;
/**
 * Alias for {@link quat2.squaredLength}
 * @function
 */

var quat2_sqrLen = quat2_squaredLength;
/**
 * Normalize a dual quat
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a dual quaternion to normalize
 * @returns {quat2} out
 * @function
 */

function quat2_normalize(out, a) {
  var magnitude = quat2_squaredLength(a);

  if (magnitude > 0) {
    magnitude = Math.sqrt(magnitude);
    var a0 = a[0] / magnitude;
    var a1 = a[1] / magnitude;
    var a2 = a[2] / magnitude;
    var a3 = a[3] / magnitude;
    var b0 = a[4];
    var b1 = a[5];
    var b2 = a[6];
    var b3 = a[7];
    var a_dot_b = a0 * b0 + a1 * b1 + a2 * b2 + a3 * b3;
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = (b0 - a0 * a_dot_b) / magnitude;
    out[5] = (b1 - a1 * a_dot_b) / magnitude;
    out[6] = (b2 - a2 * a_dot_b) / magnitude;
    out[7] = (b3 - a3 * a_dot_b) / magnitude;
  }

  return out;
}
/**
 * Returns a string representation of a dual quatenion
 *
 * @param {ReadonlyQuat2} a dual quaternion to represent as a string
 * @returns {String} string representation of the dual quat
 */

function quat2_str(a) {
  return "quat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ")";
}
/**
 * Returns whether or not the dual quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyQuat2} a the first dual quaternion.
 * @param {ReadonlyQuat2} b the second dual quaternion.
 * @returns {Boolean} true if the dual quaternions are equal, false otherwise.
 */

function quat2_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7];
}
/**
 * Returns whether or not the dual quaternions have approximately the same elements in the same position.
 *
 * @param {ReadonlyQuat2} a the first dual quat.
 * @param {ReadonlyQuat2} b the second dual quat.
 * @returns {Boolean} true if the dual quats are equal, false otherwise.
 */

function quat2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7));
}
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec2.js

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function vec2_create() {
  var out = new ARRAY_TYPE(2);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {ReadonlyVec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */

function vec2_clone(a) {
  var out = new ARRAY_TYPE(2);
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */

function vec2_fromValues(x, y) {
  var out = new ARRAY_TYPE(2);
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the source vector
 * @returns {vec2} out
 */

function vec2_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */

function vec2_set(out, x, y) {
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  return out;
}
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to ceil
 * @returns {vec2} out
 */

function vec2_ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to floor
 * @returns {vec2} out
 */

function vec2_floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to round
 * @returns {vec2} out
 */

function vec2_round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */

function vec2_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */

function vec2_scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} distance between a and b
 */

function vec2_distance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} squared distance between a and b
 */

function vec2_squaredDistance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return x * x + y * y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec2_length(a) {
  var x = a[0],
      y = a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function vec2_squaredLength(a) {
  var x = a[0],
      y = a[1];
  return x * x + y * y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to negate
 * @returns {vec2} out
 */

function vec2_negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to invert
 * @returns {vec2} out
 */

function vec2_inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to normalize
 * @returns {vec2} out
 */

function vec2_normalize(out, a) {
  var x = a[0],
      y = a[1];
  var len = x * x + y * y;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} dot product of a and b
 */

function vec2_dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec3} out
 */

function vec2_cross(out, a, b) {
  var z = a[0] * b[1] - a[1] * b[0];
  out[0] = out[1] = 0;
  out[2] = z;
  return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec2} out
 */

function vec2_lerp(out, a, b, t) {
  var ax = a[0],
      ay = a[1];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */

function vec2_random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  out[0] = Math.cos(r) * scale;
  out[1] = Math.sin(r) * scale;
  return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2d} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2d(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat3} m matrix to transform with
 * @returns {vec2} out
 */

function vec2_transformMat3(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[3] * y + m[6];
  out[1] = m[1] * x + m[4] * y + m[7];
  return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec2} out
 */

function vec2_transformMat4(out, a, m) {
  var x = a[0];
  var y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}
/**
 * Rotate a 2D vector
 * @param {vec2} out The receiving vec2
 * @param {ReadonlyVec2} a The vec2 point to rotate
 * @param {ReadonlyVec2} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec2} out
 */

function vec2_rotate(out, a, b, rad) {
  //Translate point to the origin
  var p0 = a[0] - b[0],
      p1 = a[1] - b[1],
      sinC = Math.sin(rad),
      cosC = Math.cos(rad); //perform rotation and translate to correct position

  out[0] = p0 * cosC - p1 * sinC + b[0];
  out[1] = p0 * sinC + p1 * cosC + b[1];
  return out;
}
/**
 * Get the angle between two 2D vectors
 * @param {ReadonlyVec2} a The first operand
 * @param {ReadonlyVec2} b The second operand
 * @returns {Number} The angle in radians
 */

function vec2_angle(a, b) {
  var x1 = a[0],
      y1 = a[1],
      x2 = b[0],
      y2 = b[1],
      // mag is the product of the magnitudes of a and b
  mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2),
      // mag &&.. short circuits if mag == 0
  cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1

  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec2 to zero
 *
 * @param {vec2} out the receiving vector
 * @returns {vec2} out
 */

function vec2_zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec2_str(a) {
  return "vec2(" + a[0] + ", " + a[1] + ")";
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec2_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1];
  var b0 = b[0],
      b1 = b[1];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
/**
 * Alias for {@link vec2.length}
 * @function
 */

var vec2_len = vec2_length;
/**
 * Alias for {@link vec2.subtract}
 * @function
 */

var vec2_sub = vec2_subtract;
/**
 * Alias for {@link vec2.multiply}
 * @function
 */

var vec2_mul = vec2_multiply;
/**
 * Alias for {@link vec2.divide}
 * @function
 */

var vec2_div = vec2_divide;
/**
 * Alias for {@link vec2.distance}
 * @function
 */

var vec2_dist = vec2_distance;
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */

var vec2_sqrDist = vec2_squaredDistance;
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */

var vec2_sqrLen = vec2_squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var vec2_forEach = function () {
  var vec = vec2_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
}();
;// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/index.js












/***/ }),

/***/ 840:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),

/***/ 3638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\nuniform   sampler2D  u_texture;\nuniform   float      u_alpha;\nuniform   vec4       u_color;\nvarying   vec2       v_tCoord;\n\nvoid main() {\n    gl_FragColor = u_color * texture2D(u_texture, v_tCoord);\n    gl_FragColor.a *= u_alpha;\n}");

/***/ }),

/***/ 5297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("uniform    mat4   u_pvMatrix, u_mMatrix;\nuniform    float  u_width, u_height;\nattribute  vec3   a_vCoord;\nattribute  vec2   a_size, a_tCoord;\nvarying    vec2   v_tCoord;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_vCoord, 1.);\n    gl_Position.x += a_size.x / u_width * gl_Position.w;\n    gl_Position.y += a_size.y / u_height * gl_Position.w;\n    v_tCoord = a_tCoord;\n}");

/***/ }),

/***/ 8032:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\n\nuniform    samplerCube   u_cubeTexture;\nuniform    mat4          u_mMatrix;\nuniform    float         u_radius;\nuniform    float         u_alpha;\nuniform    vec3          u_eyePosition;\nvarying    vec3          v_position;\n\nvoid main() {\n    vec3 d = v_position - u_eyePosition;\n    float a = dot(d, d),\n          b = 2. * dot(u_eyePosition, d),\n          c = dot(u_eyePosition, u_eyePosition) - u_radius*u_radius,\n          D = b*b - 4.*a*c,\n          t1, t2;\n    if (D < 0.)\n        discard;\n    t1 = (-b + sqrt(D)) / (2.*a);\n    t2 = (-b - sqrt(D)) / (2.*a);\n    vec3 dir1 = u_eyePosition + t1*d;\n    vec3 dir2 = u_eyePosition + t2*d;\n    float z = t2 * length(d);\n    gl_FragColor = textureCube(u_cubeTexture, (u_mMatrix * vec4(dir1, 1.)).yzx) +\n                   vec4(vec3(smoothstep(0., 1., z)), 0.) * textureCube(u_cubeTexture, (u_mMatrix * vec4(dir2, 1.)).yzx);\n\n    gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.));\n    // gl_FragColor = textureCube(u_cubeTexture, (u_mMatrix * vec4(dir1, 1.)).yzx);\n    gl_FragColor.a *= u_alpha;\n}");

/***/ }),

/***/ 1579:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\n\nuniform    mat4          u_pvMatrix;\nuniform    float         u_radius;\nattribute  vec3          a_position;\nvarying    vec3          v_position;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(u_radius * a_position, 1.);\n    v_position = u_radius * a_position;\n}");

/***/ }),

/***/ 7003:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\nuniform   sampler2D  u_texture1;\nuniform   sampler2D  u_shiftmap;\nuniform   mat3       u_tMatrix;\nuniform   float      u_alpha;\nvarying   vec2       v_coord;\nvarying   float      v_w;\n\n/*\n    // TypeScript\n    function encode(v: number) {\n        const VMAX = 0.015\n        return ((v / VMAX) + 1) / 2 * 256\n    }\n*/\n\nconst float VMAX = 0.015;\nvec2 decode_shiftmap(vec2 e) {\n    e *= 255. / 256.;\n    return (2. * e - 1.) * VMAX;\n}\n\nconst float DELTA_MAP_N = 64.;\nvec2 delta_coord(vec2 c) {\n    return (1./DELTA_MAP_N)*((DELTA_MAP_N-1.)*c + vec2(0.5));\n}\n\n\nvoid main() {\n    vec2 tCoord = (u_tMatrix * vec3(v_coord - decode_shiftmap(texture2D(u_shiftmap, delta_coord(v_coord)).xy), 1)).xy;\n    gl_FragColor = texture2D(u_texture1, tCoord);\n    gl_FragColor.a *= u_alpha * clamp(4. * (v_w - 0.2), 0., 1.);\n    // vec2 d = pow(2. * (v_coord - vec2(0.5)), vec2(10.));\n    // gl_FragColor.g += 0.75 * dot(d, d);\n}");

/***/ }),

/***/ 5259:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\nattribute  vec2   a_coord;\nuniform    mat4   u_pvMatrix;\nuniform    mat3   u_rotMatrix;\nuniform    mat3   u_tMatrix;\nuniform    float  u_belt_end;\nuniform    mat4   u_ax, u_ay, u_az;\nuniform    mat4   u_bx, u_by, u_bz;\nvarying    vec2   v_coord;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    float p = a_coord.x;\n    float q = a_coord.y;\n    float p2 = p*p,  q2 = q*q;\n    float p3 = p2*p, q3 = q2*q;\n    float p4 = p3*p, q4 = q3*q;\n    vec4 P = vec4(p3, p2, p, 1.);\n    vec4 Q = vec4(q3, q2, q, 1.);\n    vec3 position;\n    vec3 a = vec3(\n        dot(P, u_ax * Q),\n        dot(P, u_ay * Q),\n        dot(P, u_az * Q)\n    );\n    vec3 b = vec3(\n        dot(P, u_bx * Q),\n        dot(P, u_by * Q),\n        dot(P, u_bz * Q)\n    );\n    position = mix(a, b, step(0., u_belt_end * (q - p) - 1./128.));\n    gl_Position = u_pvMatrix * vec4(u_rotMatrix * position, 1.);\n    v_coord = a_coord;\n    v_w = gl_Position.w;\n}");

/***/ }),

/***/ 6526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\n\nuniform  float  u_fovy;\nvarying  vec4   v_color;\nvarying  float  v_y;\nvarying  float  v_w;\n\nvoid main() {\n    float alpha = 1. - smoothstep(0., 0.9, abs(v_y));\n    alpha *= clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = vec4(v_color.rgb, alpha * v_color.a);    \n}\n");

/***/ }),

/***/ 5933:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\n\nuniform    mat4   u_pvmMatrix;\nuniform    float  u_aspectRatio;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_minWidth;\nuniform    int    u_darkenNarrowLine;\nattribute  vec3   a_p;\nattribute  vec3   a_a;\nattribute  vec3   a_b;\nattribute  float  a_y;\nattribute  float  a_width;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_y;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    vec4 p4 = u_pvmMatrix * vec4(a_p, 1.);\n\n    vec4 a4 = u_pvmMatrix * vec4(a_a, 1.),\n         b4 = u_pvmMatrix * vec4(a_b, 1.);\n\n    vec2 a2 = (p4.w * a4.xy - a4.w * p4.xy) / (p4.w * p4.w),\n         b2 = (p4.w * b4.xy - b4.w * p4.xy) / (p4.w * p4.w);\n\n    a2.x *= u_aspectRatio;\n    b2.x *= u_aspectRatio;\n    a2 = normalize(a2);\n    b2 = normalize(b2);\n\n    vec2 t2 = normalize(b2 - a2),\n         v2 = vec2(-t2.y, t2.x);\n\n\tv_color = a_color;\n    v_color.a *= u_alpha;\n    u_alpha;\n\n    float cosecPhi = clamp(1. / (a2.y*v2.x - a2.x*v2.y), -2., 2.),\n          width = a_width / u_fovy,\n          minWidth = u_minWidth * p4.w;\n\n    if (width < minWidth) {\n        if (u_darkenNarrowLine == 1) {\n            v_color.a *= width / minWidth;\n        }\n        width = minWidth;\n    }\n\n    vec2 d2 = width * a_y * v2 * cosecPhi;\n    d2.x /= u_aspectRatio;\n    p4.xy += d2;\n    gl_Position = p4;\n\n    v_y = a_y;\n    v_w = gl_Position.w;\n}");

/***/ }),

/***/ 5071:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\nvarying   vec4   v_color;\nvarying   float  v_w;\n\n\nvoid main() {\n    float r = 2. * length(gl_PointCoord - vec2(0.5));\n    float v = (1. - smoothstep(0.6, 1.0, r)) * clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = v_color;\n    gl_FragColor.a *= v;\n}");

/***/ }),

/***/ 2957:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("uniform    mat4   u_pvMatrix;\nuniform    float  u_minSize;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_bufferHeight;\nuniform    int    u_darkenSmallPoint;\nattribute  vec3   a_position;\nattribute  float  a_size;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_w;\n\n\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_position, 1.);\n    float pointSize = u_bufferHeight * a_size / (gl_Position.w * u_fovy);\n    float screenSize = max(pointSize, u_minSize);\n    float r = pointSize / screenSize;\n    v_color = a_color;\n    v_color.a *= u_darkenSmallPoint != 0 ? u_alpha * r * r : u_alpha;\n    gl_PointSize = screenSize;\n    v_w = gl_Position.w;\n}");

/***/ }),

/***/ 3846:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("precision mediump float;\n\nuniform    sampler2D  u_texture0;\nuniform    float      u_layer_alpha;\nuniform    float      u_alpha;\nvarying    vec2       v_tCoord;\n\nvoid main() {\n    u_layer_alpha;\n    gl_FragColor = texture2D(u_texture0, v_tCoord);\n    gl_FragColor.rgb *= u_layer_alpha;\n    gl_FragColor.a *= u_alpha;\n}\n");

/***/ }),

/***/ 5835:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("uniform    mat4   u_pvMatrix;\nuniform    mat4   u_mMatrix;\nuniform    mat3   u_texMatrix;\nuniform    mat3   u_tileMatrix;\nattribute  vec2   a_coord;\nvarying    vec2   v_tCoord;\n\n\nvoid main(void) {\n    v_tCoord = (u_texMatrix * vec3(a_coord, 1.)).xy;\n    vec4 position = u_mMatrix * vec4((u_tileMatrix * vec3(v_tCoord, 1.)).xy, 0., 1.);\n    // position.xyz /= vec3(length(position.xyz)); // for fd2u\n    gl_Position = u_pvMatrix * position;\n}\n");

/***/ }),

/***/ 8975:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports.sprintf = sprintf
        exports.vsprintf = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),

/***/ 496:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Animation = exports.AnimationManager = void 0;
var AnimationManager = /** @class */ (function () {
    function AnimationManager(ee, draw) {
        this.ee = ee;
        this.draw = draw;
        this.animations = [];
    }
    AnimationManager.prototype.add = function (cb, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var a = new Animation(cb, options);
        if (a.cameraMotion && this.animations.filter(function (aa) { return aa.cameraMotion; }).length === 0) {
            this.ee.emit('camera-move-start');
        }
        this.animations.push(a);
        a.finally(function () {
            _this.animations.splice(_this.animations.indexOf(a), 1);
            if (a.cameraMotion && _this.animations.filter(function (aa) { return aa.cameraMotion; }).length === 0) {
                _this.ee.emit('camera-move-end');
            }
        });
        this.tick();
        return a;
    };
    AnimationManager.prototype.tick = function () {
        var _this = this;
        if (this.animations.length > 0 && this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                var now = performance.now();
                var motionAnimation = 0;
                for (var _i = 0, _a = _this.animations.slice(); _i < _a.length; _i++) {
                    var a = _a[_i];
                    if (a.cameraMotion) {
                        ++motionAnimation;
                    }
                    a.update(now);
                }
                _this.draw();
                _this.tick();
                if (motionAnimation > 0) {
                    _this.ee.emit('camera-move');
                }
            });
        }
    };
    AnimationManager.prototype.stopCameraMotion = function () {
        for (var _i = 0, _a = this.animations.slice(); _i < _a.length; _i++) {
            var a = _a[_i];
            if (a.cameraMotion) {
                a.stop();
            }
        }
    };
    AnimationManager.prototype.clear = function () {
        while (this.animations.length > 0) {
            this.animations[0].stop();
        }
    };
    return AnimationManager;
}());
exports.AnimationManager = AnimationManager;
// TODO cleanup
var Animation = /** @class */ (function () {
    function Animation(cb, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.cb = cb;
        this.options = options;
        this.start = performance.now();
        this.last = this.start;
        this.onStop = [];
        this.onFinally = [];
        this.alreadyDone = false;
        this.cameraMotion = !!options.cameraMotion;
        if (this.options.immediate) {
            this.update(performance.now());
        }
        this.promise = new Promise(function (resolve, reject) {
            // @ts-ignore
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    Animation.prototype.update = function (now) {
        var t = now - this.start;
        var dt = now - this.last;
        this.last = now;
        if (this.options.duration === undefined) {
            this.cb({ t: t, dt: dt, r: NaN });
        }
        else {
            var r = t / this.options.duration;
            this.cb({ t: t, dt: dt, r: Math.min(1, r) });
            if (t > this.options.duration) {
                this.stop();
            }
        }
    };
    Animation.prototype.stop = function () {
        if (this.alreadyDone) {
            console.warn("animation stopped 2 or more times");
        }
        else {
            for (var _i = 0, _a = this.onStop; _i < _a.length; _i++) {
                var f = _a[_i];
                f();
            }
            for (var _b = 0, _c = this.onFinally; _b < _c.length; _b++) {
                var f = _c[_b];
                f();
            }
            this.resolve();
            this.alreadyDone = true;
        }
    };
    Animation.prototype.abort = function () {
        if (this.alreadyDone) {
            console.warn("animation aborted 2 or more times");
        }
        else {
            for (var _i = 0, _a = this.onFinally; _i < _a.length; _i++) {
                var f = _a[_i];
                f();
            }
            this.reject();
            this.alreadyDone = true;
        }
    };
    Animation.prototype.finally = function (f) {
        this.onFinally.push(f);
        return this;
    };
    Animation.prototype.then = function (f) {
        this.onStop.push(f);
        return this;
    };
    return Animation;
}());
exports.Animation = Animation;


/***/ }),

/***/ 5728:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Canvas = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var angle_1 = __webpack_require__(9565);
var Canvas = /** @class */ (function () {
    function Canvas(globe, preserveBuffer) {
        if (preserveBuffer === void 0) { preserveBuffer = false; }
        this.globe = globe;
        this.preserveBuffer = preserveBuffer;
        try {
            var _a = gl_wrapper_1.canvasPool.pull({
                alpha: false,
                antialias: false,
                stencil: true,
                premultipliedAlpha: false,
                preserveDrawingBuffer: preserveBuffer,
            }), canvas = _a.canvas, gl = _a.gl;
            this.domElement = canvas;
            this.gl = gl;
            canvas.style.backgroundColor = '#000';
            canvas.style.width = canvas.style.height = '100%';
            canvas.style.display = 'block';
        }
        catch (e) {
            var message = "Fails on initializing WebGL. " + e;
            alert(message);
            throw new Error(message);
        }
    }
    Canvas.prototype.release = function () {
        gl_wrapper_1.canvasPool.push(this.domElement);
    };
    Canvas.prototype.resize = function (retina) {
        var canvas = this.domElement;
        var r = retina ? devicePixelRatio : 1;
        var w = r * canvas.clientWidth;
        var h = r * canvas.clientHeight;
        canvas.width = w;
        canvas.height = h;
        this.gl.viewport(0, 0, w, h);
    };
    Canvas.prototype.setSize = function (w, h) {
        var canvas = this.domElement;
        canvas.width = w;
        canvas.height = h;
        this.gl.viewport(0, 0, w, h);
    };
    Object.defineProperty(Canvas.prototype, "aspectRatio", {
        get: function () {
            var c = this.domElement;
            var a = c.width / c.height;
            return isNaN(a) ? 1 : a;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.coordFromClientCoord = function (e) {
        return angle_1.EquatorialCoord.fromXyz(this.xyzFromClientCoord(e));
    };
    Canvas.prototype.xyzFromClientCoord = function (e) {
        return this.xyzFromNdc(this.ndcFromClientCoord(e));
    };
    Canvas.prototype.xyzFromOffset = function (x, y) {
        return this.xyzFromNdc(this.ndcFromOffset(x, y));
    };
    Canvas.prototype.coordFromOffset = function (x, y) {
        return angle_1.EquatorialCoord.fromXyz(this.xyzFromOffset(x, y));
    };
    Canvas.prototype.xyzFromNdc = function (_a) {
        var ndx = _a[0], ndy = _a[1];
        return this.globe.viewFactory.view().camera.ndc2sphereXYZ(ndx, ndy, true);
    };
    Canvas.prototype.ndcFromClientCoord = function (e) {
        var clientRect = this.domElement.getBoundingClientRect();
        var _a = [e.clientX - clientRect.left, e.clientY - clientRect.top], x = _a[0], y = _a[1];
        return this.ndcFromOffset(x, y);
    };
    Canvas.prototype.ndcFromOffset = function (x, y) {
        return [
            2 * x / this.domElement.clientWidth - 1,
            1 - 2 * y / this.domElement.clientHeight,
        ];
    };
    Object.defineProperty(Canvas.prototype, "pixelData", {
        get: function () {
            if (!this.preserveBuffer) {
                throw new Error('this.offscreen must be true');
            }
            var gl = this.gl;
            var w = gl.drawingBufferWidth;
            var h = gl.drawingBufferHeight;
            var array = new Uint8Array(w * h * 4);
            gl.finish();
            gl.readPixels(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, array);
            return {
                width: w,
                height: h,
                buffer: array.buffer,
            };
        },
        enumerable: false,
        configurable: true
    });
    return Canvas;
}());
exports.Canvas = Canvas;


/***/ }),

/***/ 2157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Globe = void 0;
var pan_layer_1 = __webpack_require__(3179);
var zoom_layer_1 = __webpack_require__(8622);
var animation = __importStar(__webpack_require__(496));
var canvas_1 = __webpack_require__(5728);
var view_factory_1 = __webpack_require__(732);
var roll_layer_1 = __webpack_require__(7598);
var wolfy87_eventemitter_1 = __importDefault(__webpack_require__(4795));
var point_event_layer_1 = __webpack_require__(8851);
var touch_layer_1 = __webpack_require__(1534);
var Globe = /** @class */ (function () {
    function Globe(el, defaultLayers, preserveBuffer) {
        var _this = this;
        if (defaultLayers === void 0) { defaultLayers = true; }
        if (preserveBuffer === void 0) { preserveBuffer = false; }
        this.ee = new wolfy87_eventemitter_1.default();
        this.viewFactory = new view_factory_1.ViewFactory(this);
        this.layers = [];
        this.rafId = undefined;
        this.animationManager = new animation.AnimationManager(this.ee, function () { return _this.draw(); });
        var canvas = this.canvas = new canvas_1.Canvas(this, preserveBuffer);
        this.canvas = canvas;
        el && this.mount(el);
        this.gl = canvas.gl;
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        point_event_layer_1.PointerEventLayer.initGlobe(this);
        defaultLayers && this.initDefaultLayers();
        this.resize();
        this.requestRefresh();
    }
    Globe.prototype.mount = function (el) {
        this.el = el;
        el.appendChild(this.canvas.domElement);
    };
    Globe.prototype.unmount = function () {
        console.assert(this.el !== undefined);
        this.el.removeChild(this.canvas.domElement);
        this.el = undefined;
    };
    Globe.prototype.release = function () {
        this.animationManager.clear();
        while (this.layers.length > 0) {
            this.removeLayer(this.layers[0]);
        }
        if (this.el) {
            this.unmount();
        }
        this.canvas.release();
    };
    Globe.prototype.resize = function () {
        this.canvas.resize(this.viewFactory.retina);
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        this.requestRefresh();
    };
    Globe.prototype.setSize = function (w, h) {
        this.canvas.setSize(w, h);
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        this.requestRefresh();
    };
    Globe.prototype.addLayer = function (layer) {
        layer.changeGlobe(this);
        this.layers.push(layer);
        this.sortLayers();
        this.requestRefresh();
        this.ee.emit('layer-change');
    };
    Globe.prototype.removeLayer = function (layer) {
        var i = this.layers.indexOf(layer);
        if (i >= 0) {
            this.layers.splice(i, 1);
            layer.changeGlobe(undefined);
        }
        this.requestRefresh();
        this.ee.emit('layer-change');
    };
    Globe.prototype.requestRefresh = function () {
        var _this = this;
        if (this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                _this.draw();
            });
        }
    };
    Globe.prototype.animation = function (cb, options) {
        return this.animationManager.add(cb, options);
    };
    Globe.prototype.stopCameraMotion = function () {
        this.animationManager.stopCameraMotion();
    };
    Globe.prototype.setLayerSortFunc = function (f) {
        this.layerSortFunc = f;
        this.sortLayers();
    };
    Globe.prototype.eachLayer = function (cb) {
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var l = _a[_i];
            cb(l);
        }
    };
    Globe.prototype.draw = function () {
        this.ee.emit('draw');
        var view = this.viewFactory.view();
        var gl = this.gl;
        gl.clearColor(0, 0, 0, 0);
        // gl.clearColor(0, 0, 0, 1.e-16) // on Safari, gl.clear does not work sanely if alpha = 0
        gl.clear(gl.COLOR_BUFFER_BIT);
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            layer.render(view);
        }
    };
    Globe.prototype.initDefaultLayers = function () {
        this.addLayer(new pan_layer_1.PanLayer());
        this.addLayer(new roll_layer_1.RollLayer());
        this.addLayer(new zoom_layer_1.ZoomLayer());
        this.addLayer(new touch_layer_1.TouchLayer());
    };
    Globe.prototype.sortLayers = function () {
        if (this.layerSortFunc) {
            this.layers.sort(this.layerSortFunc);
        }
    };
    return Globe;
}());
exports.Globe = Globe;


/***/ }),

/***/ 732:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewFactory = exports.MAX_FOVY = exports.MIN_FOVY = void 0;
var angle_1 = __webpack_require__(9565);
var easing = __importStar(__webpack_require__(16));
var gl_matrix_1 = __webpack_require__(887);
var math_1 = __webpack_require__(3774);
var view_1 = __webpack_require__(5678);
var camera_1 = __webpack_require__(62);
var matrilx_utils_1 = __webpack_require__(3310);
exports.MIN_FOVY = (0, angle_1.asec2rad)(5);
exports.MAX_FOVY = 2;
var ViewFactory = /** @class */ (function () {
    function ViewFactory(globe, retina) {
        if (retina === void 0) { retina = true; }
        this.globe = globe;
        this.retina = retina;
        this.aspectRatio = -1;
        this.mode = matrilx_utils_1.CameraMode.STEROGRAPHIC;
        this.theta = 0;
        this.phi = 0;
        this.fovy = (0, angle_1.deg2rad)(45);
        this.roll = 0;
        this.lodBias = 0;
        this.za = 0;
        this.zd = Math.PI / 2;
        this.zp = 0;
        this.setLodHooks();
    }
    ViewFactory.prototype.coord2thetaphi = function (coord) {
        var v = gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), coord.xyz, (0, matrilx_utils_1.zenith3)(this.za, this.zd, this.zp));
        return (0, math_1.xyz2thetaphi)(v[0], v[1], v[2]);
    };
    ViewFactory.prototype.xyz2thetaphi = function (v) {
        return this.coord2thetaphi(angle_1.EquatorialCoord.fromXyz(v));
    };
    ViewFactory.prototype.thetaphi2xyz = function (theta, phi) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], (0, math_1.thetaphi2xyz)(theta, phi), (0, matrilx_utils_1.izenith3)(this.za, this.zd, this.zp));
    };
    ViewFactory.prototype.thetaphi2coord = function (theta, phi) {
        return angle_1.EquatorialCoord.fromXyz(this.thetaphi2xyz(theta, phi));
    };
    ViewFactory.prototype.center = function () {
        return this.thetaphi2coord(this.theta, this.phi);
    };
    ViewFactory.prototype.jumpTo = function (params2, options) {
        var _a;
        var _this = this;
        if (options === void 0) { options = {}; }
        var duration = options.duration || 400;
        var easingFunction = options.easingFunction || easing.fastStart4;
        this.globe.stopCameraMotion();
        var p1 = {
            aspectRatio: this.aspectRatio,
            theta: this.theta,
            phi: this.phi,
            fovy: this.fovy,
            roll: this.roll,
            mode: this.mode,
            za: this.za,
            zd: this.zd,
            zp: this.zp,
        };
        var p2 = __assign(__assign({}, p1), params2);
        if (options.coord) {
            var v = gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), options.coord.xyz, (0, matrilx_utils_1.zenith3)(p2.za, p2.zd, p2.zp));
            _a = (0, math_1.xyz2thetaphi)(v[0], v[1], v[2]), p2.theta = _a[0], p2.phi = _a[1];
        }
        p1.mode !== p2.mode && this.changeMode(p2.mode, duration);
        p1.phi = (0, angle_1.wrapTo2Pi)(p1.phi);
        if (Math.abs(p1.phi - p2.phi) > Math.PI) {
            if (p1.phi > p2.phi) {
                p2.phi += 2 * Math.PI;
            }
            else {
                p1.phi += 2 * Math.PI;
            }
        }
        var distance = gl_matrix_1.vec3.distance((0, math_1.thetaphi2xyz)(p1.theta, p1.phi), (0, math_1.thetaphi2xyz)(p2.theta, p2.phi));
        return this.jumpAnimation = this.globe.animation(function (_a) {
            var ratio = _a.r;
            var r = easingFunction(ratio);
            _this.phi = r * p2.phi + (1 - r) * p1.phi;
            _this.theta = r * p2.theta + (1 - r) * p1.theta;
            var f = 1 - Math.pow((2 * (r - 0.5)), 2);
            _this.fovy = options.keepFovy ?
                (1 - r) * p1.fovy + r * p2.fovy : f * Math.max(distance - 2 * p1.fovy, 0) + (1 - r) * p1.fovy + r * p2.fovy;
            _this.roll = (1 - r) * p1.roll + r * p2.roll;
            _this.za = (1 - r) * p1.za + r * p2.za;
            _this.zd = (1 - r) * p1.zd + r * p2.zd;
            _this.zp = (1 - r) * p1.zp + r * p2.zp;
        }, { duration: duration, cameraMotion: true }).then(function () { return _this.jumpAnimation = undefined; });
    };
    ViewFactory.prototype.view = function () {
        return new view_1.View(
        // @ts-ignore
        new camera_1.Camera(this.modeTransitionPv || this.pv()), this.lodBias, this.retina, this.globe.gl.drawingBufferHeight);
    };
    ViewFactory.prototype.pv = function (mode) {
        if (mode === void 0) { mode = this.mode; }
        return (this.customPvMatrix || matrilx_utils_1.cameraMatrix)({
            aspectRatio: this.aspectRatio,
            theta: this.theta,
            phi: this.phi,
            fovy: this.fovy,
            roll: this.roll,
            mode: mode,
            za: this.za,
            zd: this.zd,
            zp: this.zp,
        });
    };
    ViewFactory.prototype.changeMode = function (mode, duration) {
        var _this = this;
        if (duration === void 0) { duration = 200; }
        var oldMode = this.mode;
        this.modeAnimation && this.modeAnimation.stop();
        this.mode = mode;
        this.modeAnimation = this.globe.animation(function (_a) {
            var r = _a.r;
            r = easing.fastStart4(r);
            // @ts-ignore
            _this.modeTransitionPv = (0, matrilx_utils_1.composite)([1 - r, r], [_this.pv(oldMode), _this.pv()]);
        }, { duration: duration, immediate: true, cameraMotion: true }).then(function () {
            _this.modeAnimation = undefined;
            _this.modeTransitionPv = undefined;
        });
    };
    ViewFactory.prototype.cage = function () {
        var _this = this;
        if (this.cageAnimation === undefined && (this.fovy < exports.MIN_FOVY || exports.MAX_FOVY < this.fovy)) {
            this.cageAnimation = this.globe.animation(function (_a) {
                var dt = _a.dt;
                if (exports.MIN_FOVY <= _this.fovy && _this.fovy <= exports.MAX_FOVY) {
                    _this.cageAnimation.stop();
                    return;
                }
                var k = 5.e-3;
                var base = _this.fovy > exports.MAX_FOVY ? exports.MAX_FOVY : exports.MIN_FOVY;
                var d = Math.log(_this.fovy / base);
                d += (d < 0 ? -1 : 1) * 1.e-3;
                _this.fovy *= Math.exp(-k * dt * d);
            }, { cameraMotion: true }).then(function () { return _this.cageAnimation = undefined; });
        }
    };
    ViewFactory.prototype.setLodHooks = function () {
        var _this = this;
        this.globe.ee.on('camera-move-start', function () {
            if (_this.lodAnimcation) {
                _this.lodAnimcation.stop();
            }
            _this.lodBias = 1;
        });
        this.globe.ee.on('camera-move-end', function () {
            _this.lodAnimcation = _this.globe.animation(function (_a) {
                var r = _a.r;
                return _this.lodBias = 1 - r;
            }, { duration: 200 }).then(function () {
                _this.lodAnimcation = undefined;
            });
        });
    };
    ViewFactory.prototype.setRetina = function (retina) {
        this.retina = retina;
        this.globe.resize();
        this.globe.requestRefresh();
    };
    return ViewFactory;
}());
exports.ViewFactory = ViewFactory;


/***/ }),

/***/ 3607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zeroTexture = exports.utils = exports.text2imageData = exports.PointEvent = exports.PointEventLayer = exports.RollLayer = exports.ZoomLayer = exports.TouchLayer = exports.PanLayer = exports.EsoMilkyWayLayer = exports.GridLayer = exports.HipparcosCatalogLayer = exports.ConstellationLayer = exports.BillboardRenderer = exports.path = exports.tile = exports.hips = exports.Animation = exports.Angle = exports.EquatorialCoord = exports.cameraMatrix = exports.normalizeZenith = exports.CameraMode = exports.View = exports.Layer = exports.Globe = void 0;
var globe_1 = __webpack_require__(2157);
Object.defineProperty(exports, "Globe", ({ enumerable: true, get: function () { return globe_1.Globe; } }));
var layer_1 = __webpack_require__(7288);
Object.defineProperty(exports, "Layer", ({ enumerable: true, get: function () { return layer_1.Layer; } }));
var view_1 = __webpack_require__(5678);
Object.defineProperty(exports, "View", ({ enumerable: true, get: function () { return view_1.View; } }));
var matrilx_utils_1 = __webpack_require__(3310);
Object.defineProperty(exports, "CameraMode", ({ enumerable: true, get: function () { return matrilx_utils_1.CameraMode; } }));
Object.defineProperty(exports, "normalizeZenith", ({ enumerable: true, get: function () { return matrilx_utils_1.normalizeZenith; } }));
Object.defineProperty(exports, "cameraMatrix", ({ enumerable: true, get: function () { return matrilx_utils_1.cameraMatrix; } }));
var angle_1 = __webpack_require__(9565);
Object.defineProperty(exports, "EquatorialCoord", ({ enumerable: true, get: function () { return angle_1.EquatorialCoord; } }));
Object.defineProperty(exports, "Angle", ({ enumerable: true, get: function () { return angle_1.Angle; } }));
var animation_1 = __webpack_require__(496);
Object.defineProperty(exports, "Animation", ({ enumerable: true, get: function () { return animation_1.Animation; } }));
var hips = __importStar(__webpack_require__(1025));
exports.hips = hips;
var tile = __importStar(__webpack_require__(6562));
exports.tile = tile;
var path = __importStar(__webpack_require__(2997));
exports.path = path;
var billboard_renderer_1 = __webpack_require__(4415);
Object.defineProperty(exports, "BillboardRenderer", ({ enumerable: true, get: function () { return billboard_renderer_1.BillboardRenderer; } }));
var constellation_layer_1 = __webpack_require__(9950);
Object.defineProperty(exports, "ConstellationLayer", ({ enumerable: true, get: function () { return constellation_layer_1.ConstellationLayer; } }));
var hipparcos_catalog_layer_1 = __webpack_require__(9314);
Object.defineProperty(exports, "HipparcosCatalogLayer", ({ enumerable: true, get: function () { return hipparcos_catalog_layer_1.HipparcosCatalogLayer; } }));
var grid_layer_1 = __webpack_require__(9823);
Object.defineProperty(exports, "GridLayer", ({ enumerable: true, get: function () { return grid_layer_1.GridLayer; } }));
var eso_milky_way_layer_1 = __webpack_require__(1615);
Object.defineProperty(exports, "EsoMilkyWayLayer", ({ enumerable: true, get: function () { return eso_milky_way_layer_1.EsoMilkyWayLayer; } }));
var pan_layer_1 = __webpack_require__(3179);
Object.defineProperty(exports, "PanLayer", ({ enumerable: true, get: function () { return pan_layer_1.PanLayer; } }));
var touch_layer_1 = __webpack_require__(1534);
Object.defineProperty(exports, "TouchLayer", ({ enumerable: true, get: function () { return touch_layer_1.TouchLayer; } }));
var zoom_layer_1 = __webpack_require__(8622);
Object.defineProperty(exports, "ZoomLayer", ({ enumerable: true, get: function () { return zoom_layer_1.ZoomLayer; } }));
var roll_layer_1 = __webpack_require__(7598);
Object.defineProperty(exports, "RollLayer", ({ enumerable: true, get: function () { return roll_layer_1.RollLayer; } }));
var point_event_layer_1 = __webpack_require__(8851);
Object.defineProperty(exports, "PointEventLayer", ({ enumerable: true, get: function () { return point_event_layer_1.PointerEventLayer; } }));
Object.defineProperty(exports, "PointEvent", ({ enumerable: true, get: function () { return point_event_layer_1.GlobePointerEvent; } }));
var utils = __importStar(__webpack_require__(5928));
exports.utils = utils;
var text2imagedata_1 = __webpack_require__(4363);
Object.defineProperty(exports, "text2imageData", ({ enumerable: true, get: function () { return text2imagedata_1.text2imageData; } }));
var image_1 = __webpack_require__(5507);
Object.defineProperty(exports, "zeroTexture", ({ enumerable: true, get: function () { return image_1.zeroTexture; } }));


/***/ }),

/***/ 9950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConstellationLayer = void 0;
var layer_1 = __webpack_require__(7288);
var path_renderer_1 = __webpack_require__(2997);
var billboard_renderer_1 = __webpack_require__(4415);
var angle_1 = __webpack_require__(9565);
var text2imagedata_1 = __webpack_require__(4363);
var japanese_1 = __webpack_require__(6349);
var axios_1 = __importDefault(__webpack_require__(9669));
var LANG;
(function (LANG) {
    LANG[LANG["ENGLISH"] = 0] = "ENGLISH";
    LANG[LANG["HIRAGANA"] = 1] = "HIRAGANA";
    LANG[LANG["KANJI"] = 2] = "KANJI";
})(LANG || (LANG = {}));
var ConstellationLayer = /** @class */ (function (_super) {
    __extends(ConstellationLayer, _super);
    function ConstellationLayer(showLines, showNames, lang) {
        if (showLines === void 0) { showLines = true; }
        if (showNames === void 0) { showNames = false; }
        if (lang === void 0) { lang = LANG.ENGLISH; }
        var _this = _super.call(this) || this;
        _this.showLines = showLines;
        _this.showNames = showNames;
        _this.lang = lang;
        _this.paths = [];
        _this.linesReady = false;
        _this.namesReady = false;
        return _this;
    }
    ConstellationLayer.prototype.onAdd = function () {
        this.pathRenderer = new path_renderer_1.Renderer(this.globe.gl);
        this.billboardRenderer = new billboard_renderer_1.BillboardRenderer(this.globe.gl);
        this.pathRenderer.setPaths(this.paths);
    };
    ConstellationLayer.prototype.onRemove = function () {
        this.pathRenderer.release();
        this.billboardRenderer.release();
    };
    ConstellationLayer.prototype.render = function (view) {
        var alpha = layer_1.Layer.overlayAlpha(view);
        if (this.showLines) {
            this.linesReady || this.buildLines();
            this.pathRenderer.alpha = alpha;
            this.pathRenderer.render(view);
        }
        if (this.showNames) {
            this.namesReady || this.buildNameBillboards();
            this.billboardRenderer.alpha = alpha;
            this.billboardRenderer.render(view);
        }
    };
    ConstellationLayer.prototype.buildLines = function () {
        return __awaiter(this, void 0, void 0, function () {
            var constellations, paths, _loop_1, _i, _a, name_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.linesReady = true;
                        return [4 /*yield*/, axios_1.default.get(__webpack_require__(6752))];
                    case 1:
                        constellations = (_b.sent()).data;
                        paths = [];
                        _loop_1 = function (name_1) {
                            var c = constellations[name_1];
                            var name2star = (function () {
                                var m = {};
                                for (var _i = 0, _a = c.stars; _i < _a.length; _i++) {
                                    var star = _a[_i];
                                    m[star.name] = star;
                                }
                                return m;
                            })();
                            var color = c.ecliptical ? [1, 0.75, 0, 0.25] : [1, 1, 1, 0.25];
                            for (var _c = 0, _d = c.lines; _c < _d.length; _c++) {
                                var line = _d[_c];
                                var stars = line.split('-').map(function (starName) { return name2star[starName]; });
                                for (var i = 0; i < stars.length - 1; ++i) {
                                    var path = new path_renderer_1.Path([
                                        new path_renderer_1.Point(star2xyz(stars[i]), color, 0.015),
                                        new path_renderer_1.Point(star2xyz(stars[i + 1]), color, 0.015),
                                    ], false);
                                    paths.push(path);
                                }
                            }
                        };
                        for (_i = 0, _a = Object.keys(constellations); _i < _a.length; _i++) {
                            name_1 = _a[_i];
                            _loop_1(name_1);
                        }
                        this.pathRenderer.setPaths(this.paths = paths);
                        this.globe && this.globe.requestRefresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstellationLayer.prototype.buildNameBillboards = function () {
        return __awaiter(this, void 0, void 0, function () {
            var constellations, images, imageRefs, _i, _a, name_2, c, label;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.namesReady = true;
                        return [4 /*yield*/, axios_1.default.get(__webpack_require__(6752))];
                    case 1:
                        constellations = (_c.sent()).data;
                        images = [];
                        imageRefs = [];
                        for (_i = 0, _a = Object.keys(constellations); _i < _a.length; _i++) {
                            name_2 = _a[_i];
                            c = constellations[name_2];
                            imageRefs.push({
                                imageID: images.length,
                                position: centroid(c.stars),
                            });
                            label = (_b = {},
                                _b[LANG.ENGLISH] = name_2,
                                _b[LANG.HIRAGANA] = japanese_1.hiragana[name_2],
                                _b[LANG.KANJI] = japanese_1.kanji[name_2],
                                _b)[this.lang];
                            images.push({
                                imageData: (0, text2imagedata_1.text2imageData)(label, '12pt fantasy', 'rgba(239, 225, 196, 1)'),
                                origin: [0, 0],
                            });
                        }
                        this.billboardRenderer.buildArray(images, imageRefs);
                        this.globe && this.globe.requestRefresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstellationLayer.LANG = LANG;
    return ConstellationLayer;
}(layer_1.Layer));
exports.ConstellationLayer = ConstellationLayer;
function star2xyz(star) {
    var coord = angle_1.EquatorialCoord.fromDeg(star.ra, star.dec);
    return coord.xyz;
}
function centroid(stars) {
    var g = [0, 0, 0];
    for (var _i = 0, stars_1 = stars; _i < stars_1.length; _i++) {
        var s = stars_1[_i];
        star2xyz(s).forEach(function (c, i) { return g[i] += c; });
    }
    g = g.map(function (c) { return c / stars.length; });
    var r = Math.sqrt(g.reduce(function (sum, c) { return sum + c * c; }, 0));
    return g.map(function (c) { return c / r; });
}


/***/ }),

/***/ 6349:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hiragana = exports.kanji = void 0;
exports.kanji = {
    Andromeda: "アンドロメダ",
    Antlia: "ポンプ",
    Apus: "風鳥",
    Aquarius: "水瓶",
    Aquila: "鷲",
    Ara: "祭壇",
    Aries: "牡羊",
    Auriga: "御者",
    Boötes: "牛飼い",
    Caelum: "彫刻具",
    Camelopardalis: "キリン",
    Cancer: "蟹",
    CanesVenatici: "猟犬",
    CanisMajor: "大犬",
    CanisMinor: "小犬",
    Capricornus: "山羊",
    Carina: "竜骨",
    Cassiopeia: "カシオペヤ",
    Centaurus: "ケンタウルス",
    Cepheus: "ケフェウス",
    Cetus: "鯨",
    Chamaeleon: "カメレオン",
    Circinus: "コンパス",
    Columba: "鳩",
    ComaBerenices: "髪",
    CoronaAustralis: "南の冠",
    CoronaBorealis: "冠",
    Corvus: "烏",
    Crater: "コップ",
    Crux: "南十字",
    Cygnus: "白鳥",
    Delphinus: "海豚",
    Dorado: "旗魚",
    Draco: "竜",
    Equuleus: "小馬",
    Eridanus: "エリダヌス",
    Fornax: "炉",
    Gemini: "双子",
    Grus: "鶴",
    Hercules: "ヘルクレス",
    Horologium: "時計",
    Hydra: "海蛇",
    Hydrus: "水蛇",
    Indus: "インディアン",
    Lacerta: "蜥蜴",
    Leo: "獅子",
    LeoMinor: "小獅子",
    Lepus: "兎",
    Libra: "天秤",
    Lupus: "狼",
    Lynx: "山猫",
    Lyra: "琴",
    Mensa: "テーブル山",
    Microscopium: "顕微鏡",
    Monoceros: "一角獣",
    Musca: "蝿",
    Norma: "定規",
    Octans: "八分儀",
    Ophiuchus: "蛇遣",
    Orion: "オリオン",
    Pavo: "孔雀",
    Pegasus: "ペガスス",
    Perseus: "ペルセウス",
    Phoenix: "鳳凰",
    Pictor: "画架",
    Pisces: "魚",
    PiscisAustrinus: "南の魚",
    Puppis: "艫",
    Pyxis: "羅針盤",
    Reticulum: "レチクル",
    Sagitta: "矢",
    Sagittarius: "射手",
    Scorpius: "蠍",
    Sculptor: "彫刻室",
    Scutum: "楯",
    Serpens: "蛇",
    Sextans: "六分儀",
    Taurus: "牡牛",
    Telescopium: "望遠鏡",
    Triangulum: "三角",
    TriangulumAustrale: "南の三角",
    Tucana: "巨嘴鳥",
    UrsaMajor: "大熊",
    UrsaMinor: "小熊",
    Vela: "帆",
    Virgo: "乙女",
    Volans: "飛魚",
    Vulpecula: "小狐",
};
exports.hiragana = {
    Andromeda: "アンドロメダ",
    Antlia: "ポンプ",
    Apus: "ふうちょう",
    Aquarius: "みずがめ",
    Aquila: "わし",
    Ara: "さいだん",
    Aries: "おひつじ",
    Auriga: "ぎょしゃ",
    Boötes: "うしかい",
    Caelum: "ちょうこくぐ",
    Camelopardalis: "キリン",
    Cancer: "かに",
    CanesVenatici: "りょうけん",
    CanisMajor: "おおいぬ",
    CanisMinor: "こいぬ",
    Capricornus: "やぎ",
    Carina: "りゅうこつ",
    Cassiopeia: "カシオペヤ",
    Centaurus: "ケンタウルス",
    Cepheus: "ケフェウス",
    Cetus: "くじら",
    Chamaeleon: "カメレオン",
    Circinus: "コンパス",
    Columba: "はと",
    ComaBerenices: "かみのけ",
    CoronaAustralis: "みなみのかんむり",
    CoronaBorealis: "かんむり",
    Corvus: "からす",
    Crater: "コップ",
    Crux: "みなみじゅうじ",
    Cygnus: "はくちょう",
    Delphinus: "いるか",
    Dorado: "かじき",
    Draco: "りゅう",
    Equuleus: "こうま",
    Eridanus: "エリダヌス",
    Fornax: "ろ",
    Gemini: "ふたご",
    Grus: "つる",
    Hercules: "ヘルクレス",
    Horologium: "とけい",
    Hydra: "うみへび",
    Hydrus: "みずへび",
    Indus: "インディアン",
    Lacerta: "とかげ",
    Leo: "しし",
    LeoMinor: "こじし",
    Lepus: "うさぎ",
    Libra: "てんびん",
    Lupus: "おおかみ",
    Lynx: "やまねこ",
    Lyra: "こと",
    Mensa: "テーブルさん",
    Microscopium: "けんびきょう",
    Monoceros: "いっかくじゅう",
    Musca: "はえ",
    Norma: "じょうぎ",
    Octans: "はちぶんぎ",
    Ophiuchus: "へびつかい",
    Orion: "オリオン",
    Pavo: "くじゃく",
    Pegasus: "ペガスス",
    Perseus: "ペルセウス",
    Phoenix: "ほうおう",
    Pictor: "がか",
    Pisces: "うお",
    PiscisAustrinus: "みなみのうお",
    Puppis: "とも",
    Pyxis: "らしんばん",
    Reticulum: "レチクル",
    Sagitta: "や",
    Sagittarius: "いて",
    Scorpius: "さそり",
    Sculptor: "ちょうこくしつ",
    Scutum: "たて",
    Serpens: "へび",
    Sextans: "ろくぶんぎ",
    Taurus: "おうし",
    Telescopium: "ぼうえんきょう",
    Triangulum: "さんかく",
    TriangulumAustrale: "みなみのさんかく",
    Tucana: "きょしちょう",
    UrsaMajor: "おおぐま",
    UrsaMinor: "こぐま",
    Vela: "ほ",
    Virgo: "おとめ",
    Volans: "とびうお",
    Vulpecula: "こぎつね",
};


/***/ }),

/***/ 1615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EsoMilkyWayLayer = void 0;
var cube_map_renderer_1 = __webpack_require__(1174);
var gl_matrix_1 = __webpack_require__(887);
var image_1 = __webpack_require__(5507);
var __1 = __webpack_require__(3607);
// thanks to ESO/S. Brunier
// https://www.eso.org/public/images/eso0932a/
var EsoMilkyWayLayer = /** @class */ (function (_super) {
    __extends(EsoMilkyWayLayer, _super);
    function EsoMilkyWayLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fadeAlpha = 0;
        return _this;
    }
    EsoMilkyWayLayer.prototype.onAdd = function () {
        var _this = this;
        this.renderer = new EsoMilkyWay(this.globe.gl, function () {
            _this.globe && _this.globe.animation(function (_a) {
                var r = _a.r;
                _this.fadeAlpha = r;
            }, { duration: 200 });
        });
    };
    EsoMilkyWayLayer.prototype.onRemove = function () {
        this.renderer.release();
    };
    EsoMilkyWayLayer.prototype.render = function (view) {
        var alpha = __1.Layer.overlayAlpha(view) * this.fadeAlpha;
        this.renderer.alpha = alpha;
        this.renderer.render(view);
    };
    return EsoMilkyWayLayer;
}(__1.Layer));
exports.EsoMilkyWayLayer = EsoMilkyWayLayer;
var EsoMilkyWay = /** @class */ (function (_super) {
    __extends(EsoMilkyWay, _super);
    function EsoMilkyWay(gl, done) {
        var _this = _super.call(this, gl) || this;
        _this.m = gl_matrix_1.mat4.fromValues(+0.0017373464070261, -0.4792437255382538, -0.8776800036430359, 0, +0.8911036849021912, +0.3990314602851868, -0.2161209583282471, 0, +0.4537965655326843, -0.7817283272743225, +0.4277492463588715, 0, 0, 0, 0, 1);
        _this.loadImages().then(done);
        return _this;
    }
    EsoMilkyWay.prototype.loadImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var urls, isFirefox, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isFirefox = window.navigator.userAgent.match(/firefox/i);
                        if (isFirefox) {
                            urls = urls512;
                            console.info('using small version of ESO Milky Way images');
                        }
                        else {
                            urls = urls1024;
                        }
                        _a = this.setCubeImage;
                        return [4 /*yield*/, Promise.all(urls.map(function (url) { return (0, image_1.loadImage)(url); }))];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    EsoMilkyWay.prototype.mMatrix = function () {
        return this.m;
    };
    EsoMilkyWay.attributions = [{
            which: 'The Milky Way Panorama',
            label: 'ESO/S. Brunier',
            link: 'https://www.eso.org/public/images/eso0932a/',
        }];
    return EsoMilkyWay;
}(cube_map_renderer_1.CubeMappRenderer));
var urls1024 = ['px', 'py', 'pz', 'nx', 'ny', 'nz']
    .map(function (dir) { return "//hscmap.mtk.nao.ac.jp/data/eso_milky_way_layer/images-1024/" + dir + ".png"; });
var urls512 = ['px', 'py', 'pz', 'nx', 'ny', 'nz']
    .map(function (dir) { return "//hscmap.mtk.nao.ac.jp/data/eso_milky_way_layer/images-512/" + dir + ".png"; });


/***/ }),

/***/ 9823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GridLayer = void 0;
// tslint:disable:variable-name
var layer_1 = __webpack_require__(7288);
var path_renderer_1 = __webpack_require__(2997);
var math_1 = __webpack_require__(3774);
var GridLayer = /** @class */ (function (_super) {
    __extends(GridLayer, _super);
    function GridLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridLayer.prototype.onAdd = function () {
        this.pathRenderer = new path_renderer_1.Renderer(this.globe.gl);
        this.pathRenderer.setPaths(this.generatePaths());
    };
    GridLayer.prototype.onRemove = function () {
        this.pathRenderer.release();
    };
    GridLayer.prototype.render = function (view) {
        this.pathRenderer.alpha = layer_1.Layer.overlayAlpha(view);
        this.pathRenderer.render(view);
    };
    GridLayer.prototype.generatePaths = function () {
        var paths = [];
        var width = 0.008;
        var defaultColor = [0.25, 0.5, 1, 0.5];
        var n_d;
        var n_a;
        // decl lines
        n_d = 18;
        n_a = 360;
        var _loop_1 = function (i_d) {
            var theta = Math.PI * (i_d - 9) / n_d;
            var color = i_d === 9 ? [1, 0, 0, 0.75] : defaultColor;
            paths.push(new path_renderer_1.Path((0, math_1.range)(0, n_a).map(function (i_a) {
                var phi = 2 * Math.PI * i_a / n_a;
                return new path_renderer_1.Point([
                    Math.cos(theta) * Math.cos(phi),
                    Math.cos(theta) * Math.sin(phi),
                    Math.sin(theta)
                ], color, width);
            }), true, path_renderer_1.JOINT.MITER));
        };
        for (var i_d = 1; i_d < n_d; ++i_d) {
            _loop_1(i_d);
        }
        // ra lines
        n_d = 180;
        n_a = 24;
        var _loop_2 = function (i_a) {
            var phi = 2 * Math.PI * i_a / n_a;
            var color = {
                0: [1, 0, 0, 0.5],
                6: [0.5, 1, 0, 0.5],
                12: [0, 1, 1, 0.5],
                18: [0.5, 0, 1, 0.5],
            }[i_a] || defaultColor;
            paths.push(new path_renderer_1.Path((0, math_1.range)(0, n_d + 1).map(function (i_d) {
                var theta = Math.PI * (i_d - 90) / n_d;
                return new path_renderer_1.Point([
                    Math.cos(theta) * Math.cos(phi),
                    Math.cos(theta) * Math.sin(phi),
                    Math.sin(theta)
                ], color, width);
            }), false, path_renderer_1.JOINT.MITER));
        };
        for (var i_a = 0; i_a < n_a; ++i_a) {
            _loop_2(i_a);
        }
        return paths;
    };
    return GridLayer;
}(layer_1.Layer));
exports.GridLayer = GridLayer;


/***/ }),

/***/ 9314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HipparcosCatalogLayer = void 0;
var layer_1 = __webpack_require__(7288);
var point_renderer_1 = __webpack_require__(931);
// tslint:disable-next-line:no-var-requires variable-name
var Loader = __webpack_require__(6637);
var HipparcosCatalogLayer = /** @class */ (function (_super) {
    __extends(HipparcosCatalogLayer, _super);
    function HipparcosCatalogLayer() {
        var _this = _super.call(this) || this;
        _this.loader = new Loader();
        _this.loader.addEventListener('message', function (e) {
            _this.array = new Float32Array(e.data.buffer);
            _this.refresh();
        });
        return _this;
    }
    HipparcosCatalogLayer.prototype.onAdd = function () {
        this.pointRenderer = new point_renderer_1.PointRenderer(this.globe.gl);
        this.refresh();
    };
    HipparcosCatalogLayer.prototype.onRemove = function () {
        this.pointRenderer.release();
    };
    HipparcosCatalogLayer.prototype.render = function (view) {
        this.pointRenderer.alpha = layer_1.Layer.overlayAlpha(view);
        this.pointRenderer.render(view);
    };
    HipparcosCatalogLayer.prototype.refresh = function () {
        if (this.globe && this.pointRenderer && this.array) {
            this.pointRenderer._setArray(this.array);
            this.globe.requestRefresh();
        }
    };
    return HipparcosCatalogLayer;
}(layer_1.Layer));
exports.HipparcosCatalogLayer = HipparcosCatalogLayer;


/***/ }),

/***/ 7288:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Layer = void 0;
var math_1 = __webpack_require__(3774);
var Layer = /** @class */ (function () {
    function Layer() {
    }
    Layer.prototype.changeGlobe = function (globe) {
        this.globe && this.onRemove();
        this.globe = globe;
        if (globe) {
            this.onAdd();
            globe.requestRefresh();
        }
    };
    Layer.prototype.onAdd = function () { };
    Layer.prototype.onRemove = function () { };
    Layer.prototype.render = function (view) { };
    Layer.prototype.active = function () {
        return !!this.globe;
    };
    Layer.baseAlpha = function (view) {
        return 1 - this.overlayAlpha(view);
    };
    Layer.overlayAlpha = function (view) {
        var b = this.overlayAlphaStart;
        var a = this.overlayAlphaGradient;
        return (0, math_1.clamp)((view.camera.arc - b) * a, 0, 1);
    };
    Layer.overlayAlphaStart = 0.2;
    Layer.overlayAlphaGradient = 4;
    return Layer;
}());
exports.Layer = Layer;


/***/ }),

/***/ 3179:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanLayer = void 0;
var inertial_mouse_1 = __webpack_require__(5131);
var gl_matrix_1 = __webpack_require__(887);
var math_1 = __webpack_require__(3774);
var mouse_1 = __webpack_require__(7312);
var point_event_layer_1 = __webpack_require__(8851);
var EPSILON = (1 / 3600) / 180 * Math.PI;
var PanLayer = /** @class */ (function (_super) {
    __extends(PanLayer, _super);
    function PanLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = gl_matrix_1.mat2.create();
        _this.dblclick = function (e) {
            var coord = _this.globe.canvas.coordFromClientCoord(e);
            var _a = _this.globe.viewFactory.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
            _this.globe.viewFactory.jumpTo({ theta: theta, phi: phi });
        };
        return _this;
    }
    PanLayer.prototype.onAdd = function () {
        _super.prototype.onAdd.call(this);
        var el = this.globe.canvas.domElement;
        el.addEventListener('dblclick', this.dblclick);
        this.setupDragEvent();
    };
    PanLayer.prototype.onRemove = function () {
        var el = this.globe.canvas.domElement;
        el.removeEventListener('dblclick', this.dblclick);
        this.im.teardown();
    };
    PanLayer.prototype.hit = function (e) {
        var hit = false;
        e.originalEvent({
            mouse: function (me) {
                hit = mouse_1.mouse.button(me) === mouse_1.mouse.Button.LEFT;
            },
            touch: function () {
                hit = true;
            },
        });
        return hit;
    };
    PanLayer.prototype.dragStart = function (e) {
        this.hit(e) && this.im.start(e);
    };
    PanLayer.prototype.dragEnd = function () {
        this.im.unbind();
    };
    PanLayer.prototype.setupDragEvent = function () {
        var _this = this;
        var fovy0;
        this.im = new inertial_mouse_1.InertialMouse({
            down: function (e) {
                var canvas = _this.globe.canvas;
                var _a = _this.offset(e.r), x = _a.x, y = _a.y;
                var vf = _this.globe.viewFactory;
                var c0 = vf.coord2thetaphi(canvas.coordFromOffset(x, y));
                var cx = vf.coord2thetaphi(canvas.coordFromOffset(x + 1, y));
                var cy = vf.coord2thetaphi(canvas.coordFromOffset(x, y + 1));
                if (Math.abs(c0[1] - cx[1]) > Math.PI) {
                    cx[1] += (cx[1] > c0[1] ? -1 : +1) * 2 * Math.PI;
                }
                if (Math.abs(c0[1] - cy[1]) > Math.PI) {
                    cy[1] += (cy[1] > c0[1] ? -1 : +1) * 2 * Math.PI;
                }
                gl_matrix_1.mat2.set(_this.m, cx[1] - c0[1], cx[0] - c0[0], cy[1] - c0[1], cy[0] - c0[0]);
                fovy0 = _this.globe.viewFactory.fovy;
            },
            move: function (e) {
                var _a = e.d, dx = _a.x, dy = _a.y;
                var dCoord = gl_matrix_1.vec2.transformMat2(gl_matrix_1.vec2.create(), [dx, dy], _this.m);
                var vf = _this.globe.viewFactory;
                var scale = Math.min(_this.globe.viewFactory.fovy / fovy0, 1);
                vf.phi -= scale * dCoord[0];
                vf.theta -= scale * dCoord[1];
                vf.theta = (0, math_1.clamp)(vf.theta, -Math.PI / 2 + EPSILON, Math.PI / 2 - EPSILON);
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.animation = undefined;
                    });
                }
            },
            moveend: function () {
                _this.animation.stop();
            },
        });
        this.im.physics.k = 4.e-2;
        this.im.physics.friction = 0.05;
    };
    return PanLayer;
}(point_event_layer_1.PointerEventLayer));
exports.PanLayer = PanLayer;


/***/ }),

/***/ 8851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GlobePointerEvent = exports.PointerEventLayer = void 0;
var gl_matrix_1 = __webpack_require__(887);
var inertial_mouse_1 = __webpack_require__(5131);
var layer_1 = __webpack_require__(7288);
var PointerEventLayer = /** @class */ (function (_super) {
    __extends(PointerEventLayer, _super);
    function PointerEventLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHit = false;
        return _this;
    }
    PointerEventLayer.prototype.hover = function (e) { };
    PointerEventLayer.prototype.enter = function (e) { };
    PointerEventLayer.prototype.leave = function (e) { };
    PointerEventLayer.prototype.dragStart = function (e) { };
    PointerEventLayer.prototype.drag = function (e) { };
    PointerEventLayer.prototype.dragEnd = function (e) { };
    PointerEventLayer.prototype.offset = function (_a) {
        var x = _a.x, y = _a.y;
        var rect = this.globe.canvas.domElement.getBoundingClientRect();
        return {
            x: x - rect.left,
            y: y - rect.top,
        };
    };
    PointerEventLayer.initGlobe = function (globe) {
        globe.addLayer(new PointerEventInitiatorLayer());
    };
    PointerEventLayer.prototype._hover = function (e) {
        var hit = this.hit(e);
        this.hover(e);
        if (this.lastHit !== hit) {
            this.lastHit = hit;
            if (hit) {
                this.enter(e);
                return true;
            }
            else {
                this.leave(e);
            }
        }
    };
    return PointerEventLayer;
}(layer_1.Layer));
exports.PointerEventLayer = PointerEventLayer;
var GlobePointerEvent = /** @class */ (function (_super) {
    __extends(GlobePointerEvent, _super);
    function GlobePointerEvent(e, globe, view) {
        var _this = _super.call(this, e.e) || this;
        _this.globe = globe;
        _this.view = view;
        _this.coord = globe.canvas.coordFromClientCoord(e);
        return _this;
    }
    GlobePointerEvent.prototype.coord2offset = function (coord) {
        // @ts-ignore
        var p = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), __spreadArray(__spreadArray([], coord.xyz, true), [1], false), this.view.camera.pv);
        var x = p[0] / p[3];
        var y = p[1] / p[3];
        // const z = p[2] / p[3]
        var rect = this.globe.canvas.domElement.getBoundingClientRect();
        return [
            rect.width * (x + 1) / 2.,
            rect.height * (1 - (y + 1) / 2.),
        ];
    };
    return GlobePointerEvent;
}(inertial_mouse_1.SinglePointerEvent));
exports.GlobePointerEvent = GlobePointerEvent;
var PointerEventInitiatorLayer = /** @class */ (function (_super) {
    __extends(PointerEventInitiatorLayer, _super);
    function PointerEventInitiatorLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pointerPressed = false;
        _this.pointerEventLayers = [];
        _this.refreshPointEventLayers = function () {
            _this.pointerEventLayers =
                layers(_this.globe).filter(function (l) { return l instanceof PointerEventLayer; }).reverse();
        };
        return _this;
    }
    PointerEventInitiatorLayer.prototype.render = function (view) {
        this.view = view;
    };
    PointerEventInitiatorLayer.prototype.onAdd = function () {
        var _this = this;
        var clear;
        this.unbindDown = inertial_mouse_1.SinglePointerEvent.bindDown(this.canvas, function (downSe) {
            var activeLayer;
            var downGe = new GlobePointerEvent(downSe, _this.globe, _this.view);
            _this.pointerPressed = true;
            _this.globe.ee.emit('pointer-down', downGe);
            for (var _i = 0, _a = _this.pointerEventLayers; _i < _a.length; _i++) {
                var l = _a[_i];
                if (l.hit(downGe)) {
                    activeLayer = l;
                    break;
                }
            }
            if (activeLayer) {
                activeLayer.dragStart(new GlobePointerEvent(downSe, _this.globe, _this.view));
                var unbindMove_1 = inertial_mouse_1.SinglePointerEvent.bindMove(document, function (moveEvent) {
                    activeLayer.drag(new GlobePointerEvent(moveEvent, _this.globe, _this.view));
                });
                clear = function (cancelEvent) {
                    _this.pointerPressed = false;
                    activeLayer.dragEnd(new GlobePointerEvent(cancelEvent, _this.globe, _this.view));
                    unbindUp_1();
                    unbindMove_1();
                    clear = undefined;
                };
                var unbindUp_1 = inertial_mouse_1.SinglePointerEvent.bindUp(document, function (upSe) {
                    var upGe = new GlobePointerEvent(upSe, _this.globe, _this.view);
                    _this.globe.ee.emit('pointer-up', upGe);
                    clear(upSe);
                });
            }
        }, function (se) {
            clear && clear(se);
        });
        this.unbindHover = inertial_mouse_1.SinglePointerEvent.bindMove(this.canvas, function (se) {
            if (!_this.pointerPressed) {
                var e = new GlobePointerEvent(se, _this.globe, _this.view);
                for (var _i = 0, _a = _this.pointerEventLayers; _i < _a.length; _i++) {
                    var l = _a[_i];
                    if (l._hover(e)) {
                        break;
                    }
                }
            }
        });
        this.globe.ee.addListener('layer-change', this.refreshPointEventLayers);
    };
    PointerEventInitiatorLayer.prototype.onRemove = function () {
        this.globe.ee.removeListener('layer-change', this.refreshPointEventLayers);
        this.unbindHover();
        this.unbindDown();
    };
    Object.defineProperty(PointerEventInitiatorLayer.prototype, "canvas", {
        get: function () {
            return this.globe.canvas.domElement;
        },
        enumerable: false,
        configurable: true
    });
    return PointerEventInitiatorLayer;
}(layer_1.Layer));
function layers(globe) {
    var ls = [];
    globe.eachLayer(function (l) { return ls.push(l); });
    return ls;
}
// function unfocus() {
//   document.activeElement && (document.activeElement as HTMLElement).blur()
// }


/***/ }),

/***/ 7598:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RollLayer = void 0;
var inertial_mouse_1 = __webpack_require__(5131);
var mouse_1 = __webpack_require__(7312);
var point_event_layer_1 = __webpack_require__(8851);
var RollLayer = /** @class */ (function (_super) {
    __extends(RollLayer, _super);
    function RollLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RollLayer.prototype.onAdd = function () {
        this.setupDragEvent();
    };
    RollLayer.prototype.onRemove = function () {
        this.im.teardown();
    };
    RollLayer.prototype.hit = function (e) {
        var hit = false;
        e.originalEvent({
            mouse: function (me) {
                hit = mouse_1.mouse.button(me) === mouse_1.mouse.Button.MIDDLE;
            },
        });
        return hit;
    };
    RollLayer.prototype.dragStart = function (e) {
        this.im.start(e);
    };
    RollLayer.prototype.setupDragEvent = function () {
        var _this = this;
        this.im = new inertial_mouse_1.InertialMouse({
            move: function (e) {
                var _a = _this.offset(e.r), x = _a.x, y = _a.y;
                var _b = e.d, dx = _b.x, dy = _b.y;
                var canvas = _this.globe.canvas;
                x -= canvas.domElement.clientWidth / 2;
                y -= canvas.domElement.clientHeight / 2;
                if (x !== 0 && y !== 0) {
                    _this.globe.viewFactory.roll += (y * dx - x * dy) / (x * x + y * y);
                }
            },
            moveend: function () {
                _this.animation.stop();
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.animation = undefined;
                    });
                }
            },
        });
    };
    return RollLayer;
}(point_event_layer_1.PointerEventLayer));
exports.RollLayer = RollLayer;


/***/ }),

/***/ 1534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TouchLayer = void 0;
var layer_1 = __webpack_require__(7288);
var hammerjs_1 = __importDefault(__webpack_require__(840));
var math_1 = __webpack_require__(3774);
var angle_1 = __webpack_require__(9565);
var TouchLayer = /** @class */ (function (_super) {
    __extends(TouchLayer, _super);
    function TouchLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TouchLayer.prototype.onAdd = function () {
        this.mc = new hammerjs_1.default(this.canvas);
        this.handlePinch();
        this.handleDoubleTap();
        this.handleTap2();
    };
    TouchLayer.prototype.onRemove = function () {
        this.mc.destroy();
    };
    Object.defineProperty(TouchLayer.prototype, "canvas", {
        get: function () {
            return this.globe.canvas.domElement;
        },
        enumerable: false,
        configurable: true
    });
    TouchLayer.prototype.handleDoubleTap = function () {
        var _this = this;
        this.mc.get('doubletap').set({ posThreshold: 30 });
        this.mc.on('doubletap', function (e) {
            if (e.pointerType === 'touch') {
                var _a = e.center, clientX = _a.x, clientY = _a.y;
                var _b = zoomOnClientCoord(_this.globe, 0.5, { clientX: clientX, clientY: clientY }), theta = _b.theta, phi = _b.phi, fovy = _b.fovy;
                _this.globe.viewFactory.jumpTo({ theta: theta, phi: phi, fovy: fovy });
                _this.globe.requestRefresh();
            }
        });
    };
    TouchLayer.prototype.handleTap2 = function () {
        var _this = this;
        this.mc.add(new hammerjs_1.default.Tap({ event: 'tap2', pointers: 2 }));
        this.mc.on('tap2', function (e) {
            var vf = _this.globe.viewFactory;
            vf.jumpTo({ fovy: vf.fovy * 2 });
        });
    };
    TouchLayer.prototype.handlePinch = function () {
        var _this = this;
        this.mc.get('pinch').set({ enable: true });
        var scale;
        this.mc.on('pinchstart', function (e) {
            scale = 1;
        });
        this.mc.on('pinchmove', function (e) {
            var _a = e.center, clientX = _a.x, clientY = _a.y;
            var _b = zoomOnClientCoord(_this.globe, scale / e.scale, { clientX: clientX, clientY: clientY }), theta = _b.theta, phi = _b.phi, fovy = _b.fovy;
            var vf = _this.globe.viewFactory;
            scale = e.scale;
            vf.theta = theta;
            vf.phi = phi;
            vf.fovy = fovy;
            vf.cage();
            _this.globe.requestRefresh();
        });
    };
    return TouchLayer;
}(layer_1.Layer));
exports.TouchLayer = TouchLayer;
function zoomOnClientCoord(globe, dScale, clinentCoord) {
    var canvas = globe.canvas;
    var vf = globe.viewFactory;
    var pole = vf.thetaphi2xyz(Math.PI / 2, 0);
    var centerXyz = vf.thetaphi2xyz(vf.theta, vf.phi);
    var targetXyz = canvas.xyzFromClientCoord(clinentCoord);
    var x1 = centerXyz[0], y1 = centerXyz[1], z1 = centerXyz[2];
    var x2 = targetXyz[0], y2 = targetXyz[1], z2 = targetXyz[2];
    var dx = (1 - dScale) * (x2 - x1);
    var dy = (1 - dScale) * (y2 - y1);
    var dz = (1 - dScale) * (z2 - z1);
    var dp = (0, math_1.dot)(pole, centerXyz); // cos(<(center, pole))
    var cp = Math.sqrt(1 - dp * dp); // sin(<(center, pole))
    if (cp < vf.fovy) {
        var r = (0, math_1.clamp)(cp / vf.fovy - 0.1, 0, 1);
        dx = r * dx + (1 - r) * x1;
        dy = r * dy + (1 - r) * y1;
        dz = r * dz + (1 - r) * z1;
    }
    x1 += dx;
    y1 += dy;
    z1 += dz;
    var coord = angle_1.EquatorialCoord.fromXyz([x1, y1, z1]);
    var _a = vf.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
    return {
        theta: theta,
        phi: phi,
        fovy: vf.fovy * dScale,
    };
}


/***/ }),

/***/ 8622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ZoomLayer = void 0;
var inertial_wheel_1 = __webpack_require__(6703);
var __1 = __webpack_require__(3607);
var math_1 = __webpack_require__(3774);
var layer_1 = __webpack_require__(7288);
var ZoomLayer = /** @class */ (function (_super) {
    __extends(ZoomLayer, _super);
    function ZoomLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.k = 7.5e-2;
        _this.pointerDown = function () {
            _this.animation && _this.animation.stop();
        };
        return _this;
    }
    ZoomLayer.prototype.onAdd = function () {
        var _this = this;
        this.globe.ee.on('pointer-down', this.pointerDown);
        this.iw = new inertial_wheel_1.InertialWheel(this.globe.canvas.domElement, {
            wheel: function (e) {
                var canvas = _this.globe.canvas;
                var vf = _this.globe.viewFactory;
                var dScale = Math.exp(_this.k * e.v);
                var pole = vf.thetaphi2xyz(Math.PI / 2, 0);
                var centerXyz = vf.thetaphi2xyz(vf.theta, vf.phi);
                var targetXyz = canvas.xyzFromClientCoord(e.originalEvent);
                var x1 = centerXyz[0], y1 = centerXyz[1], z1 = centerXyz[2];
                var x2 = targetXyz[0], y2 = targetXyz[1], z2 = targetXyz[2];
                var dx = (1 - dScale) * (x2 - x1);
                var dy = (1 - dScale) * (y2 - y1);
                var dz = (1 - dScale) * (z2 - z1);
                var dp = (0, math_1.dot)(pole, centerXyz); // cos(<(center, pole))
                var cp = Math.sqrt(1 - dp * dp); // sin(<(center, pole))
                if (cp < vf.fovy) {
                    var r = (0, math_1.clamp)(cp / vf.fovy - 0.1, 0, 1);
                    dx = r * dx + (1 - r) * x1;
                    dy = r * dy + (1 - r) * y1;
                    dz = r * dz + (1 - r) * z1;
                }
                x1 += dx;
                y1 += dy;
                z1 += dz;
                var coord = __1.EquatorialCoord.fromXyz([x1, y1, z1]);
                var _a = vf.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
                vf.theta = theta;
                vf.phi = phi;
                vf.fovy *= dScale;
                vf.cage();
            },
            wheelend: function () {
                _this.animation.stop();
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.iw.stop();
                        _this.animation = undefined;
                    });
                }
            },
        });
        this.iw.physics.t1 = 150;
        this.iw.physics.t2 = 150;
    };
    ZoomLayer.prototype.onRemove = function () {
        this.iw.teardown();
        this.globe.ee.off('pointer-down', this.pointerDown);
    };
    return ZoomLayer;
}(layer_1.Layer));
exports.ZoomLayer = ZoomLayer;


/***/ }),

/***/ 4423:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SinglePointerEvent = exports.isTouchEvent = void 0;
var v2_1 = __webpack_require__(4563);
function isTouchEvent(e) {
    return window.TouchEvent && e instanceof TouchEvent;
}
exports.isTouchEvent = isTouchEvent;
var SinglePointerEvent = /** @class */ (function () {
    function SinglePointerEvent(e) {
        this.e = e;
    }
    SinglePointerEvent.prototype.stopPropagation = function () {
        this.e.stopPropagation();
    };
    SinglePointerEvent.prototype.preventDefault = function () {
        this.e.preventDefault();
    };
    Object.defineProperty(SinglePointerEvent.prototype, "clientX", {
        get: function () {
            if (isTouchEvent(this.e)) {
                return (this.e.type === 'touchend' ? this.e.changedTouches : this.e.touches).item(0).clientX;
            }
            else {
                return this.e.clientX;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SinglePointerEvent.prototype, "clientY", {
        get: function () {
            if (isTouchEvent(this.e)) {
                return (this.e.type === 'touchend' ? this.e.changedTouches : this.e.touches).item(0).clientY;
            }
            else {
                return this.e.clientY;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SinglePointerEvent.prototype, "clientCoord", {
        get: function () {
            return new v2_1.V2(this.clientX, this.clientY);
        },
        enumerable: false,
        configurable: true
    });
    SinglePointerEvent.bindDown = function (target, cb, cancel, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 1) {
                cb(new SinglePointerEvent(e));
            }
            if (e.touches.length > 1) {
                cancel && cancel(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mousedown', mouse, useCapture);
        target.addEventListener('touchstart', touch, useCapture);
        return function () {
            target.removeEventListener('mousedown', mouse, useCapture);
            target.removeEventListener('touchstart', touch, useCapture);
        };
    };
    SinglePointerEvent.bindMove = function (target, cb, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 1) {
                cb(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mousemove', mouse, useCapture);
        target.addEventListener('touchmove', touch, useCapture);
        return function () {
            target.removeEventListener('mousemove', mouse, useCapture);
            target.removeEventListener('touchmove', touch, useCapture);
        };
    };
    SinglePointerEvent.bindUp = function (target, cb, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 0) {
                cb(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mouseup', mouse, useCapture);
        target.addEventListener('touchend', touch, useCapture);
        return function () {
            target.removeEventListener('mouseup', mouse, useCapture);
            target.removeEventListener('touchend', touch, useCapture);
        };
    };
    SinglePointerEvent.prototype.originalEvent = function (_a) {
        var mouse = _a.mouse, touch = _a.touch;
        if (isTouchEvent(this.e)) {
            touch && touch(this.e);
        }
        else {
            mouse && mouse(this.e);
        }
    };
    return SinglePointerEvent;
}());
exports.SinglePointerEvent = SinglePointerEvent;


/***/ }),

/***/ 5131:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InertialMouse = exports.Physics = exports.V2 = exports.SinglePointerEvent = void 0;
var SinglePointerEvent_1 = __webpack_require__(4423);
Object.defineProperty(exports, "SinglePointerEvent", ({ enumerable: true, get: function () { return SinglePointerEvent_1.SinglePointerEvent; } }));
var v2_1 = __webpack_require__(4563);
Object.defineProperty(exports, "V2", ({ enumerable: true, get: function () { return v2_1.V2; } }));
var physics_1 = __webpack_require__(3132);
Object.defineProperty(exports, "Physics", ({ enumerable: true, get: function () { return physics_1.Physics; } }));
var inertial_mouse_1 = __webpack_require__(6336);
Object.defineProperty(exports, "InertialMouse", ({ enumerable: true, get: function () { return inertial_mouse_1.InertialMouse; } }));


/***/ }),

/***/ 6336:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MoveEndEvent = exports.MoveStartEvent = exports.MoveEvent = exports.UpEvent = exports.DownEvent = exports.InertialMouse = void 0;
var SinglePointerEvent_1 = __webpack_require__(4423);
var physics_1 = __webpack_require__(3132);
var InertialMouse = /** @class */ (function () {
    function InertialMouse(cb) {
        var _this = this;
        this.cb = cb;
        this.physics = new physics_1.Physics();
        this.dead = false;
        this.events = [];
        this.pointmove = function (e) {
            if (_this.dead) {
                return;
            }
            _this.physics.hook(e.clientCoord);
            _this.cb.setNextTick(function () { return _this.tick(); });
        };
        this.pointend = function (e) {
            if (_this.dead) {
                return;
            }
            _this.physics.unhook();
            _this.unbind();
            _this.cb.up && _this.cb.up(new UpEvent(e.clientCoord, e));
        };
        cb.setNextTick = cb.setNextTick || defaultSetNextTick();
    }
    InertialMouse.prototype.teardown = function () {
        this.dead = true;
        this.unbind();
    };
    InertialMouse.prototype.stop = function () {
        this.physics.stop();
    };
    InertialMouse.prototype.unbind = function () {
        while (this.events.length > 0) {
            this.events.pop()();
        }
    };
    InertialMouse.prototype.start = function (e) {
        var r = e.clientCoord;
        this.physics.put(r);
        this.events.push(SinglePointerEvent_1.SinglePointerEvent.bindMove(document, this.pointmove));
        this.events.push(SinglePointerEvent_1.SinglePointerEvent.bindUp(document, this.pointend));
        this.cb.down && this.cb.down(new DownEvent(r, e));
    };
    InertialMouse.prototype.tick = function () {
        var _this = this;
        if (this.dead) {
            return;
        }
        var _a = this.physics.tick(performance.now()), r = _a.r, dr = _a.dr, movestart = _a.movestart, moveend = _a.moveend;
        movestart && this.cb.movestart && this.cb.movestart(new MoveStartEvent());
        this.cb.move && this.cb.move(new MoveEvent(r, dr));
        moveend && this.cb.moveend && this.cb.moveend(new MoveEndEvent());
        moveend || this.cb.setNextTick(function () { return _this.tick(); });
    };
    return InertialMouse;
}());
exports.InertialMouse = InertialMouse;
function defaultSetNextTick() {
    var rafId;
    return function (tick) {
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                tick();
            });
        }
    };
}
var DownEvent = /** @class */ (function () {
    function DownEvent(r, pointerEvent) {
        this.r = r;
        this.pointerEvent = pointerEvent;
    }
    return DownEvent;
}());
exports.DownEvent = DownEvent;
var UpEvent = /** @class */ (function () {
    function UpEvent(r, pointerEvent) {
        this.r = r;
        this.pointerEvent = pointerEvent;
    }
    return UpEvent;
}());
exports.UpEvent = UpEvent;
var MoveEvent = /** @class */ (function () {
    function MoveEvent(r, d) {
        this.r = r;
        this.d = d;
    }
    return MoveEvent;
}());
exports.MoveEvent = MoveEvent;
var MoveStartEvent = /** @class */ (function () {
    function MoveStartEvent() {
    }
    return MoveStartEvent;
}());
exports.MoveStartEvent = MoveStartEvent;
var MoveEndEvent = /** @class */ (function () {
    function MoveEndEvent() {
    }
    return MoveEndEvent;
}());
exports.MoveEndEvent = MoveEndEvent;


/***/ }),

/***/ 3132:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Physics = void 0;
var v2_1 = __webpack_require__(4563);
var Physics = /** @class */ (function () {
    function Physics() {
        this.k = 2.0e-2;
        this.friction = 0.2;
        this.slick = true;
        this.minV = 0.5;
        this.bound = false;
        this.moving = false;
    }
    Physics.prototype.put = function (r) {
        this.r = this.anchor = r;
        this.v = new v2_1.V2(0, 0);
    };
    Physics.prototype.hook = function (anchor) {
        this.bound = true;
        this.anchor = anchor;
    };
    Physics.prototype.unhook = function () {
        this.bound = false;
    };
    Physics.prototype.stop = function () {
        this.anchor = this.r;
        this.v = new v2_1.V2(0, 0);
        this.moving = false;
    };
    Physics.prototype.tick = function (t) {
        var k = this.k;
        var moving0 = this.moving;
        var r0 = this.r.clone();
        if (!moving0) {
            this.t = t;
        }
        var T = k * (t - this.t);
        var maxDT = 0.5;
        while (T > 0) {
            var dt = Math.min(maxDT, T);
            var delta = new v2_1.V2(this.anchor.x - this.r.x, this.anchor.y - this.r.y);
            var a = this.bound || !this.slick ? new v2_1.V2(// acceleration of critical damping
            delta.x - 2 * this.v.x, delta.y - 2 * this.v.y) : new v2_1.V2(// friction
            -this.friction * this.v.x, -this.friction * this.v.y);
            this.v.x += dt * a.x;
            this.v.y += dt * a.y;
            var dx = dt * this.v.x;
            var dy = dt * this.v.y;
            this.r.x += dx;
            this.r.y += dy;
            T -= maxDT;
        }
        var dr = new v2_1.V2(this.r.x - r0.x, this.r.y - r0.y);
        this.t = t;
        this.moving = this.willMove();
        return {
            r: this.r,
            dr: dr,
            movestart: !moving0,
            moveend: !this.moving,
        };
    };
    Physics.prototype.willMove = function () {
        var minV = this.minV = 1;
        if (this.bound || !this.slick) {
            return Math.abs(this.anchor.x - this.r.x) > minV || Math.abs(this.anchor.y - this.r.y) > minV;
        }
        else {
            var v = this.v;
            var f = this.friction;
            return Math.abs(v.x / f) >= minV || Math.abs(v.y / f) >= minV;
        }
    };
    return Physics;
}());
exports.Physics = Physics;


/***/ }),

/***/ 4563:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V2 = void 0;
var V2 = /** @class */ (function () {
    function V2(x, y) {
        this.x = x;
        this.y = y;
    }
    V2.prototype.clone = function () { return new V2(this.x, this.y); };
    return V2;
}());
exports.V2 = V2;


/***/ }),

/***/ 6703:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Physics = exports.InertialWheel = void 0;
var inertial_wheel_1 = __webpack_require__(5723);
Object.defineProperty(exports, "InertialWheel", ({ enumerable: true, get: function () { return inertial_wheel_1.InertialWheel; } }));
var physics_1 = __webpack_require__(5680);
Object.defineProperty(exports, "Physics", ({ enumerable: true, get: function () { return physics_1.Physics; } }));


/***/ }),

/***/ 5723:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InertialWheelEndEvent = exports.InertialWheelStartEvent = exports.InertialWheelEvent = exports.InertialWheel = void 0;
var magic_trackpad_detector_1 = __webpack_require__(5661);
var physics_1 = __webpack_require__(5680);
var InertialWheel = /** @class */ (function () {
    function InertialWheel(target, cb) {
        var _this = this;
        this.target = target;
        this.cb = cb;
        this.physics = new physics_1.Physics();
        this.magicTrackpadDetector = new magic_trackpad_detector_1.MagicTrackpadDetector();
        this.wheel = function (e) {
            e.preventDefault();
            if (!_this.magicTrackpadDetector.inertial(e)) {
                _this.lastNativeEvent = e;
                var a = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
                _this.physics.kick(a, performance.now());
            }
            _this.cb.setNextTick(function () { return _this.tick(); });
        };
        this.normalize = 60 / 1000;
        if (cb.setNextTick === undefined) {
            cb.setNextTick = defaultSetNextTick();
        }
        target.addEventListener('wheel', this.wheel);
    }
    InertialWheel.prototype.teardown = function () {
        this.target.removeEventListener('wheel', this.wheel);
    };
    InertialWheel.prototype.stop = function () {
        this.physics.stop();
    };
    InertialWheel.prototype.tick = function () {
        var _this = this;
        var _a = this.physics.tick(performance.now()), v = _a.v, dt = _a.dt, wheelstart = _a.wheelstart, wheelend = _a.wheelend;
        wheelstart && this.cb.wheelstart && this.cb.wheelstart(new InertialWheelStartEvent());
        this.cb.wheel && this.cb.wheel(new InertialWheelEvent(this.normalize * dt * v, this.lastNativeEvent));
        wheelend && this.cb.wheelend && this.cb.wheelend(new InertialWheelEndEvent());
        wheelend || this.cb.setNextTick(function () { return _this.tick(); });
    };
    return InertialWheel;
}());
exports.InertialWheel = InertialWheel;
var InertialWheelEvent = /** @class */ (function () {
    function InertialWheelEvent(v, originalEvent) {
        this.v = v;
        this.originalEvent = originalEvent;
    }
    return InertialWheelEvent;
}());
exports.InertialWheelEvent = InertialWheelEvent;
var InertialWheelStartEvent = /** @class */ (function () {
    function InertialWheelStartEvent() {
    }
    return InertialWheelStartEvent;
}());
exports.InertialWheelStartEvent = InertialWheelStartEvent;
var InertialWheelEndEvent = /** @class */ (function () {
    function InertialWheelEndEvent() {
    }
    return InertialWheelEndEvent;
}());
exports.InertialWheelEndEvent = InertialWheelEndEvent;
function defaultSetNextTick() {
    var rafId;
    return function (tick) {
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                tick();
            });
        }
    };
}


/***/ }),

/***/ 5680:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Physics = void 0;
var defaults = {
    accDuration: 100,
    t1: 100,
    t2: 200,
};
var Physics = /** @class */ (function () {
    function Physics() {
        this.v = 0;
        this.moving = false;
        this.accDuration = defaults.accDuration;
        this.t1 = defaults.t1;
        this.t2 = defaults.t2;
        this.maxDT = 3 * 1000 / 60;
    }
    Physics.prototype.stop = function () {
        this.a = 0;
        this.v = 0;
        this.moving = false;
    };
    Physics.prototype.kick = function (a, t) {
        this.a = a;
        this.lastAcc = t;
    };
    Physics.prototype.tick = function (t) {
        var moving0 = this.moving;
        if (!moving0) {
            this.t = t;
        }
        if (t - this.lastAcc > this.accDuration) {
            this.a = 0;
        }
        var dt0 = t - this.t;
        var DT = dt0;
        while (DT > 0) {
            var dt = Math.min(DT, this.maxDT);
            DT -= this.maxDT;
            this.v += dt * (this.a === 0 ?
                -1. / this.t2 * this.v :
                this.a / this.t1);
            this.v = clamp(this.v, -1, 1);
        }
        this.t = t;
        this.moving = this.willMove();
        return {
            v: this.v,
            dt: Math.min(1000, dt0),
            wheelstart: !moving0,
            wheelend: !this.moving,
        };
    };
    Physics.prototype.willMove = function () {
        return this.t - this.lastAcc <= this.accDuration || Math.abs(this.v) >= 0.005;
    };
    Physics.defaults = defaults;
    return Physics;
}());
exports.Physics = Physics;
function clamp(x, min, max) {
    return x < min ? min : (x > max ? max : x);
}


/***/ }),

/***/ 2880:
/***/ (() => {

"use strict";



/***/ }),

/***/ 4415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BillboardRenderer = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var pack_rects_1 = __webpack_require__(5574);
var canvas_1 = __webpack_require__(5451);
var BillboardRenderer = /** @class */ (function () {
    function BillboardRenderer(gl, images, imageRefs) {
        if (images === void 0) { images = []; }
        if (imageRefs === void 0) { imageRefs = []; }
        this.gl = gl;
        this.scale = 1;
        this.alpha = 1;
        this.color = [1, 1, 1, 1];
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(5297)/* ["default"] */ .Z, __webpack_require__(3638)/* ["default"] */ .Z);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_vCoord', nComponents: 3 },
                { name: 'a_size', nComponents: 2 },
                { name: 'a_tCoord', nComponents: 2 },
            ],
        });
        this.texture = new gl_wrapper_1.Texture(gl);
        this.buildArray(images, imageRefs);
    }
    BillboardRenderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.texture.release();
    };
    BillboardRenderer.prototype.buildArray = function (images, imageRefs) {
        var _this = this;
        var gl = this.gl;
        var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        this.packedTexture = packTextures(images, maxTextureSize);
        this.texture.bind(function () {
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this.packedTexture.imageData);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
            gl.generateMipmap(gl.TEXTURE_2D);
        });
        var attrs = [];
        var _a = this.packedTexture.imageData, W = _a.width, H = _a.height;
        for (var _i = 0, imageRefs_1 = imageRefs; _i < imageRefs_1.length; _i++) {
            var s = imageRefs_1[_i];
            var _b = s.position, x = _b[0], y = _b[1], z = _b[2];
            var _c = this.packedTexture.bbox[s.imageID], _d = _c.rect, l = _d.left, r = _d.right, t = _d.top, b = _d.bottom, w = _d.width, h = _d.height, o = _c.origin;
            attrs.push(x, y, z, (-1 + o[0]) * w, (-1 + o[1]) * h, l / W, b / H, x, y, z, (+1 + o[0]) * w, (-1 + o[1]) * h, r / W, b / H, x, y, z, (+1 + o[0]) * w, (+1 + o[1]) * h, r / W, t / H, x, y, z, (-1 + o[0]) * w, (-1 + o[1]) * h, l / W, b / H, x, y, z, (+1 + o[0]) * w, (+1 + o[1]) * h, r / W, t / H, x, y, z, (-1 + o[0]) * w, (+1 + o[1]) * h, l / W, t / H);
        }
        this.attribList.setData({
            array: new Float32Array(attrs),
        });
    };
    BillboardRenderer.prototype.render = function (view) {
        var _this = this;
        var alpha = this.alpha;
        if (this.attribList.vertexCount === 0 || alpha <= 0) {
            return;
        }
        var gl = this.gl;
        var p = this.program;
        p.use();
        var ratio = this.scale * (view.retina ? devicePixelRatio : 1);
        p.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
        p.uniform4fv({ u_color: this.color });
        p.uniform1i({ u_texture: 0 });
        p.uniform1f({
            u_alpha: alpha,
            u_width: 1 / ratio * gl.drawingBufferWidth,
            u_height: 1 / ratio * gl.drawingBufferHeight,
        });
        gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
            gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
            _this.texture.bind(function () {
                _this.attribList.enable(p, function () {
                    gl.drawArrays(gl.TRIANGLES, 0, _this.attribList.vertexCount);
                });
            });
        });
    };
    return BillboardRenderer;
}());
exports.BillboardRenderer = BillboardRenderer;
function packTextures(images, maxTextureSize) {
    var rects = images.map(function (image) { return new pack_rects_1.Rect(image.imageData.width + 2, image.imageData.height + 2); });
    try {
        (0, pack_rects_1.packRectsOptimally)(rects, maxTextureSize);
    }
    catch (e) {
        console.warn(e);
        return {
            imageData: new ImageData(1, 1),
            bbox: [],
        };
    }
    var width = (0, pack_rects_1.powerOf2)(Math.max.apply(Math, rects.map(function (r) { return r.right; })));
    var height = (0, pack_rects_1.powerOf2)(Math.max.apply(Math, rects.map(function (r) { return r.bottom; })));
    return (0, canvas_1.get2dContext)(width, height, function (ctx) {
        var bbox = [];
        for (var i = 0; i < images.length; ++i) {
            var image = images[i];
            var rect = rects[i];
            ctx.putImageData(image.imageData, rect.left + 1, rect.top + 1);
            bbox.push({ rect: rect, origin: image.origin });
        }
        // window.open(ctx.canvas.toDataURL()) // for debug
        return {
            imageData: ctx.getImageData(0, 0, width, height),
            bbox: bbox,
        };
    });
}


/***/ }),

/***/ 5574:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.powerOf2 = exports.packRectsOptimally = exports.Rect = void 0;
var Rect = /** @class */ (function () {
    function Rect(width, height, position) {
        if (position === void 0) { position = [0, 0]; }
        this.width = width;
        this.height = height;
        this.position = position;
    }
    Object.defineProperty(Rect.prototype, "left", {
        get: function () { return this.position[0]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "top", {
        get: function () { return this.position[1]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "right", {
        get: function () { return this.left + this.width; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "bottom", {
        get: function () { return this.top + this.height; },
        enumerable: false,
        configurable: true
    });
    Rect.prototype.intersect = function (other) {
        return (!(this.right <= other.left || this.left >= other.right) &&
            !(this.top >= other.bottom || this.bottom <= other.top));
    };
    return Rect;
}());
exports.Rect = Rect;
function packRects(rects, height) {
    rects = rects.slice().sort(function (a, b) { return a.height - b.height; });
    var packed = [];
    var cands = [[0, 0]];
    var _loop_1 = function () {
        var r = rects.pop();
        cands.sort(function (a, b) { return a[0] - b[0]; });
        for (var i = 0; i < cands.length; ++i) {
            var c = cands[i];
            r.position = c;
            if (r.bottom <= height && packed.every(function (p) { return !p.intersect(r); })) {
                packed.push(r);
                cands.splice(i, 1, [r.right, r.top], [r.left, r.bottom]);
                break;
            }
        }
    };
    while (rects.length > 0) {
        _loop_1();
    }
}
function packRectsOptimally(rects, maxSize) {
    var maxWidth = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.width; })));
    var height = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.height; })));
    var minArea = Infinity;
    var optimalHeight = -1;
    for (; true; height <<= 1) {
        var packed = packRects(rects, height);
        var width = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.right; })));
        if (width > maxSize) {
            continue;
        }
        var area = width * height;
        if (area < minArea) {
            minArea = area;
            optimalHeight = height;
        }
        if (width === maxWidth) {
            break;
        }
    }
    if (optimalHeight < 0) {
        throw new Error("Sprite Texture too large");
    }
    packRects(rects, optimalHeight);
}
exports.packRectsOptimally = packRectsOptimally;
function powerOf2(n) {
    var p = 1;
    while (p < n) {
        p *= 2;
    }
    return p;
}
exports.powerOf2 = powerOf2;


/***/ }),

/***/ 1174:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CubeMappRenderer = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var gl_matrix_1 = __webpack_require__(887);
var CubeMappRenderer = /** @class */ (function () {
    function CubeMappRenderer(gl) {
        this.gl = gl;
        this.alpha = 1;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(1579)/* ["default"] */ .Z, __webpack_require__(8032)/* ["default"] */ .Z);
        this.buildArray();
    }
    CubeMappRenderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.indexBuffer.release();
        this.texture && this.gl.deleteTexture(this.texture);
    };
    CubeMappRenderer.prototype.render = function (view) {
        var _this = this;
        if (this.texture === undefined) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var p = this.program;
        var gl = this.gl;
        p.use();
        p.enableAttribList(this.attribList, function () {
            p.uniform1i({ u_cubeTexture: 0 });
            // @ts-ignore
            p.uniformMatrix4fv({ u_pvMatrix: view.camera.pv, u_mMatrix: _this.mMatrix() });
            p.uniform3fv({ u_eyePosition: view.camera.eyePosition });
            p.uniform1f({
                u_alpha: alpha,
                u_radius: 1,
            });
            gl_wrapper_1.utils.enable(gl, [gl.BLEND, gl.CULL_FACE], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                _this.indexBuffer.bind(function () {
                    gl.bindTexture(gl.TEXTURE_CUBE_MAP, _this.texture);
                    gl.drawElements(gl.TRIANGLES, _this.indexBuffer.length, gl.UNSIGNED_SHORT, 0);
                    gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
                });
            });
        });
    };
    CubeMappRenderer.prototype.mMatrix = function () {
        return E;
    };
    CubeMappRenderer.prototype.buildArray = function () {
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [
                { name: 'a_position', nComponents: 3 },
            ],
            array: new Float32Array([
                -1, -1, -1,
                -1, -1, +1,
                -1, +1, -1,
                -1, +1, +1,
                +1, -1, -1,
                +1, -1, +1,
                +1, +1, -1,
                +1, +1, +1,
            ]),
        });
        this.indexBuffer = new gl_wrapper_1.IndexBuffer(this.gl, {
            array: new Int16Array([
                1, 0, 2, 1, 2, 3,
                1, 7, 5, 1, 3, 7,
                5, 7, 6, 4, 5, 6,
                3, 6, 7, 2, 6, 3,
                0, 6, 2, 0, 4, 6,
                0, 1, 5, 0, 5, 4,
            ]),
        });
    };
    CubeMappRenderer.prototype.setupTexture = function () {
        var gl = this.gl;
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.texture);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
    };
    CubeMappRenderer.prototype.setCubeImage = function (images) {
        this.texture || this.setupTexture();
        var gl = this.gl;
        var targets = [
            gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
        ];
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.texture);
        for (var i = 0; i < targets.length; ++i) {
            gl.texImage2D(targets[i], 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, images[i]);
        }
        gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
    };
    CubeMappRenderer.faces = ['px', 'py', 'pz', 'nx', 'ny', 'nz'];
    return CubeMappRenderer;
}());
exports.CubeMappRenderer = CubeMappRenderer;
var E = gl_matrix_1.mat4.create();


/***/ }),

/***/ 8438:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoordFrame = void 0;
var gl_matrix_1 = __webpack_require__(887);
// Reconsidering the Galactic coordinate system
// J.-C. Liu, Z. Zhu, and H. Zhang
// A&A 526, A16 (2011)
// https://www.aanda.org/articles/aa/pdf/2011/02/aa14961-10.pdf
var g2e = gl_matrix_1.mat3.fromValues(// N_J (9)
-0.054875539390, -0.873437104725, -0.483834991775, +0.494109453633, -0.444829594298, +0.746982248696, -0.867666135681, -0.198076389622, +0.455983794523);
var CoordFrame = /** @class */ (function () {
    function CoordFrame(mat) {
        this.mat = mat;
        this.invMat = gl_matrix_1.mat3.transpose(gl_matrix_1.mat3.create(), mat);
    }
    CoordFrame.prototype.rotate = function (v) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], v, this.mat);
    };
    CoordFrame.prototype.invert = function (v) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], v, this.invMat);
    };
    CoordFrame.GALACTIC = new CoordFrame(g2e);
    CoordFrame.EQUATORIAL = new CoordFrame(gl_matrix_1.mat3.identity(gl_matrix_1.mat3.create()));
    return CoordFrame;
}());
exports.CoordFrame = CoordFrame;


/***/ }),

/***/ 6319:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// tslint:disable:variable-name
// TODO: cleanup !!
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.size2order = exports.encode_id = exports.decode_id = exports.shiftmapId = exports.shiftmap = exports.coeff = void 0;
var PI = Math.PI;
var PI2 = 2 * Math.PI;
var PI_2 = Math.PI / 2;
var PI_4 = Math.PI / 4;
var PI_8 = Math.PI / 8;
exports.coeff = (function () {
    var i2xy = (function () {
        function index2xy(index) {
            var i = Math.floor(index / 4);
            var j = index % 4;
            var mesh = [0, 1 / 3, 2 / 3, 1];
            return [mesh[i], mesh[j]];
        }
        var a = [];
        for (var i = 0; i < 16; ++i) {
            a.push(index2xy(i));
        }
        return a;
    })();
    var za = [new Float32Array(16), new Float32Array(16), new Float32Array(16)];
    var zb = [new Float32Array(16), new Float32Array(16), new Float32Array(16)];
    var zeromat4 = new Float32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    return function (order, ipix) {
        var nside = 1 << order;
        var d = PI_4 / nside;
        var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
        var _b = fxy2tu(nside, f, x, y), t0 = _b.t, u0 = _b.u;
        var belt = Math.abs(u0) <= PI_4;
        var isBeltEnd = (f < 4 || 8 <= f) && x + y === nside - 1;
        if (isBeltEnd) {
            for (var i = 0; i < 16; ++i) {
                var _c = i2xy[i], p = _c[0], q = _c[1];
                var t = t0 + d * (1 - q - p);
                var u = u0 + d * (p - q);
                var zaNorth = tu2za(t, u, f >= 8);
                var zaSouth = tu2za(t, u, f < 4);
                var va = za2vec(zaNorth.z, zaNorth.a);
                var vb = za2vec(zaSouth.z, zaSouth.a);
                za[0][i] = va[0];
                za[1][i] = va[1];
                za[2][i] = va[2];
                zb[0][i] = vb[0];
                zb[1][i] = vb[1];
                zb[2][i] = vb[2];
            }
            var a = [mul(B, za[0]), mul(B, za[1]), mul(B, za[2])];
            var b = [mul(B, zb[0]), mul(B, zb[1]), mul(B, zb[2])];
            return { a: a, b: b };
        }
        else {
            for (var i = 0; i < 16; ++i) {
                var _d = i2xy[i], p = _d[0], q = _d[1];
                var t = t0 + d * (1 - q - p);
                var u = u0 + d * (p - q);
                // tslint:disable-next-line:no-shadowed-variable
                var _e = tu2za(t, u, belt), z = _e.z, a_1 = _e.a;
                var va = za2vec(z, a_1);
                za[0][i] = va[0];
                za[1][i] = va[1];
                za[2][i] = va[2];
            }
            var a = [mul(B, za[0]), mul(B, za[1]), mul(B, za[2])];
            var b = [zeromat4, zeromat4, zeromat4];
            return { a: a, b: b };
        }
    };
})();
function fxy2tu(nside, f, x, y) {
    var f_row = f >> 2;
    var f1 = f_row + 2;
    var f2 = 2 * (f % 4) - (f_row % 2) + 1;
    var v = x + y;
    var h = x - y;
    var i = f1 * nside - v - 1;
    var k = (f2 * nside + h + (8 * nside));
    var t = k / nside * PI_4;
    var u = PI_2 - i / nside * PI_4;
    return { t: t, u: u };
}
function tu2za(t, u, belt) {
    var abs_u = Math.abs(u);
    if (belt) {
        var z = u / (3 * PI_8);
        var a = t;
        return { z: z, a: a };
    }
    else {
        if (abs_u >= PI_2) {
            return { z: sign(u), a: 0 };
        }
        var t_t = t % (Math.PI / 2);
        var a = t - (abs_u - PI_4) / (abs_u - PI_2) * (t_t - PI_4);
        var z = sign(u) * (1 - 1 / 3 * square(2 - 4 * abs_u / PI));
        return { z: z, a: a };
    }
}
function za2vec(z, a) {
    var z2 = z * z;
    var sin_theta = z2 > 1 ? -Math.sqrt(z2 - 1) : Math.sqrt(1 - z2);
    var x = sin_theta * Math.cos(a);
    var y = sin_theta * Math.sin(a);
    return [x, y, z];
}
function mul(a, b) {
    var l = b.length;
    var c = new Float32Array(l);
    for (var i = 0; i < l; ++i) {
        var p = 0;
        for (var j = 0; j < l; ++j) {
            p += a[i + j * l] * b[j];
        }
        c[i] = p;
    }
    return c;
}
function dot(a, b) {
    var c = 0;
    for (var i = 0; i < a.length; ++i) {
        c += a[i] * b[i];
    }
    return c;
}
function ab2v(a, b, p, q, isBeltEnd) {
    var p2 = p * p;
    var p3 = p2 * p;
    var q2 = q * q;
    var q3 = q2 * q;
    if (isBeltEnd) {
        return p - q >= 0 ?
            a.map(function (aa) { return dot([p3, p2, p, 1], mul(aa, [q3, q2, q, 1])); }) :
            b.map(function (bb) { return dot([p3, p2, p, 1], mul(bb, [q3, q2, q, 1])); });
    }
    else {
        return a.map(function (aa) { return dot([p3, p2, p, 1], mul(aa, [q3, q2, q, 1])); });
    }
}
function beltEnd(nside, ipix) {
    var nside2 = nside * nside;
    var f = Math.floor(ipix / nside2);
    var _a = bit_decombine(ipix % nside2), x = _a.x, y = _a.y;
    return (f < 4 || 8 <= f) && x + y === nside - 1;
}
function shiftmap(order, ipix, size) {
    function encode(v) {
        var VMAX = 0.015;
        return ((v / VMAX) + 1) / 2 * 256;
    }
    var nside = 1 << order;
    var _a = (0, exports.coeff)(order, ipix), a = _a.a, b = _a.b;
    var d = new Uint8Array(3 * size * size);
    var isBeltEnd = beltEnd(nside, ipix);
    function dpq(p, q) {
        var v = ab2v(a, b, p, q, isBeltEnd);
        var _a = vec2pixcoord(nside, ipix, v), x = _a.x, y = _a.y;
        var trueP = y;
        var trueQ = 1 - x;
        return [p - trueP, q - trueQ];
    }
    var k = 0;
    for (var i = 0; i < size; ++i) {
        var q = i / (size - 1);
        for (var j = 0; j < size; ++j) {
            var p = j / (size - 1);
            var _b = dpq(p, q), dp = _b[0], dq = _b[1];
            d[3 * k + 0] = encode(dp);
            d[3 * k + 1] = encode(dq);
            d[3 * k + 2] = 0;
            ++k;
        }
    }
    return d;
}
exports.shiftmap = shiftmap;
function shiftmapId(order, index) {
    var nside = 1 << order;
    var nside2 = nside * nside;
    var f0 = Math.floor(index / nside2);
    var f = (f0 >> 2) << 2;
    var index2 = f * nside2 + (index % nside2);
    return encode_id(order, index2);
}
exports.shiftmapId = shiftmapId;
function vec2pixcoord(nside, ipix, v) {
    var n2 = nside * nside;
    var face = Math.floor(ipix / n2);
    var _a = vec2za(v[0], v[1], v[2]), z = _a.z, a0 = _a.a;
    var a = wrap(a0 - (face % 4 + 2.5) * PI_2, PI2) - PI + (face % 4 + 0.5) * PI_2;
    var _b = zaf2tu(z, a, face), t = _b.t, u = _b.u;
    var cfxy = nest2fxy(nside, ipix);
    var ctu = fxy2tu(nside, cfxy.f, cfxy.x, cfxy.y);
    var d = PI_4 / nside;
    var dt = (face % 4 === 1 || face % 4 === 2) ?
        wrap(t, PI2) - wrap(ctu.t, PI2) :
        wrap(t + PI, PI2) - wrap(ctu.t + PI, PI2);
    var du = u - ctu.u + d;
    return {
        x: (dt + du) / d / 2,
        y: (du - dt) / d / 2,
    };
}
function vec2za(x, y, z) {
    var r2 = x * x + y * y;
    if (r2 === 0) {
        return { z: z < 0 ? -1 : 1, a: 0 };
    }
    else {
        var a = (Math.atan2(y, x) + PI2) % PI2;
        z /= Math.sqrt(z * z + r2);
        return { z: z, a: a };
    }
}
function nest2fxy(nside, ipix) {
    var nside2 = nside * nside;
    var f = Math.floor(ipix / nside2); // base pixel index
    var k = ipix % nside2; // nested pixel index in base pixel
    var _a = bit_decombine(k), x = _a.x, y = _a.y;
    return { f: f, x: x, y: y };
}
function sigma(z) {
    if (z < 0) {
        return -sigma(-z);
    }
    else {
        return 2 - Math.sqrt(3 * (1 - z));
    }
}
function zaf2tu(z, a, f) {
    if (Math.abs(z) <= 2. / 3.) { // equatorial belt
        var t = a;
        var u = 3 * PI_8 * z;
        return { t: t, u: u };
    }
    else { // polar caps
        f %= 4;
        // a = clamp(a, f * PI_2, (f + 1) * PI_2)
        var p_t = a - (f * PI_2);
        var sigma_z = sigma(z);
        var t = a - (Math.abs(sigma_z) - 1) * (p_t - PI_4);
        var u = PI_4 * sigma_z;
        return { t: t, u: u };
    }
}
function wrap(x, p) {
    return x < 0 ? p - (-x % p) : x % p;
}
function square(x) {
    return x * x;
}
var sign = Math.sign || (function (x) {
    return x > 0 ? 1 : (x < 0 ? -1 : 0);
});
function bit_decombine(p) {
    assert(p <= 0x7fffffff);
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i):x}) >> {i}' for i in range(16))
    var x = (p & 0x1) >> 0 | (p & 0x4) >> 1 | (p & 0x10) >> 2 |
        (p & 0x40) >> 3 | (p & 0x100) >> 4 | (p & 0x400) >> 5 |
        (p & 0x1000) >> 6 | (p & 0x4000) >> 7 | (p & 0x10000) >> 8 |
        (p & 0x40000) >> 9 | (p & 0x100000) >> 10 | (p & 0x400000) >> 11 |
        (p & 0x1000000) >> 12 | (p & 0x4000000) >> 13 | (p & 0x10000000) >> 14 | (p & 0x40000000) >> 15;
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i + 1):x}) >> {i+1}' for i in range(15))
    var y = (p & 0x2) >> 1 | (p & 0x8) >> 2 | (p & 0x20) >> 3 |
        (p & 0x80) >> 4 | (p & 0x200) >> 5 | (p & 0x800) >> 6 |
        (p & 0x2000) >> 7 | (p & 0x8000) >> 8 | (p & 0x20000) >> 9 |
        (p & 0x80000) >> 10 | (p & 0x200000) >> 11 | (p & 0x800000) >> 12 |
        (p & 0x2000000) >> 13 | (p & 0x8000000) >> 14 | (p & 0x20000000) >> 15;
    return { x: x, y: y };
}
function decode_id(id) {
    assert(id <= 0x7fffffff);
    var order = 0;
    var l = (id >> 2) + 1;
    while (l >= 4) {
        l >>= 2;
        ++order;
    }
    var index = id - (((1 << (2 * order)) - 1) << 2);
    return { order: order, index: index };
}
exports.decode_id = decode_id;
function encode_id(order, index) {
    return 4 * ((1 << (2 * order)) - 1) + index;
}
exports.encode_id = encode_id;
function assert(condition) {
    console.assert(condition);
    if (!condition) {
        debugger;
    }
}
function size2order(size) {
    var n = 0;
    while (size > 0) {
        size >>= 1;
        ++n;
    }
    return n;
}
exports.size2order = size2order;
var B = new Float32Array([
    81 / 4, -81 / 2, 99 / 4, -9 / 2, -81 / 2, 81, -99 / 2, 9, 99 / 4, -99 / 2, 121 / 4, -11 / 2, -9 / 2, 9, -11 / 2, 1,
    -243 / 4, 243 / 2, -297 / 4, 27 / 2, 405 / 4, -405 / 2, 495 / 4, -45 / 2, -81 / 2, 81, -99 / 2, 9, 0, 0, 0, 0,
    243 / 4, -243 / 2, 297 / 4, -27 / 2, -81, 162, -99, 18, 81 / 4, -81 / 2, 99 / 4, -9 / 2, 0, 0, 0, 0,
    -81 / 4, 81 / 2, -99 / 4, 9 / 2, 81 / 4, -81 / 2, 99 / 4, -9 / 2, -9 / 2, 9, -11 / 2, 1, 0, 0, 0, 0,
    -243 / 4, 405 / 4, -81 / 2, 0, 243 / 2, -405 / 2, 81, 0, -297 / 4, 495 / 4, -99 / 2, 0, 27 / 2, -45 / 2, 9, 0,
    729 / 4, -1215 / 4, 243 / 2, 0, -1215 / 4, 2025 / 4, -405 / 2, 0, 243 / 2, -405 / 2, 81, 0, 0, 0, 0, 0,
    -729 / 4, 1215 / 4, -243 / 2, 0, 243, -405, 162, 0, -243 / 4, 405 / 4, -81 / 2, 0, 0, 0, 0, 0,
    243 / 4, -405 / 4, 81 / 2, 0, -243 / 4, 405 / 4, -81 / 2, 0, 27 / 2, -45 / 2, 9, 0, 0, 0, 0, 0,
    243 / 4, -81, 81 / 4, 0, -243 / 2, 162, -81 / 2, 0, 297 / 4, -99, 99 / 4, 0, -27 / 2, 18, -9 / 2, 0,
    -729 / 4, 243, -243 / 4, 0, 1215 / 4, -405, 405 / 4, 0, -243 / 2, 162, -81 / 2, 0, 0, 0, 0, 0,
    729 / 4, -243, 243 / 4, 0, -243, 324, -81, 0, 243 / 4, -81, 81 / 4, 0, 0, 0, 0, 0,
    -243 / 4, 81, -81 / 4, 0, 243 / 4, -81, 81 / 4, 0, -27 / 2, 18, -9 / 2, 0, 0, 0, 0, 0,
    -81 / 4, 81 / 4, -9 / 2, 0, 81 / 2, -81 / 2, 9, 0, -99 / 4, 99 / 4, -11 / 2, 0, 9 / 2, -9 / 2, 1, 0,
    243 / 4, -243 / 4, 27 / 2, 0, -405 / 4, 405 / 4, -45 / 2, 0, 81 / 2, -81 / 2, 9, 0, 0, 0, 0, 0,
    -243 / 4, 243 / 4, -27 / 2, 0, 81, -81, 18, 0, -81 / 4, 81 / 4, -9 / 2, 0, 0, 0, 0, 0,
    81 / 4, -81 / 4, 9 / 2, 0, -81 / 4, 81 / 4, -9 / 2, 0, 9 / 2, -9 / 2, 1, 0, 0, 0, 0, 0
]);


/***/ }),

/***/ 1025:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TileTexture = exports.TextureRef = exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TextureProvider = exports.CoordFrame = exports.Renderer = void 0;
var renderer_1 = __webpack_require__(9434);
Object.defineProperty(exports, "Renderer", ({ enumerable: true, get: function () { return renderer_1.Renderer; } }));
var coord_frame_1 = __webpack_require__(8438);
Object.defineProperty(exports, "CoordFrame", ({ enumerable: true, get: function () { return coord_frame_1.CoordFrame; } }));
var texture_provider_1 = __webpack_require__(4922);
Object.defineProperty(exports, "TextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.TextureProvider; } }));
Object.defineProperty(exports, "AsyncTextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.AsyncTextureProvider; } }));
// SimpleFitsTextureProvider,
Object.defineProperty(exports, "SimpleImageTextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.SimpleImageTextureProvider; } }));
Object.defineProperty(exports, "TextureRef", ({ enumerable: true, get: function () { return texture_provider_1.TextureRef; } }));
Object.defineProperty(exports, "TileTexture", ({ enumerable: true, get: function () { return texture_provider_1.TileTexture; } }));


/***/ }),

/***/ 8729:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchProperties = void 0;
var axios_1 = __importDefault(__webpack_require__(9669));
function fetchProperties(baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var url, txt, dict, _i, _a, line, _b, k, v;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = baseUrl + "/properties";
                    return [4 /*yield*/, axios_1.default.get(url, { responseType: 'text' })];
                case 1:
                    txt = (_c.sent()).data;
                    dict = {};
                    for (_i = 0, _a = txt.split('\n'); _i < _a.length; _i++) {
                        line = _a[_i];
                        if (!line.match(/^\s*#/)) {
                            if (line.indexOf('=') >= 0) {
                                _b = line.split('=').map(function (s) { return s.replace(/\s*(.*?)\s*$/, '$1'); }), k = _b[0], v = _b[1];
                                dict[k] = v;
                            }
                        }
                    }
                    if (!('hips_order' in dict) || !('hips_tile_width' in dict)) {
                        throw new Error("invalid properties file");
                    }
                    return [2 /*return*/, dict];
            }
        });
    });
}
exports.fetchProperties = fetchProperties;


/***/ }),

/***/ 9434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Renderer = void 0;
var cache_map_1 = __webpack_require__(1796);
var gl_wrapper_1 = __webpack_require__(3898);
var healpix = __importStar(__webpack_require__(5866));
var gl_matrix_1 = __webpack_require__(887);
var math_1 = __webpack_require__(3774);
var healpix_1 = __webpack_require__(6319);
var shiftmap = __importStar(__webpack_require__(9544));
var MIN_TILE_ORDER = 2;
var Renderer = /** @class */ (function () {
    function Renderer(globe, textureProvider) {
        this.globe = globe;
        this.textureProvider = textureProvider;
        this.alpha = 1;
        this.animationLod = 0;
        this.lodBias = 0;
        this.integerOrder = false;
        this.tileCache = new cache_map_1.CacheMap(5000, function (t) { return t.release(); });
        var gl = this.gl = this.globe.gl;
        this.program = gl_wrapper_1.Program.new(this.gl, __webpack_require__(5259)/* ["default"] */ .Z, __webpack_require__(7003)/* ["default"] */ .Z);
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [{ name: 'a_coord', nComponents: 2 }],
            array: this.buildArray(),
        });
        this.zeroTexture = new gl_wrapper_1.Texture(gl);
        this.zeroTexture.bind(function () {
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, 1, 1, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array([128]));
        });
        for (var i = MIN_TILE_ORDER; i < 5; ++i) {
            shiftmap.preload(i);
        }
    }
    Renderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.zeroTexture.release();
        this.tileCache.clear();
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        if (this.alpha <= 0) {
            return;
        }
        this.activateProgram(function () {
            var _a = _this, gl = _a.gl, program = _a.program;
            program.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
            // @ts-ignore
            program.uniformMatrix3fv({ u_rotMatrix: _this.textureProvider.coordFrame.mat });
            program.uniform1i({ u_shiftmap: 0 });
            program.uniform1i({ u_texture1: 1 });
            var order = _this.visibleTiles(view, function (rOrder, hid) {
                var tile = _this.tileCache.get(hid);
                if (!tile) {
                    tile = new Tile(_this, hid);
                    _this.tileCache.set(hid, tile);
                }
                tile.render(rOrder);
            });
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, null);
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(gl.TEXTURE_2D, null);
            order > MIN_TILE_ORDER && shiftmap.preload(order - 1);
            shiftmap.preload(order + 1);
            gl.activeTexture(gl.TEXTURE0);
        });
        this.textureProvider.flushQueue(this.textureProvider.coordFrame.invert(view.camera.direction));
    };
    Renderer.prototype.draw = function () {
        var gl = this.gl;
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
    };
    Renderer.prototype.visibleTiles = function (view, cb) {
        var _a = this.textureProvider, minTileOrder = _a.minTileOrder, maxTileOrder = _a.maxTileOrder, tileOrder = _a.tileOrder;
        var rOrder = (0, math_1.clamp)(this.realOrder(view) - tileOrder - (this.lodBias + this.animationLod * view.lodBias), minTileOrder, maxTileOrder);
        if (this.integerOrder) {
            rOrder = Math.floor(rOrder);
        }
        var order = Math.ceil((0, math_1.clamp)(rOrder, MIN_TILE_ORDER, maxTileOrder));
        var nside = 1 << order;
        query_disc_inclusive_nest(this.textureProvider.coordFrame, nside, view.camera.direction, view.camera.radius, function (index) {
            cb(rOrder, healpix.orderpix2uniq(order, index));
        });
        return order;
    };
    Renderer.prototype.realOrder = function (view) {
        var arc = view.camera.arc;
        return Math.log(Math.sqrt(Math.PI / 3) * this.globe.gl.drawingBufferHeight / arc) / Math.LN2;
    };
    Renderer.prototype.activateProgram = function (cb) {
        var gl = this.gl;
        this.program.use();
        this.attribList.enable(this.program, function () {
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                cb();
            });
        });
    };
    Renderer.prototype.buildArray = function () {
        var a = [];
        var step = 32;
        for (var i = 0; i < step; ++i) {
            var y = i / step;
            var y2 = (i + 1) / step;
            for (var j = 0; j <= step; ++j) {
                var x = j / step;
                for (var k = step > 1 && j === 0 ? 2 : 1; k !== 0; --k) {
                    a.push(y2, x);
                }
                for (var k = step > 1 && j === step ? 2 : 1; k !== 0; --k) {
                    a.push(y, x);
                }
            }
        }
        return new Float32Array(a);
    };
    return Renderer;
}());
exports.Renderer = Renderer;
function query_disc_inclusive_nest(cf, nside, center, radius, cb) {
    center = cf.invert(center);
    if (radius > Math.PI / 2) {
        var n = 12 * nside * nside;
        for (var i = 0; i < n; ++i) {
            cb(i);
        }
    }
    else {
        healpix.query_disc_inclusive_nest(nside, center, radius, cb);
    }
}
var Tile = /** @class */ (function () {
    function Tile(renderer, hid) {
        var _this = this;
        this.renderer = renderer;
        this.hid = hid;
        this.alreadyReleased = false;
        var _a = healpix.uniq2orderpix(hid), order = _a.order, index = _a.ipix;
        this.order = order;
        this.index = index;
        this.coeff = (0, healpix_1.coeff)(order, index);
        this.isBeltEnd = Tile.isBeltEnd(order, index);
        if (shiftmap.needShiftMap(order, index)) {
            shiftmap.fetch(order, index, function (arr) {
                if (!_this.alreadyReleased) {
                    var gl_1 = _this.renderer.globe.gl;
                    _this.shiftmap = new gl_wrapper_1.Texture(gl_1);
                    _this.shiftmap.bind(function () {
                        var size = shiftmap.size;
                        gl_1.texImage2D(gl_1.TEXTURE_2D, 0, gl_1.RGB, size, size, 0, gl_1.RGB, gl_1.UNSIGNED_BYTE, arr);
                    });
                }
            });
        }
    }
    Tile.prototype.release = function () {
        this.alreadyReleased = true;
        if (this.shiftmap) {
            this.shiftmap.release();
        }
    };
    Tile.prototype.render = function (rOrder) {
        var _this = this;
        var _a = this.renderer, gl = _a.gl, program = _a.program;
        program.uniform1f({ u_belt_end: this.isBeltEnd ? 1 : 0 });
        program.uniformMatrix4fv({
            u_ax: this.coeff.a[0],
            u_ay: this.coeff.a[1],
            u_az: this.coeff.a[2],
        });
        if (this.isBeltEnd) {
            program.uniformMatrix4fv({
                u_bx: this.coeff.b[0],
                u_by: this.coeff.b[1],
                u_bz: this.coeff.b[2],
            });
        }
        this.textures(rOrder, function (tt, tMatrix, textureAlpha) {
            // tslint:disable-next-line:variable-name
            var u_alpha = _this.renderer.alpha * textureAlpha;
            program.uniform1f({ u_alpha: u_alpha });
            // @ts-ignore
            program.uniformMatrix3fv({ u_tMatrix: tMatrix });
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(gl.TEXTURE_2D, tt.tex.name);
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, (_this.shiftmap || _this.renderer.zeroTexture).name);
            _this.renderer.draw();
        });
    };
    Tile.isBeltEnd = function (order, index) {
        var nside = 1 << order;
        var nside2 = nside * nside;
        var f = Math.floor(index / nside2);
        var _a = healpix.bit_decombine(index % nside2), x = _a.x, y = _a.y;
        return (f < 4 || 8 <= f) && x + y === nside - 1;
    };
    Tile.prototype.textures = function (rOrder, cb) {
        var tp = this.renderer.textureProvider;
        var tMaxOrder = Math.ceil(rOrder);
        var order = this.order;
        var index = this.index;
        var tMatrix = gl_matrix_1.mat3.create();
        var beta = 1;
        while (order >= tp.minTileOrder) {
            if (order <= tMaxOrder) {
                var hid = healpix.orderpix2uniq(order, index);
                var tt = tp.get(hid);
                if (tt) {
                    var alpha = (tMaxOrder === order ? 1 + rOrder - order : 1) * tt.fadeAlpha;
                    var invTMatrix = gl_matrix_1.mat3.invert(gl_matrix_1.mat3.create(), tMatrix);
                    cb(tt, invTMatrix, alpha * beta);
                    beta *= 1 - alpha;
                    if (alpha >= 1) {
                        break;
                    }
                }
                else {
                    tp.request(hid);
                }
            }
            gl_matrix_1.mat3.scale(tMatrix, tMatrix, [2, 2]);
            gl_matrix_1.mat3.translate(tMatrix, tMatrix, [index & 2 ? -0.5 : 0, index & 1 ? 0 : -0.5]);
            --order;
            index >>= 2;
        }
    };
    return Tile;
}());


/***/ }),

/***/ 9544:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.preload = exports.needShiftMap = exports.fetch = exports.size = void 0;
// tslint:disable-next-line:no-var-requires variable-name
var ShiftmapWorker = __webpack_require__(5693);
var healpix_1 = __webpack_require__(6319);
var interface_1 = __webpack_require__(5137);
Object.defineProperty(exports, "size", ({ enumerable: true, get: function () { return interface_1.DELTA_MAP_N; } }));
function fetch(order, index, then) {
    var id = (0, healpix_1.shiftmapId)(order, index);
    if (workerManager.cache.has(id)) {
        then(workerManager.cache.get(id));
    }
    else {
        workerManager.enqueue(id).then(then);
    }
}
exports.fetch = fetch;
var ShitmapWorkerManager = /** @class */ (function () {
    function ShitmapWorkerManager() {
        this.cache = new Map();
        this.resolve = new Map();
        this.queue = [];
    }
    ShitmapWorkerManager.prototype.enqueue = function (id) {
        var _this = this;
        if (this.cache.has(id)) {
            return Promise.resolve(this.cache.get(id));
        }
        if (this.processing !== id && this.queue.indexOf(id) < 0) {
            this.queue.push(id);
            this.doNextJob();
        }
        return new Promise(function (resolve) {
            if (!_this.resolve.has(id)) {
                _this.resolve.set(id, []);
            }
            _this.resolve.get(id).push(resolve);
        });
    };
    ShitmapWorkerManager.prototype.receiveShiftmap = function (_a) {
        var id = _a.id, arraybuffer = _a.arraybuffer;
        var array = new Uint8Array(arraybuffer);
        var i = this.queue.indexOf(id);
        if (i >= 0) {
            this.queue.splice(i, 1);
        }
        this.cache.set(id, array);
        if (this.resolve.has(id)) {
            for (var _i = 0, _b = this.resolve.get(id); _i < _b.length; _i++) {
                var r = _b[_i];
                r(array);
            }
            this.resolve.delete(id);
        }
    };
    ShitmapWorkerManager.prototype.doNextJob = function () {
        if (this.processing === undefined) {
            var id = this.queue.shift();
            if (id !== undefined) {
                var req = { id: id };
                this.startWorker();
                this.processing = id;
                this.worker.postMessage(req);
            }
            else {
                this.requestQuitWorker();
            }
        }
    };
    ShitmapWorkerManager.prototype.startWorker = function () {
        var _this = this;
        if (!this.worker) {
            this.cancelQuit();
            this.worker = new ShiftmapWorker();
            this.worker.addEventListener('message', function (e) {
                var res = e.data;
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var shiftmap = res_1[_i];
                    _this.receiveShiftmap(shiftmap);
                }
                _this.processing = undefined;
                _this.doNextJob();
            });
        }
    };
    ShitmapWorkerManager.prototype.cancelQuit = function () {
        if (this.quitTimer !== undefined) {
            clearTimeout(this.quitTimer);
            this.quitTimer = undefined;
        }
    };
    ShitmapWorkerManager.prototype.requestQuitWorker = function () {
        var _this = this;
        this.cancelQuit();
        this.quitTimer = setTimeout(function () {
            _this.quitTimer = undefined;
            _this.worker.terminate();
            _this.worker = undefined;
        }, 5000);
    };
    return ShitmapWorkerManager;
}());
// true for polar caps
function needShiftMap(order, index) {
    var nside = 1 << order;
    var nside2 = nside * nside;
    var f = Math.floor(index / nside2);
    if (4 <= f && f < 8) {
        return false;
    }
    var i = f >= 8 ? index % nside2 : nside2 - (index % nside2) - 1;
    return [0, 1, 2, 3].indexOf(i) >= 0;
}
exports.needShiftMap = needShiftMap;
var workerManager = new ShitmapWorkerManager();
function preload(order) {
    if (order === 0) {
        workerManager.enqueue((0, healpix_1.encode_id)(0, 0));
        workerManager.enqueue((0, healpix_1.encode_id)(0, 8));
    }
    else {
        var n2 = 1 << (2 * order);
        for (var i = 0; i < 4; ++i) {
            workerManager.enqueue((0, healpix_1.shiftmapId)(order, n2 - i - 1)); // north cap
            workerManager.enqueue((0, healpix_1.shiftmapId)(order, 8 * n2 + i)); // south cap
        }
    }
}
exports.preload = preload;


/***/ }),

/***/ 5137:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DELTA_MAP_N = void 0;
exports.DELTA_MAP_N = 64; // see frag.vert.glsl


/***/ }),

/***/ 4922:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TextureRef = exports.TileTexture = exports.TextureProvider = void 0;
var cache_map_1 = __webpack_require__(1796);
// import { Fits } from '@hscmap/fits'
var gl_wrapper_1 = __webpack_require__(3898);
var healpix = __importStar(__webpack_require__(5866));
var gl_matrix_1 = __webpack_require__(887);
var image_1 = __webpack_require__(5507);
var matrilx_utils_1 = __webpack_require__(3310);
var _1 = __webpack_require__(1025);
var healpix_1 = __webpack_require__(6319);
var properties_1 = __webpack_require__(8729);
var TextureProvider = /** @class */ (function () {
    function TextureProvider(globe, tileOrder, maxTileOrder, minTileOrder, coordFrame) {
        this.globe = globe;
        this.tileOrder = tileOrder;
        this.maxTileOrder = maxTileOrder;
        this.minTileOrder = minTileOrder;
        this.coordFrame = coordFrame;
    }
    return TextureProvider;
}());
exports.TextureProvider = TextureProvider;
var TileTexture = /** @class */ (function () {
    function TileTexture(tp) {
        var _this = this;
        this.fadeAlpha = 0;
        var gl = tp.globe.gl;
        this.tex = new gl_wrapper_1.Texture(gl);
        tp.globe.animation((function (_a) {
            var r = _a.r;
            _this.fadeAlpha = r;
        }), { duration: 200 });
    }
    TileTexture.prototype.release = function () {
        this.tex.release();
    };
    TileTexture.prototype.bind = function (cb) {
        this.tex.bind(cb);
    };
    return TileTexture;
}());
exports.TileTexture = TileTexture;
var TextureRef = /** @class */ (function () {
    function TextureRef(hid) {
        this.hid = hid;
        var _a = healpix.uniq2orderpix(hid), order = _a.order, ipix = _a.ipix;
        this.order = order;
        this.index = ipix;
        this.center = healpix.pix2vec_nest(1 << order, ipix);
    }
    return TextureRef;
}());
exports.TextureRef = TextureRef;
var AsyncTextureProvider = /** @class */ (function (_super) {
    __extends(AsyncTextureProvider, _super);
    function AsyncTextureProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = new cache_map_1.CacheMap(1000, function (tt) { return tt.release(); });
        _this.alreadyReleased = false;
        _this.refsToLoad = new Map();
        _this.refsInLoading = new Map();
        _this.deadHid = new Set();
        _this.nParallel = 4;
        return _this;
    }
    AsyncTextureProvider.prototype.release = function () {
        this.alreadyReleased = true;
        this.cache.clear();
    };
    AsyncTextureProvider.prototype.get = function (hid) {
        return this.cache.get(hid);
    };
    AsyncTextureProvider.prototype.request = function (hid) {
        if (!this.deadHid.has(hid) && !this.refsInLoading.has(hid) && !this.refsToLoad.has(hid)) {
            var ref = new TextureRef(hid);
            this.refsToLoad.set(hid, ref);
        }
    };
    AsyncTextureProvider.prototype.flushQueue = function (center) {
        var _this = this;
        if (this.refsInLoading.size >= this.nParallel) {
            return;
        }
        var refs = [];
        this.refsToLoad.forEach(function (ref) { return refs.push(ref); });
        refs.sort(function (a, b) {
            return a.order !== b.order ? a.order - b.order : gl_matrix_1.vec3.sqrDist(center, a.center) - gl_matrix_1.vec3.sqrDist(center, b.center);
        });
        var _loop_1 = function (ref) {
            if (this_1.refsInLoading.size >= this_1.nParallel) {
                return "break";
            }
            this_1.refsInLoading.set(ref.hid, ref);
            this_1.makeTileTexture(ref).then(function (tt) {
                if (_this.alreadyReleased) {
                    tt.release();
                }
                else {
                    _this.cache.set(ref.hid, tt, ref.order === _this.minTileOrder);
                    _this.globe.requestRefresh();
                }
            }).catch(function (e) {
                _this.deadHid.add(ref.hid);
            }).then(function () {
                _this.refsInLoading.delete(ref.hid);
            });
        };
        var this_1 = this;
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var ref = refs_1[_i];
            var state_1 = _loop_1(ref);
            if (state_1 === "break")
                break;
        }
        this.refsToLoad.clear();
    };
    return AsyncTextureProvider;
}(TextureProvider));
exports.AsyncTextureProvider = AsyncTextureProvider;
// export class SimpleFitsTextureProvider extends AsyncTextureProvider {
//     constructor(
//     globe: Globe,
//     readonly baseUrl: string,
//     tileOrder: number,
//     maxTileOrder: number,
//     minTileOrder: number,
//     coordFrame: CoordFrame,
//     ) {
//     super(globe, tileOrder, maxTileOrder, minTileOrder, coordFrame)
//     }
//     async makeTileTexture(ref: TextureRef): Promise<TileTexture> {
//     const url = this.tileId2Url(ref.order, ref.index)
//     const hdul = await Fits.fetch(url, [{ outputDataType: Fits.DataType.float32 }])
//     const tt = new TileTexture(this)
//     tt.bind(() => {
//       const gl = this.globe.gl
//       const hdu = hdul[0]
//       const width = hdu.card('NAXIS1', 'number')
//       const height = hdu.card('NAXIS2', 'number')
//       const array = hdu.float32array()
//       gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, width, height, 0, gl.LUMINANCE, gl.FLOAT, array)
//       if (ref.order == this.minTileOrder) {
//       gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR)
//       gl.generateMipmap(gl.TEXTURE_2D)
//       }
//     })
//     return tt
//     }
//     private tileId2Url(order: number, index: number) {
//     const dir = Math.floor(index / 10000) * 10000
//     return `${this.baseUrl}/Norder${order}/Dir${dir}/Npix${index}.fits`
//     }
// }
var SimpleImageTextureProvider = /** @class */ (function (_super) {
    __extends(SimpleImageTextureProvider, _super);
    function SimpleImageTextureProvider(globe, baseUrl, properties) {
        var _this = this;
        var maxOrder = Number(properties.hips_order);
        var minOrder = properties.hips_order_min ? Number(properties.hips_order_min) : 3;
        var tileSize = Number(properties.hips_tile_width);
        var coordFrame = (function (cf) {
            switch (cf) {
                case 'equatorial': return _1.CoordFrame.EQUATORIAL;
                case 'galactic': return _1.CoordFrame.GALACTIC;
                case 'hsc/zenith':
                case 'zenith':
                    var _a = JSON.parse(properties['hsc/zenith']), a = _a[0], d = _a[1], p = _a[2];
                    return new _1.CoordFrame((0, matrilx_utils_1.izenith3)(a, d, p));
            }
            return _1.CoordFrame.EQUATORIAL;
        })(properties.hips_frame);
        var tileOrder = (0, healpix_1.size2order)(tileSize);
        var format = (function (fs) {
            var f = fs.split(/\s+/)[0];
            return { jpeg: 'jpg' }[f] || f;
        })(properties.hips_tile_format);
        _this = _super.call(this, globe, tileOrder, maxOrder, minOrder, coordFrame) || this;
        _this.baseUrl = baseUrl;
        _this.properties = properties;
        _this.format = format;
        return _this;
    }
    SimpleImageTextureProvider.prototype.makeTileTexture = function (ref) {
        return __awaiter(this, void 0, void 0, function () {
            var url, image, tt, gl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.tileId2Url(ref.order, ref.index);
                        return [4 /*yield*/, (0, image_1.loadImage)(url)];
                    case 1:
                        image = _a.sent();
                        tt = new TileTexture(this);
                        gl = this.globe.gl;
                        tt.bind(function () {
                            void gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
                            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                            void gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 0);
                            if (ref.order === _this.minTileOrder) {
                                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
                                gl.generateMipmap(gl.TEXTURE_2D);
                            }
                        });
                        return [2 /*return*/, tt];
                }
            });
        });
    };
    SimpleImageTextureProvider.prototype.tileId2Url = function (order, index) {
        var dir = Math.floor(index / 10000) * 10000;
        return this.baseUrl + "/Norder" + order + "/Dir" + dir + "/Npix" + index + "." + this.format;
    };
    SimpleImageTextureProvider.fromBaseUrl = function (globe, baseUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var properties;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, properties_1.fetchProperties)(baseUrl)];
                    case 1:
                        properties = _a.sent();
                        return [2 /*return*/, new SimpleImageTextureProvider(globe, baseUrl, properties)];
                }
            });
        });
    };
    return SimpleImageTextureProvider;
}(AsyncTextureProvider));
exports.SimpleImageTextureProvider = SimpleImageTextureProvider;


/***/ }),

/***/ 2997:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BlendMode = exports.Point = exports.Path = exports.JOINT = exports.Renderer = void 0;
var renderer_1 = __webpack_require__(1143);
Object.defineProperty(exports, "Renderer", ({ enumerable: true, get: function () { return renderer_1.Renderer; } }));
Object.defineProperty(exports, "JOINT", ({ enumerable: true, get: function () { return renderer_1.JOINT; } }));
Object.defineProperty(exports, "Path", ({ enumerable: true, get: function () { return renderer_1.Path; } }));
Object.defineProperty(exports, "Point", ({ enumerable: true, get: function () { return renderer_1.Point; } }));
Object.defineProperty(exports, "BlendMode", ({ enumerable: true, get: function () { return renderer_1.BlendMode; } }));


/***/ }),

/***/ 1143:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Renderer = exports.BlendMode = exports.Path = exports.Point = exports.JOINT = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var gl_matrix_1 = __webpack_require__(887);
var JOINT;
(function (JOINT) {
    JOINT[JOINT["MITER"] = 0] = "MITER";
    JOINT[JOINT["NONE"] = 1] = "NONE";
})(JOINT = exports.JOINT || (exports.JOINT = {}));
var Point = /** @class */ (function () {
    function Point(position, color, size) {
        this.position = position;
        this.color = color;
        this.size = size;
    }
    return Point;
}());
exports.Point = Point;
var Path = /** @class */ (function () {
    function Path(points, close, joint) {
        if (joint === void 0) { joint = JOINT.NONE; }
        this.points = points;
        this.close = close;
        this.joint = joint;
    }
    return Path;
}());
exports.Path = Path;
var BlendMode;
(function (BlendMode) {
    BlendMode["NORMAL"] = "NORMAL";
    BlendMode["ADD"] = "ADD";
})(BlendMode = exports.BlendMode || (exports.BlendMode = {}));
var Renderer = /** @class */ (function () {
    function Renderer(gl) {
        this.gl = gl;
        this.darkenNarrowLine = true;
        this.depthTest = false;
        this.stencilTest = false;
        this.minWidth = 4;
        this.alpha = 1;
        this.blendMode = BlendMode.ADD;
        this._paths = [];
        this.alreadyReleased = false;
        this.needsUpdatePaths = false;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(5933)/* ["default"] */ .Z, __webpack_require__(6526)/* ["default"] */ .Z);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_p', nComponents: 3 },
                { name: 'a_a', nComponents: 3 },
                { name: 'a_b', nComponents: 3 },
                { name: 'a_y', nComponents: 1 },
                { name: 'a_width', nComponents: 1 },
                { name: 'a_color', nComponents: 4 },
            ],
        });
    }
    Renderer.prototype.setPaths = function (path) {
        this._paths = path.slice();
        this.needsUpdatePaths = true;
    };
    Renderer.prototype.release = function () {
        this.alreadyReleased = true;
        this.attribList.release();
        this.program.release();
    };
    Renderer.prototype.mMatirx = function () {
        return E;
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        if (this.needsUpdatePaths) {
            this.updateVBO();
            this.needsUpdatePaths = false;
        }
        if (this.attribList.vertexCount === 0) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var camera = view.camera;
        var gl = this.gl;
        var p = this.program;
        p.enableAttribList(this.attribList, function () {
            // @ts-ignore
            p.uniformMatrix4fv({ u_pvmMatrix: gl_matrix_1.mat4.mul(gl_matrix_1.mat4.create(), camera.pv, _this.mMatirx()) });
            p.uniform1f({
                u_alpha: alpha,
                u_fovy: camera.fovy,
                u_aspectRatio: camera.aspectRatio,
                u_minWidth: _this.minWidth / gl.drawingBufferHeight,
            });
            p.uniform1i({ u_darkenNarrowLine: _this.darkenNarrowLine ? 1 : 0 });
            var features = [gl.BLEND];
            var clearBit = 0;
            if (_this.stencilTest) {
                features.push(gl.STENCIL_TEST);
                clearBit |= gl.STENCIL_BUFFER_BIT;
                gl.clearStencil(0);
                gl.stencilFunc(gl.EQUAL, 0, ~0);
                gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
            }
            if (_this.depthTest) {
                features.push(gl.DEPTH_TEST);
                clearBit |= gl.DEPTH_BUFFER_BIT;
            }
            if (clearBit) {
                gl.clear(clearBit);
            }
            gl_wrapper_1.utils.enable(gl, features, function () {
                switch (_this.blendMode) {
                    case BlendMode.ADD:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case BlendMode.NORMAL:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                }
                gl.drawArrays(gl.TRIANGLE_STRIP, 0, _this.attribList.vertexCount);
            });
        });
    };
    Renderer.prototype.updateVBO = function () {
        var attrs = [];
        var paths = this._paths;
        for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
            var path = paths_1[_i];
            switch (path.joint) {
                case JOINT.MITER:
                    path2attrsMiter(attrs, path);
                    break;
                case JOINT.NONE:
                    path2attrsNone(attrs, path);
                    break;
            }
        }
        this.attribList.setData({ array: new Float32Array(attrs) });
    };
    return Renderer;
}());
exports.Renderer = Renderer;
function path2attrsMiter(attrs, path) {
    if (path.points.length < 2) {
        throw new Error('Path must include more than 2 points');
    }
    if (path.close) {
        path.points.unshift(path.points[path.points.length - 1]);
        path.points.push(path.points[1], path.points[2]);
    }
    else {
        // cap ends
        path.points.unshift(__assign(__assign({}, path.points[0]), { position: path.points[0].position.map(function (p, i) { return 2 * p - path.points[1].position[i]; }) }));
        var last_1 = path.points.length - 1;
        path.points.push(__assign(__assign({}, path.points[last_1]), { position: path.points[last_1].position.map(function (p, i) { return 2 * p - path.points[last_1 - 1].position[i]; }) }));
    }
    for (var i = 1; i < path.points.length - 1; ++i) {
        // (a) - (p) - (b)
        var p = path.points[i];
        var a = path.points[i - 1];
        var b = path.points[i + 1];
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], p.position, false), a.position, false), b.position, false), [-1, 0.5 * p.size], false), p.color, false));
        if (i === 1) {
            attrs.push.apply(attrs, attrs.slice(attrs.length - 15));
        }
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], p.position, false), a.position, false), b.position, false), [+1, 0.5 * p.size], false), p.color, false));
    }
    attrs.push.apply(attrs, attrs.slice(attrs.length - 15));
}
function path2attrsNone(attrs, path) {
    if (path.points.length < 2) {
        throw new Error('Path must include more than 2 points');
    }
    if (path.close) {
        path.points.push(path.points[0]);
    }
    var _loop_1 = function (i) {
        var a = path.points[i];
        var b = path.points[i + 1];
        var a2 = [0, 1, 2].map(function (j) { return 2 * a.position[j] - b.position[j]; }); // a + (a - b)
        var b2 = [0, 1, 2].map(function (j) { return 2 * b.position[j] - a.position[j]; }); // b + (b - a)
        attrs.push.apply(// b + (b - a)
        attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], a.position, false), a2, false), b.position, false), [+1, 0.5 * a.size], false), a.color, false));
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], a.position, false), a2, false), b.position, false), [+1, 0.5 * a.size], false), a.color, false));
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], a.position, false), a2, false), b.position, false), [-1, 0.5 * a.size], false), a.color, false));
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], b.position, false), a.position, false), b2, false), [+1, 0.5 * b.size], false), b.color, false));
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], b.position, false), a.position, false), b2, false), [-1, 0.5 * b.size], false), b.color, false));
        attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], b.position, false), a.position, false), b2, false), [-1, 0.5 * b.size], false), b.color, false));
    };
    for (var i = 0; i < path.points.length - 1; ++i) {
        _loop_1(i);
    }
}
var E = gl_matrix_1.mat4.create();


/***/ }),

/***/ 931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PointRenderer = exports.Point = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var Point = /** @class */ (function () {
    function Point(position, color, size) {
        this.position = position;
        this.color = color;
        this.size = size;
    }
    return Point;
}());
exports.Point = Point;
var PointRenderer = /** @class */ (function () {
    function PointRenderer(gl) {
        this.gl = gl;
        this.darkenSmallPoint = true;
        this.minSize = 3;
        this.alpha = 1;
        this._points = [];
        this.needsUpdatePoints = false;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(2957)/* ["default"] */ .Z, __webpack_require__(5071)/* ["default"] */ .Z);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_position', nComponents: 3 },
                { name: 'a_size', nComponents: 1 },
                { name: 'a_color', nComponents: 4 },
            ],
        });
    }
    Object.defineProperty(PointRenderer.prototype, "points", {
        get: function () { return this.points; },
        set: function (points) {
            this._points = points;
            this.needsUpdatePoints = true;
        },
        enumerable: false,
        configurable: true
    });
    PointRenderer.prototype.release = function () {
        this.attribList.release();
        this.program.release();
    };
    PointRenderer.prototype.render = function (view) {
        var _this = this;
        if (this.needsUpdatePoints) {
            this.updateVBO();
            this.needsUpdatePoints = false;
        }
        if (this.attribList.vertexCount === 0) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var camera = view.camera;
        var gl = this.gl;
        var p = this.program;
        p.enableAttribList(this.attribList, function () {
            p.uniformMatrix4fv({ u_pvMatrix: camera.pv });
            p.uniform1f({
                u_alpha: alpha,
                u_fovy: camera.fovy,
                u_bufferHeight: gl.drawingBufferHeight,
                u_minSize: _this.minSize,
            });
            p.uniform1i({ u_darkenSmallPoint: _this.darkenSmallPoint ? 1 : 0 });
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                gl.drawArrays(gl.POINTS, 0, _this.attribList.vertexCount);
            });
        });
    };
    PointRenderer.prototype.updateVBO = function () {
        /*
          { name: 'a_position', nComponents: 3 },
          { name: 'a_size', nComponents: 1 },
          { name: 'a_color', nComponents: 4 },
        */
        var attrs = [];
        var points = this._points;
        for (var _i = 0, points_1 = points; _i < points_1.length; _i++) {
            var p = points_1[_i];
            attrs.push.apply(attrs, __spreadArray(__spreadArray(__spreadArray([], p.position, false), [p.size], false), p.color, false));
        }
        this.attribList.setData({ array: new Float32Array(attrs) });
    };
    PointRenderer.prototype._setArray = function (array) {
        this._points = [];
        this.attribList.setData({ array: new Float32Array(array) });
    };
    return PointRenderer;
}());
exports.PointRenderer = PointRenderer;


/***/ }),

/***/ 6562:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TileTexture = exports.TileRef = exports.TextureProvider = exports.Tract = exports.Renderer = void 0;
var renderer_1 = __webpack_require__(720);
Object.defineProperty(exports, "Renderer", ({ enumerable: true, get: function () { return renderer_1.Renderer; } }));
var tract_1 = __webpack_require__(4156);
Object.defineProperty(exports, "Tract", ({ enumerable: true, get: function () { return tract_1.Tract; } }));
var texture_provider_1 = __webpack_require__(2574);
Object.defineProperty(exports, "TextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.TextureProvider; } }));
Object.defineProperty(exports, "TileRef", ({ enumerable: true, get: function () { return texture_provider_1.TileRef; } }));
Object.defineProperty(exports, "TileTexture", ({ enumerable: true, get: function () { return texture_provider_1.TileTexture; } }));
Object.defineProperty(exports, "AsyncTextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.AsyncTextureProvider; } }));
Object.defineProperty(exports, "SimpleImageTextureProvider", ({ enumerable: true, get: function () { return texture_provider_1.SimpleImageTextureProvider; } }));


/***/ }),

/***/ 720:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tile = exports.TractRenderer = exports.Renderer = void 0;
var cache_map_1 = __webpack_require__(1796);
var gl_wrapper_1 = __webpack_require__(3898);
var gl_matrix_1 = __webpack_require__(887);
var tract_1 = __webpack_require__(4156);
var Renderer = /** @class */ (function () {
    function Renderer(globe, textureProvider) {
        this.globe = globe;
        this.textureProvider = textureProvider;
        this.tileCache = new cache_map_1.CacheMap(1000, function (t) { return t.release(); });
        this.deadTileId = new Set();
        this.alpha = 1;
        this.animationLod = 1;
        this.lodBias = 0;
        this.integerLevel = false;
        this.alreadyReleased = false;
        this.tractRenderers = new Map();
        var gl = globe.gl;
        this.gl = gl;
        this.program = gl_wrapper_1.Program.new(this.gl, __webpack_require__(5835)/* ["default"] */ .Z, __webpack_require__(3846)/* ["default"] */ .Z);
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [{ name: 'a_coord', nComponents: 2 }],
            array: this.buildArray(),
        });
    }
    Renderer.prototype.release = function () {
        this.attribList.release();
        this.program.release();
        this.alreadyReleased = true;
        this.tileCache.clear();
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        var tractCount = 0;
        if (this.alpha <= 0) {
            return 0;
        }
        this.activateProgram(function () {
            tractCount = _this.textureProvider.visibleTracts(view, function (tract) {
                var program = _this.program;
                if (!_this.tractRenderers.has(tract)) {
                    _this.tractRenderers.set(tract, new TractRenderer(_this, tract));
                }
                var r = _this.tractRenderers.get(tract);
                program.uniform1f({ u_layer_alpha: _this.alpha });
                program.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
                r.render(view);
            });
            _this.textureProvider.flushQueue(view.camera.direction);
        });
        return tractCount;
    };
    Renderer.prototype.draw = function () {
        var gl = this.gl;
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
    };
    Renderer.prototype.activateProgram = function (cb) {
        var _a = this, gl = _a.gl, program = _a.program;
        program.use();
        this.attribList.enable(this.program, function () {
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
                gl.activeTexture(gl.TEXTURE0);
                program.uniform1i({ u_texture0: 0 });
                cb();
                gl.bindTexture(gl.TEXTURE_2D, null);
            });
        });
    };
    Renderer.prototype.buildArray = function () {
        var a = [0, 0, 1, 0, 0, 1, 1, 1];
        return new Float32Array(a);
    };
    Renderer.prototype.clearTiles = function () {
        this.tileCache.clear();
        this.deadTileId.clear();
    };
    Renderer.prototype.clearInvisibleTiles = function (view, lodBias) {
        var _this = this;
        if (lodBias === void 0) { lodBias = 1; }
        var integerLevel = this.integerLevel;
        this.integerLevel = true;
        var visibleTileIds = new Set();
        this.textureProvider.visibleTracts(view, function (tract) {
            var tr = _this.tractRenderers.get(tract);
            if (tr) {
                var tiles = tr.visibleTiles(view, _this.lodBias + lodBias).tiles;
                for (var _i = 0, tiles_1 = tiles; _i < tiles_1.length; _i++) {
                    var tile = tiles_1[_i];
                    visibleTileIds.add(tile.id);
                }
            }
        });
        for (var _i = 0, _a = this.tileCache.keys(); _i < _a.length; _i++) {
            var k = _a[_i];
            if (!visibleTileIds.has(k)) {
                this.tileCache.delete(k);
            }
        }
        this.integerLevel = integerLevel;
        this.deadTileId.clear();
    };
    Renderer.prototype.setCacheSize = function (limit) {
        this.tileCache.setLimit(limit);
    };
    return Renderer;
}());
exports.Renderer = Renderer;
var TractRenderer = /** @class */ (function () {
    function TractRenderer(renderer, tract) {
        this.renderer = renderer;
        this.tract = tract;
    }
    TractRenderer.prototype.render = function (view) {
        var tract = this.tract;
        var _a = this.renderer, lodBias = _a.lodBias, animationLod = _a.animationLod;
        var _b = this.visibleTiles(view, lodBias + animationLod * view.lodBias), tiles = _b.tiles, baseLevel = _b.baseLevel, lodAlpha = _b.lodAlpha;
        tiles.sort(function (a, b) { return b.level - a.level; });
        // @ts-ignore
        this.renderer.program.uniformMatrix4fv({ u_mMatrix: tract.mMatrix });
        for (var _i = 0, tiles_2 = tiles; _i < tiles_2.length; _i++) {
            var tile = tiles_2[_i];
            var alpha = !this.renderer.integerLevel && baseLevel === tile.level ? lodAlpha : 1;
            tile.render(alpha);
        }
    };
    TractRenderer.prototype.visibleTiles = function (view, lodBias) {
        var tract = this.tract;
        var tiles = [];
        var done = new Set();
        var _a = tract.tileIndices(view, lodBias), minP = _a.minP, maxP = _a.maxP, minQ = _a.minQ, maxQ = _a.maxQ, baseLevel = _a.baseLevel, lodAlpha = _a.lodAlpha;
        for (var p = minP; p <= maxP; ++p) {
            for (var q = minQ; q <= maxQ; ++q) {
                this.readyTilesFor(baseLevel, p, q, function (tile) {
                    if (!done.has(tile.id)) {
                        tiles.push(tile);
                    }
                    done.add(tile.id);
                });
            }
        }
        return { tiles: tiles, baseLevel: baseLevel, lodAlpha: lodAlpha };
    };
    TractRenderer.prototype.readyTilesFor = function (baseLevel, p, q, cb) {
        var renderer = this.renderer;
        var tract = this.tract;
        var tileCache = renderer.tileCache;
        for (var level = baseLevel; level <= tract.maxTileLevel; ++level) {
            var id = tract.encodeTileId(level, p, q);
            if (renderer.deadTileId.has(id)) {
                return;
            }
            var isRootTile = level === tract.maxTileLevel;
            var tile = tileCache.get(id);
            if (tile) {
                cb(tile);
                tile.tt.needUpdate() && this.requestTile(id, isRootTile, tile);
                if ((renderer.integerLevel || level > baseLevel) && tile.tt.fadeAlpha >= 1) {
                    break;
                }
            }
            else {
                this.requestTile(id, isRootTile);
            }
            p >>= 1;
            q >>= 1;
        }
    };
    TractRenderer.prototype.requestTile = function (id, isRootTile, oldTile) {
        var _this = this;
        var renderer = this.renderer;
        var tp = renderer.textureProvider;
        var priority = oldTile ? oldTile.tt.revision : tp.revision;
        var fetch = tp.fetch(id, priority); // fetch will be undefined if id in tp's queue
        fetch && fetch.then(function (tt) {
            if (renderer.alreadyReleased) {
                tt.release();
            }
            else {
                !oldTile && tt.fadeIn();
                var tile = new Tile(id, tt, renderer);
                renderer.tileCache.set(id, tile, isRootTile);
                _this.renderer.globe.requestRefresh();
            }
        }).catch(function () {
            renderer.deadTileId.add(id);
            _this.renderer.globe.requestRefresh();
        });
    };
    return TractRenderer;
}());
exports.TractRenderer = TractRenderer;
var Tile = /** @class */ (function () {
    // readonly a2mMatrix: mat4
    function Tile(id, tt, renderer) {
        this.id = id;
        this.tt = tt;
        this.renderer = renderer;
        var _a = tract_1.Tract.decodeTileId(id), tract = _a.tract, level = _a.level, p = _a.p, q = _a.q;
        this.level = level;
        var s = tract.tileSize << level;
        var U = (Math.min(((tract.naxis2 >> level) - 1) << level, s * (p + 1)) - s * p) / s;
        var V = (Math.min(((tract.naxis1 >> level) - 1) << level, s * (q + 1)) - s * q) / s;
        this.texMatrix = gl_matrix_1.mat3.fromValues(V, 0, 0, 0, U, 0, 0, 0, 1); // window for texture
        this.tileMatrix = gl_matrix_1.mat3.fromValues(s, 0, 0, 0, s, 0, s * q, s * p, 1);
        // this.a2mMatrix = mat4.mul( // mMatrix * tileMatrix * texMatrix
        //     mat4.create(),
        //     tract.mMatrix,
        //     mat4.fromValues(
        //     V * s, 0, 0, 0,
        //     0, U * s, 0, 0,
        //     0, 0, 1, 0,
        //     q * s, p * s, 0, 1)
        // )
    }
    Tile.prototype.release = function () {
        this.tt.release();
    };
    Tile.prototype.render = function (alpha) {
        var tt = this.tt;
        var renderer = this.renderer;
        var gl = renderer.gl, program = renderer.program;
        gl.bindTexture(gl.TEXTURE_2D, tt.tex.name);
        program.uniform1f({ u_alpha: alpha * this.tt.fadeAlpha });
        // @ts-ignore
        program.uniformMatrix3fv({ u_texMatrix: this.texMatrix, u_tileMatrix: this.tileMatrix });
        renderer.draw();
    };
    return Tile;
}());
exports.Tile = Tile;


/***/ }),

/***/ 2574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TileTexture = exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TileRef = exports.TextureProvider = void 0;
var gl_wrapper_1 = __webpack_require__(3898);
var gl_matrix_1 = __webpack_require__(887);
var image_1 = __webpack_require__(5507);
var math_1 = __webpack_require__(3774);
var time_1 = __webpack_require__(4418);
var tract_1 = __webpack_require__(4156);
var TextureProvider = /** @class */ (function () {
    function TextureProvider(globe) {
        this.globe = globe;
        this.alreadyReleased = false;
        this._revision = 0;
    }
    TextureProvider.prototype.release = function () {
        this.alreadyReleased = true;
    };
    TextureProvider.prototype.visibleTracts = function (view, cb) {
        var fovCenter = view.camera.direction;
        var arc = view.camera.arc;
        var tractCount = 0;
        this.walkTracts(function (tract) {
            if (gl_matrix_1.vec3.sqrDist(fovCenter, tract.refPoint) <= (0, math_1.square)(arc + tract.fov)) {
                ++tractCount;
                cb(tract);
            }
        });
        return tractCount;
    };
    Object.defineProperty(TextureProvider.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        enumerable: false,
        configurable: true
    });
    TextureProvider.prototype.update = function () {
        this._revision++;
    };
    return TextureProvider;
}());
exports.TextureProvider = TextureProvider;
var TileRef = /** @class */ (function () {
    function TileRef(id, priority) {
        this.id = id;
        this.priority = priority;
        var _a = tract_1.Tract.decodeTileId(id), tract = _a.tract, level = _a.level, p = _a.p, q = _a.q;
        this.tract = tract;
        this.level = level;
        this.p = p;
        this.q = q;
        var centerI = ((tract.tileSize << level) * (p + 0.5));
        var centerJ = ((tract.tileSize << level) * (q + 0.5));
        this.center = tract.pixel2xyz(centerJ, centerI);
    }
    return TileRef;
}());
exports.TileRef = TileRef;
var AsyncTextureProvider = /** @class */ (function (_super) {
    __extends(AsyncTextureProvider, _super);
    function AsyncTextureProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nParallel = 2;
        _this.loading = new Set();
        _this.requests = new Map();
        return _this;
    }
    AsyncTextureProvider.prototype.fetch = function (tileId, priority) {
        var _this = this;
        if (this.loading.has(tileId) || this.requests.has(tileId)) {
            return;
        }
        return new Promise(function (resolve, reject) {
            var ref = new TileRef(tileId, priority);
            _this.requests.set(tileId, { ref: ref, resolve: resolve, reject: reject });
        });
    };
    AsyncTextureProvider.prototype.flushQueue = function (center) {
        var _this = this;
        var rs = [];
        this.requests.forEach(function (v) { return rs.push(v); });
        rs.sort(function (a, b) {
            if (a.ref.priority !== b.ref.priority) {
                return a.ref.priority - b.ref.priority;
            }
            if (a.ref.level !== b.ref.level) {
                return b.ref.level - a.ref.level;
            }
            return gl_matrix_1.vec3.sqrDist(a.ref.center, center) - gl_matrix_1.vec3.sqrDist(b.ref.center, center);
        });
        var _loop_1 = function () {
            var _a = rs.shift(), ref = _a.ref, resolve = _a.resolve, reject = _a.reject;
            this_1.loading.add(ref.id);
            this_1.makeTileTexture(ref)
                .then(function (tt) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, time_1.nextAnimationFrame)()];
                    case 1:
                        _a.sent();
                        resolve(tt);
                        return [2 /*return*/];
                }
            }); }); })
                .catch(function (e) { return reject(e); })
                .then(function () {
                _this.loading.delete(ref.id);
                if (_this.loading.size == 0) {
                    _this.globe.ee.emit('imageloadend');
                }
            });
        };
        var this_1 = this;
        while (rs.length > 0 && this.loading.size < this.nParallel) {
            _loop_1();
        }
        this.requests.clear();
    };
    AsyncTextureProvider.prototype.numLoadingImages = function () {
        return this.loading.size;
    };
    return AsyncTextureProvider;
}(TextureProvider));
exports.AsyncTextureProvider = AsyncTextureProvider;
var SimpleImageTextureProvider = /** @class */ (function (_super) {
    __extends(SimpleImageTextureProvider, _super);
    function SimpleImageTextureProvider(globe) {
        return _super.call(this, globe) || this;
    }
    SimpleImageTextureProvider.prototype.makeTileTexture = function (ref) {
        return __awaiter(this, void 0, void 0, function () {
            var url, image, tt, gl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.ref2url(ref);
                        return [4 /*yield*/, (0, image_1.loadImage)(url)];
                    case 1:
                        image = _a.sent();
                        tt = new TileTexture(this);
                        gl = this.globe.gl;
                        tt.bind(function () {
                            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                            if (ref.level === ref.tract.maxTileLevel) {
                                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
                                gl.generateMipmap(gl.TEXTURE_2D);
                            }
                        });
                        return [2 /*return*/, tt];
                }
            });
        });
    };
    return SimpleImageTextureProvider;
}(AsyncTextureProvider));
exports.SimpleImageTextureProvider = SimpleImageTextureProvider;
var TileTexture = /** @class */ (function () {
    function TileTexture(tp) {
        this.tp = tp;
        this.fadeAlpha = 1;
        var gl = tp.globe.gl;
        this.tex = new gl_wrapper_1.Texture(gl);
        this.revision = tp.revision;
    }
    TileTexture.prototype.fadeIn = function () {
        var _this = this;
        this.tp.globe.animation((function (_a) {
            var r = _a.r;
            _this.fadeAlpha = r;
        }), { duration: 200, immediate: true });
    };
    TileTexture.prototype.release = function () {
        this.tex.release();
    };
    TileTexture.prototype.bind = function (cb) {
        this.tex.bind(cb);
    };
    TileTexture.prototype.needUpdate = function () {
        return this.revision < this.tp.revision;
    };
    return TileTexture;
}());
exports.TileTexture = TileTexture;


/***/ }),

/***/ 4156:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tract = void 0;
var angle_1 = __webpack_require__(9565);
var gl_matrix_1 = __webpack_require__(887);
var math_1 = __webpack_require__(3774);
var serial_number_1 = __webpack_require__(320);
var gl_matrix_2 = __webpack_require__(887);
var Tract = /** @class */ (function () {
    function Tract(naxis1, // [pixel]
    naxis2, // [pixel]
    crval1, // [rad]
    crval2, // [rad]
    crpix1, // [pixel]
    crpix2, // [pixel]
    cd, // [rad/pixel]
    options) {
        if (options === void 0) { options = {}; }
        this.naxis1 = naxis1;
        this.naxis2 = naxis2;
        this.crval1 = crval1;
        this.crval2 = crval2;
        this.id = (0, serial_number_1.serialNumber)();
        this.fov = (0, angle_1.deg2rad)(1.8);
        this.tileSize = options.tileSize || 256;
        this.minTileLevel = options.minTileLevel || 0;
        this.maxTileLevel = options.maxTileLevel || 8;
        var m = gl_matrix_1.mat4.create();
        gl_matrix_1.mat4.rotateZ(m, m, crval1);
        gl_matrix_1.mat4.rotateY(m, m, -crval2);
        gl_matrix_1.mat4.mul(m, m, gl_matrix_1.mat4.fromValues(0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1));
        gl_matrix_1.mat4.mul(m, m, [
            cd[0], cd[2], 0, 0,
            cd[1], cd[3], 0, 0,
            0, 0, 1, 0,
            0, 0, 0, 1,
        ]);
        gl_matrix_1.mat4.translate(m, m, [-crpix1, -crpix2, 0]);
        gl_matrix_1.mat4.translate(m, m, [0.5, 0.5, 0]);
        this.flipV = options.flipV || false;
        if (options.flipV) {
            gl_matrix_1.mat4.translate(m, m, [0, naxis2, 0]);
            gl_matrix_1.mat4.scale(m, m, [1, -1, 1]);
        }
        this.mMatrix = m;
        this.invMMatrix = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.mMatrix);
        this.refPoint = angle_1.EquatorialCoord.fromRad(crval1, crval2).xyz;
        this.pixelScale = Math.sqrt(Math.abs(cd[0] * cd[3] - cd[1] * cd[2]));
        Tract.id2tract.set(this.id, this);
    }
    Tract.prototype.pixel2xyz = function (j, i) {
        var v = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), [j, i, 0, 1], this.mMatrix);
        var r = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
        return [v[0] / r, v[1] / r, v[2] / r];
    };
    Tract.prototype.xyz2pixel = function (xyz) {
        var sep = gl_matrix_2.vec3.angle(xyz, this.refPoint);
        var r = 1 / Math.cos(sep);
        var x = xyz[0], y = xyz[1], z = xyz[2];
        var pixel = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), [r * x, r * y, r * z, 1], this.invMMatrix);
        return [pixel[0], pixel[1]];
    };
    Tract.prototype.pix2jacobian = function (x, y) {
        var xyz = this.pixel2xyz(x, y);
        var t = gl_matrix_2.vec3.angle(xyz, this.refPoint);
        return 1 / Math.pow(Math.cos(t), 3);
    };
    Tract.prototype.ndc2pixel = function (view, cb) {
        var b = gl_matrix_1.mat4.mul(gl_matrix_1.mat4.create(), this.invMMatrix, view.camera.iPv);
        //  A = pvMatrix * mMatrix
        //  (x, y, z, w) = A * (pix_x, pix_y, 0, 1)
        //
        //  p = x / w   : ndx
        //  q = y / w   : ndy
        //  r = z / w   : ndz
        //
        //  B = A**-1
        //  (pix_x, pix_y, 0, 1) = B * (x, y, z, w)
        //  => (pix_x, pix_y, 0, 1) = w * B * (p, q, r, 1) <= eq1
        //
        //  row 3 of eq1 => b31*p * b32*q + b33*r + b34 = 0
        //  => r = - (b31*p + b32*q + b34) / b33
        //  row 4 of eq1 => 1 = w * (b41*p + b42*q + b43*r + b44)
        //  => w = 1 / (b41*p + b42*q + b43*r + b44)
        //
        //      b11(0)  b12(4)  b13(8)  b14(12)
        //  B = b21(1)  b22(5)  b23(9)  b24(13)
        //      b31(2)  b32(6)  b33(10) b34(14)
        //      b41(3)  b42(7)  b43(11) b44(15)
        cb(function (p, q) {
            var r = -(b[2] * p + b[6] * q + b[14]) / b[10];
            var w = 1 / ((b[3] * p) + (b[7] * q) + (b[11] * r) + b[15]);
            var v = gl_matrix_1.vec4.fromValues(p, q, r, 1);
            gl_matrix_1.vec4.transformMat4(v, v, b);
            return [w * v[0], w * v[1], w];
        });
    };
    Tract.prototype.tileIndices = function (view, lodBias) {
        // i: vertical raw pixelo axis
        // j: horizontal raw pixel axis
        // p: vertical tile index
        // q: horizontal tile index
        var minJ = Number.POSITIVE_INFINITY;
        var maxJ = Number.NEGATIVE_INFINITY;
        var minI = Number.POSITIVE_INFINITY;
        var maxI = Number.NEGATIVE_INFINITY;
        this.ndc2pixel(view, function (ndc2bpixel) {
            for (var _i = 0, _a = [[-1, -1], [-1, 1], [1, -1], [1, 1]]; _i < _a.length; _i++) {
                var _b = _a[_i], ndx = _b[0], ndy = _b[1];
                var _c = ndc2bpixel(ndx, ndy), j = _c[0], i = _c[1], w = _c[2];
                if (w < 0) {
                    return Tract.noIndex;
                }
                if (j < minJ) {
                    minJ = j;
                }
                if (j > maxJ) {
                    maxJ = j;
                }
                if (i < minI) {
                    minI = i;
                }
                if (i > maxI) {
                    maxI = i;
                }
            }
        });
        if (maxJ < 0 || this.naxis1 < minJ) {
            return Tract.noIndex;
        }
        if (maxI < 0 || this.naxis2 < minI) {
            return Tract.noIndex;
        }
        minJ = Math.max(minJ, 0);
        maxJ = Math.min(maxJ, this.naxis1);
        minI = Math.max(minI, 0);
        maxI = Math.min(maxI, this.naxis2);
        var density = (view.camera.arc / this.pixelScale) / view.drawingBufferHeight; // (raw pixel) / (display pixel)
        var level = (0, math_1.clamp)(Math.log(density) / Math.LN2 + lodBias, this.minTileLevel, this.maxTileLevel);
        var baseLevel = Math.floor(level);
        var lodAlpha = 1 - (level - baseLevel);
        var tileSize = this.tileSize << baseLevel;
        var minP = Math.floor(minI / tileSize);
        var maxP = Math.floor(maxI / tileSize);
        var minQ = Math.floor(minJ / tileSize);
        var maxQ = Math.floor(maxJ / tileSize);
        return { minP: minP, maxP: maxP, minQ: minQ, maxQ: maxQ, baseLevel: baseLevel, lodAlpha: lodAlpha };
    };
    Tract.fromFitsHeader = function (h, options) {
        if (options === void 0) { options = {}; }
        console.assert(h.CTYPE1 === undefined || h.CTYPE1 === 'RA---TAN');
        console.assert(h.CTYPE2 === undefined || h.CTYPE2 === 'DEC--TAN');
        console.assert(h.LONPOLE === undefined);
        console.assert(h.LATPOLE === undefined);
        var tileSize = options.tileSize, minTileLevel = options.minTileLevel, maxTileLevel = options.maxTileLevel, flipV = options.flipV;
        return new Tract(card(h, 'NAXIS1', 'number'), card(h, 'NAXIS2', 'number'), (0, angle_1.deg2rad)(card(h, 'CRVAL1', 'number')), (0, angle_1.deg2rad)(card(h, 'CRVAL2', 'number')), card(h, 'CRPIX1', 'number'), card(h, 'CRPIX2', 'number'), [
            (0, angle_1.deg2rad)(card(h, 'CD1_1', 'number')),
            (0, angle_1.deg2rad)(card(h, 'CD1_2', 'number', 0)),
            (0, angle_1.deg2rad)(card(h, 'CD2_1', 'number', 0)),
            (0, angle_1.deg2rad)(card(h, 'CD2_2', 'number')),
        ], {
            tileSize: tileSize,
            minTileLevel: minTileLevel,
            maxTileLevel: maxTileLevel,
            flipV: flipV,
        });
    };
    Tract.fromId = function (id) {
        return Tract.id2tract.get(id);
    };
    Tract.encodeTileId = function (tract, level, p, q) {
        return tract.id + ":" + level + ":" + p + ":" + q;
    };
    Tract.decodeTileId = function (id) {
        var _a = id.split(':').map(Number), tractId = _a[0], level = _a[1], p = _a[2], q = _a[3];
        var tract = Tract.fromId(tractId);
        return { tract: tract, level: level, p: p, q: q };
    };
    Tract.prototype.encodeTileId = function (level, p, q) {
        return Tract.encodeTileId(this, level, p, q);
    };
    Tract.noIndex = { minP: 0, maxP: -1, minQ: 0, maxQ: -1, baseLevel: -1, lodAlpha: -1 };
    Tract.id2tract = new Map();
    return Tract;
}());
exports.Tract = Tract;
function card(h, key, type, defaultValue) {
    var v = key in h ? h[key] : defaultValue;
    if (typeof v !== type) {
        throw new Error("type mismatch: " + type + " for [" + key + "] = " + v);
    }
    return v;
}


/***/ }),

/***/ 5451:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.get2dContext = void 0;
function get2dContext(width, height, cb) {
    var _a = getCanvas(), canvas = _a.canvas, ctx = _a.ctx;
    canvas.width = width;
    canvas.height = height;
    ctx.save();
    ctx.clearRect(0, 0, width, height);
    var retval = cb(ctx);
    ctx.restore();
    return retval;
}
exports.get2dContext = get2dContext;
var getCanvas = (function () {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    return function () { return ({ canvas: canvas, ctx: ctx }); };
})();


/***/ }),

/***/ 2593:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.elementSize = void 0;
var div = document.createElement('div');
div.style.position = 'fixed';
div.style.visibility = 'hidden';
function elementSize(cb) {
    cb(div);
    document.body.appendChild(div);
    var clientWidth = div.clientWidth, clientHeight = div.clientHeight;
    document.body.removeChild(div);
    return { width: clientWidth, height: clientHeight };
}
exports.elementSize = elementSize;


/***/ }),

/***/ 6692:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.debounce = exports.throttle = void 0;
function throttle(delay, cb) {
    var timer;
    var f = function () {
        if (timer === undefined) {
            timer = setTimeout(function () {
                timer = undefined;
                cb();
            }, delay);
        }
    };
    return f;
}
exports.throttle = throttle;
function debounce(delay, cb) {
    var timer;
    var f = function () {
        if (timer !== undefined) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = undefined;
            cb();
        }, delay);
    };
    return f;
}
exports.debounce = debounce;


/***/ }),

/***/ 5507:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.zeroTexture = exports.loadImage = void 0;
var ImageRequestQueue = /** @class */ (function () {
    function ImageRequestQueue() {
        this.nParallel = 2;
        this.q = [];
        this.running = 0;
    }
    ImageRequestQueue.prototype.push = function (url, failover) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.q.push({ url: url, resolve: resolve, reject: reject, failover: failover });
            _this.consume();
        });
    };
    ImageRequestQueue.prototype.consume = function () {
        var _this = this;
        if (this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                if (_this.q.length > 0 && _this.running < _this.nParallel) {
                    var _a = _this.q.shift(), url = _a.url, resolve_1 = _a.resolve, reject_1 = _a.reject, failover_1 = _a.failover;
                    var img_1 = new Image();
                    img_1.onload = function () {
                        --_this.running;
                        resolve_1(img_1);
                        _this.consume();
                    };
                    img_1.onerror = function (e) {
                        --_this.running;
                        if (failover_1) {
                            resolve_1(failover_1);
                        }
                        else {
                            reject_1(e);
                        }
                        _this.consume();
                    };
                    if (url.match(/^(https?:)?\/\//)) {
                        img_1.crossOrigin = '';
                    }
                    img_1.src = url;
                    ++_this.running;
                }
            });
        }
    };
    return ImageRequestQueue;
}());
var qs = new Map();
function loadImage(url, failover) {
    var host = extractHost(url);
    if (!qs.has(host)) {
        qs.set(host, new ImageRequestQueue());
    }
    var q = qs.get(host);
    return q.push(url, failover);
}
exports.loadImage = loadImage;
function extractHost(url) {
    var m = url.match(/https?:\/\/(.*?)\//);
    return m ? m[1] : '';
}
var ctx = document.createElement('canvas').getContext('2d');
exports.zeroTexture = ctx.createImageData(1, 1);


/***/ }),

/***/ 5928:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serialNumber = exports.loadImage = exports.throttle = exports.debounce = void 0;
var functional_1 = __webpack_require__(6692);
Object.defineProperty(exports, "debounce", ({ enumerable: true, get: function () { return functional_1.debounce; } }));
Object.defineProperty(exports, "throttle", ({ enumerable: true, get: function () { return functional_1.throttle; } }));
var image_1 = __webpack_require__(5507);
Object.defineProperty(exports, "loadImage", ({ enumerable: true, get: function () { return image_1.loadImage; } }));
var serial_number_1 = __webpack_require__(320);
Object.defineProperty(exports, "serialNumber", ({ enumerable: true, get: function () { return serial_number_1.serialNumber; } }));


/***/ }),

/***/ 3774:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.diff = exports.dot = exports.xyz2thetaphi = exports.thetaphi2xyz = exports.square = exports.range = exports.clamp = void 0;
function clamp(x, a, b) {
    return x < a ? a : (x > b ? b : x);
}
exports.clamp = clamp;
function range(start, end) {
    if (end === undefined) {
        end = start;
        start = 0;
    }
    var a = [];
    for (var i = start; i < end; ++i) {
        a.push(i);
    }
    return a;
}
exports.range = range;
function square(x) {
    return x * x;
}
exports.square = square;
function thetaphi2xyz(theta, phi) {
    var ct = Math.cos(theta);
    return [ct * Math.cos(phi), ct * Math.sin(phi), Math.sin(theta)];
}
exports.thetaphi2xyz = thetaphi2xyz;
function xyz2thetaphi(x, y, z) {
    var r2 = x * x + y * y;
    if (r2 === 0) {
        return [z > 0 ? Math.PI / 2 : -Math.PI / 2, 0];
    }
    else {
        var PI2 = 2 * Math.PI;
        var phi = (Math.atan2(y, x) + PI2) % PI2;
        var theta = Math.atan2(z, Math.sqrt(r2));
        return [theta, phi];
    }
}
exports.xyz2thetaphi = xyz2thetaphi;
function dot(a, b) {
    return (a[0] * b[0] +
        a[1] * b[1] +
        a[2] * b[2]);
}
exports.dot = dot;
function diff(a, b) {
    return [
        a[0] - b[0],
        a[1] - b[1],
        a[2] - b[2]
    ];
}
exports.diff = diff;


/***/ }),

/***/ 7312:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mouse = exports.Button = void 0;
var Button;
(function (Button) {
    Button[Button["LEFT"] = 0] = "LEFT";
    Button[Button["RIGHT"] = 1] = "RIGHT";
    Button[Button["MIDDLE"] = 2] = "MIDDLE";
})(Button = exports.Button || (exports.Button = {}));
function button(e) {
    switch (e.button) {
        case 2:
            return Button.RIGHT;
        case 1:
            return Button.MIDDLE;
        default: {
            if (!e.altKey && e.ctrlKey && !e.shiftKey) {
                return Button.RIGHT;
            }
            if (e.altKey && !e.ctrlKey && !e.shiftKey) {
                return Button.MIDDLE;
            }
        }
    }
    return Button.LEFT;
}
exports.mouse = {
    button: button,
    Button: Button,
};


/***/ }),

/***/ 320:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serialNumber = void 0;
var i = 0;
function serialNumber() {
    return ++i;
}
exports.serialNumber = serialNumber;


/***/ }),

/***/ 4363:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.text2imageData = void 0;
var canvas_1 = __webpack_require__(5451);
var dom_1 = __webpack_require__(2593);
function text2imageData(text, font, color, margin) {
    if (font === void 0) { font = '48pt sans-serif'; }
    if (color === void 0) { color = 'rgba(255, 255, 255, 1)'; }
    if (margin === void 0) { margin = 10; }
    var _a = (0, dom_1.elementSize)(function (el) {
        el.style.font = font;
        el.innerText = text;
    }), width = _a.width, height = _a.height;
    width += 2 * margin;
    height += 2 * margin;
    return (0, canvas_1.get2dContext)(width, height, function (ctx) {
        ctx.font = font;
        ctx.textBaseline = 'top';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        for (var _i = 0, _a = [[0.25, 15], [0.5, 10], [0.75, 5]]; _i < _a.length; _i++) {
            var _b = _a[_i], o = _b[0], w = _b[1];
            ctx.strokeStyle = "rgba(0, 0, 0, " + o + ")";
            ctx.lineWidth = w;
            ctx.strokeText(text, margin, margin);
        }
        ctx.fillStyle = color;
        ctx.fillText(text, margin, margin);
        return ctx.getImageData(0, 0, width, height);
    });
}
exports.text2imageData = text2imageData;


/***/ }),

/***/ 4418:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.nextAnimationFrame = exports.sleep = exports.time = void 0;
function time(name, cb) {
    var start = performance.now();
    var result = cb();
    console.log(name + ": " + (performance.now() - start));
    return result;
}
exports.time = time;
function sleep(t) {
    if (t === void 0) { t = 0; }
    return new Promise(function (resolve) { return setTimeout(resolve, t); });
}
exports.sleep = sleep;
exports.nextAnimationFrame = (function () {
    var q = [];
    var rafId;
    return function () { return new Promise(function (resolve) {
        // @ts-ignore
        q.push(resolve);
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                q.forEach(function (r) { return r(); });
                q = [];
            });
        }
    }); };
})();


/***/ }),

/***/ 62:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Camera = void 0;
var gl_matrix_1 = __webpack_require__(887);
var math_1 = __webpack_require__(3774);
var Camera = /** @class */ (function () {
    function Camera(pv) {
        this.pv = pv;
        var b = this.iPv = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), pv) || gl_matrix_1.mat4.create();
        var e = [b[8] / b[11], b[9] / b[11], b[10] / b[11]]; // eye position
        var d = [b[12] - (b[8] * b[15]) / b[11], b[13] - (b[9] * b[15]) / b[11], b[14] - (b[10] * b[15]) / b[11]];
        // |this.direction| == 1 if pv does not have scale matrix in its factors
        var up = [b[4] - (b[7] * b[8]) / b[11], b[5] - (b[7] * b[9]) / b[11], b[6] - (b[7] * b[10]) / b[11]];
        var right = [b[0] - (b[3] * b[8]) / b[11], b[1] - (b[3] * b[9]) / b[11], b[2] - (b[3] * b[10]) / b[11]];
        // @ts-ignore
        var upLen = gl_matrix_1.vec3.len(up);
        // @ts-ignore
        var AR = gl_matrix_1.vec3.len(right) / upLen; // aspect ratio
        var ed = gl_matrix_1.vec3.dot(e, d);
        var fovy = 2 * upLen; // ( / |d| )
        var t = (-ed + Math.sqrt(ed * ed - gl_matrix_1.vec3.sqrLen(e) + 1)); // e + t * d : fovCenter
        var arc = fovy * t;
        this.eyePosition = e;
        this.direction = d;
        this.aspectRatio = AR;
        this.fovy = fovy;
        this.arc = arc;
        this.radius = this.arc * Math.sqrt(1 + AR * AR) / 2;
        this.fovCenter = [e[0] + t * d[0], e[1] + t * d[1], e[2] + t * d[2]];
        this.ed = ed;
    }
    /*
    b11(00) b12(04) b13(08) b14(12)
    b21(01) b22 ...
    ...
    b41(03) b42(07) b43(11) b44(15)
    */
    Camera.prototype.ndc2xyz = function (ndx, ndy, ndz) {
        var b = this.iPv;
        var y4 = 1 / (b[3] * ndx + b[7] * ndy + b[11] * ndz + b[15]);
        var x = gl_matrix_1.vec4.transformMat4([0, 0, 0, 0], [y4 * ndx, y4 * ndy, y4 * ndz, y4], b);
        return [x[0], x[1], x[2]];
    };
    Camera.prototype.ndc2sphereXYZ = function (ndx, ndy, safe, r0) {
        if (safe === void 0) { safe = false; }
        if (r0 === void 0) { r0 = 1; }
        var p = this.ndc2xyz(ndx, ndy, -1);
        var q = this.ndc2xyz(ndx, ndy, 1);
        var s = (0, math_1.diff)(p, q);
        // a t**2 + 2*b*t + c == 0
        var a = (0, math_1.dot)(s, s);
        var b = (0, math_1.dot)(s, q);
        var c = (0, math_1.dot)(q, q) - (r0 * r0);
        var D = b * b - a * c;
        var t = (-b - Math.sqrt(safe ? Math.abs(D) : D)) / a;
        return [
            t * p[0] + (1 - t) * q[0],
            t * p[1] + (1 - t) * q[1],
            t * p[2] + (1 - t) * q[2],
        ];
    };
    return Camera;
}());
exports.Camera = Camera;


/***/ }),

/***/ 5678:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.View = void 0;
var View = /** @class */ (function () {
    function View(camera, lodBias, retina, drawingBufferHeight) {
        this.camera = camera;
        this.lodBias = lodBias;
        this.retina = retina;
        this.drawingBufferHeight = drawingBufferHeight;
    }
    return View;
}());
exports.View = View;


/***/ }),

/***/ 3310:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cameraMatrix = exports.normalizeZenith = exports.izenith3 = exports.zenith3 = exports.CameraMode = exports.composite = void 0;
var gl_matrix_1 = __webpack_require__(887);
function composite(scales, matrices) {
    var m = gl_matrix_1.mat4.fromValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    for (var i = 0; i < scales.length; ++i) {
        gl_matrix_1.mat4.multiplyScalarAndAdd(m, m, matrices[i], scales[i]);
    }
    // @ts-ignore
    return m;
}
exports.composite = composite;
var CameraMode;
(function (CameraMode) {
    CameraMode["GNOMONIC"] = "GNOMONIC";
    CameraMode["STEROGRAPHIC"] = "STEREOGRAPHIC";
    CameraMode["FLOATING_EYE"] = "FLOATING_EYE";
})(CameraMode = exports.CameraMode || (exports.CameraMode = {}));
function zenith4(m, a, d, p) {
    // mat4.rotateZ(m, m, -p)
    // mat4.rotateY(m, m, -(Math.PI / 2 - d))
    // mat4.rotateZ(m, m, -a)
    // return m
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    gl_matrix_1.mat4.mul(m, m, gl_matrix_1.mat4.fromValues(cA * cP * sD - sA * sP, -cA * sD * sP - cP * sA, cA * cD, 0, cA * sP + cP * sA * sD, cA * cP - sA * sD * sP, cD * sA, 0, -cD * cP, cD * sP, sD, 0, 0, 0, 0, 1));
    return m;
}
function zenith3(a, d, p) {
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    return gl_matrix_1.mat3.fromValues(cA * cP * sD - sA * sP, -cA * sD * sP - cP * sA, cA * cD, cA * sP + cP * sA * sD, cA * cP - sA * sD * sP, cD * sA, -cD * cP, cD * sP, sD);
}
exports.zenith3 = zenith3;
function izenith3(a, d, p) {
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    return gl_matrix_1.mat3.fromValues(cA * cP * sD - sA * sP, cA * sP + cP * sA * sD, -cD * cP, -cA * sD * sP - cP * sA, cA * cP - sA * sD * sP, cD * sP, cA * cD, cD * sA, sD);
}
exports.izenith3 = izenith3;
function zenith2adp(m) {
    var d = Math.asin(m[8]);
    var a = Math.atan2(m[5], m[2]);
    var p = Math.atan2(m[7], -m[6]);
    return [a, d, p];
}
function normalizeZenith(a, d, z) {
    return zenith2adp(zenith3(a, d, z));
}
exports.normalizeZenith = normalizeZenith;
function cameraMatrix(p) {
    var out = gl_matrix_1.mat4.create();
    look(out, p);
    zenith4(out, p.za, p.zd, p.zp);
    return out;
}
exports.cameraMatrix = cameraMatrix;
function look(out, p) {
    var fovy = p.fovy;
    var ar = p.aspectRatio;
    var cA = Math.cos(p.phi);
    var sA = Math.sin(p.phi);
    var cD = Math.cos(p.theta);
    var sD = Math.sin(p.theta);
    var sR = Math.sin(p.roll);
    var cR = Math.cos(p.roll);
    switch (p.mode) {
        case CameraMode.GNOMONIC:
            return gl_matrix_1.mat4.set(out, (cA * sD * sR + cR * sA) / (ar * fovy), (-cA * cR * sD + sA * sR) / fovy, 41 * cA * cD / 39, cA * cD, (-cA * cR + sA * sD * sR) / (ar * fovy), -(cA * sR + cR * sA * sD) / fovy, 41 * cD * sA / 39, cD * sA, -cD * sR / (ar * fovy), cD * cR / fovy, 41 * sD / 39, sD, 0, 0, -4 / 39, 0);
        case CameraMode.STEROGRAPHIC:
            return gl_matrix_1.mat4.set(out, 2 * (cA * sD * sR + cR * sA) / (ar * fovy), 2 * (-cA * cR * sD + sA * sR) / fovy, 13 * cA * cD / 11, cA * cD, 
            // tslint:disable-next-line:max-line-length
            2 * (-cA * cR + sA * sD * sR) / (ar * fovy), -(2 * cA * sR + 2 * cR * sA * sD) / fovy, 13 * cD * sA / 11, cD * sA, -2 * cD * sR / (ar * fovy), 2 * cD * cR / fovy, 13 * sD / 11, sD, 0, 0, 7 / 11, 1);
        case CameraMode.FLOATING_EYE:
            return gl_matrix_1.mat4.set(out, 
            // tslint:disable-next-line:max-line-length
            (fovy + 1) * (cA * sD * sR + cR * sA) / (ar * fovy), (fovy + 1) * (-cA * cR * sD + sA * sR) / fovy, 41 * cA * cD / 39, cA * cD, 
            // tslint:disable-next-line:max-line-length
            (fovy + 1) * (-cA * cR + sA * sD * sR) / (ar * fovy), -(fovy + 1) * (cA * sR + cR * sA * sD) / fovy, 41 * cD * sA / 39, cD * sA, -cD * sR * (fovy + 1) / (ar * fovy), cD * cR * (fovy + 1) / fovy, 41 * sD / 39, sD, 0, 0, 41 * fovy / 39 - 20 / 39, fovy);
    }
}


/***/ }),

/***/ 4795:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * EventEmitter v5.2.9 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - https://oli.me.uk/
 * @preserve
 */

;(function (exports) {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    function isValidListener (listener) {
        if (typeof listener === 'function' || listener instanceof RegExp) {
            return true
        } else if (listener && typeof listener === 'object') {
            return isValidListener(listener.listener)
        } else {
            return false
        }
    }

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        if (!isValidListener(listener)) {
            throw new TypeError('listener must be a function');
        }

        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);

                for (i = 0; i < listeners.length; i++) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return EventEmitter;
        }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else {}
}(typeof window !== 'undefined' ? window : this || {}));


/***/ }),

/***/ 6637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = function() {
  return new Worker(__webpack_require__.p + "232996ee3089d4c69449.worker.js");
};

/***/ }),

/***/ 5693:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = function() {
  return new Worker(__webpack_require__.p + "9a8d23ead1b825ef7348.worker.js");
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) scriptUrl = scripts[scripts.length - 1].src
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	__webpack_require__(2880);
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(3607);
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;